import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import CloseIcon from '@mui/icons-material/Close'
import EditIcon from '@mui/icons-material/Edit'
import GridViewIcon from '@mui/icons-material/GridView'
import KitchenIcon from '@mui/icons-material/Kitchen'
import SaveIcon from '@mui/icons-material/Save'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import {
  Box,
  Checkbox,
  Dialog,
  Fab,
  Fade,
  Hidden,
  IconButton,
  Radio,
  Slide,
  Switch,
  Tooltip,
  Typography,
} from '@mui/material'
import clone from 'just-clone'
import { WithSnackbarProps, withSnackbar } from 'notistack'
import { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import * as THREE from 'three'
import {
  MathUtils,
  Matrix4,
  Mesh,
  Object3D,
  PerspectiveCamera,
  Raycaster,
  Scene,
  Vector2,
  Vector3,
  WebGLRenderer,
} from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer'
import { OutlinePass } from 'three/examples/jsm/postprocessing/OutlinePass'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass'
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass'
import { FXAAShader } from 'three/examples/jsm/shaders/FXAAShader'
import { v4 } from 'uuid'
import { CabPropsType } from '../../api/appAPI'
import {
  createCornerHorizontalSheet,
  createDivider,
  createSheet,
  getFivePiecesCornerTwoDoorProps,
  getFivePiecesDoorProps,
  getFivePiecesDrawerProps,
  getNewDoorHoleSizes,
} from '../../classes/3DObjects'
import Hardware from '../../classes/Hardware'
import Item, {
  CornerTwoDoorItemPropsType,
  DoorItemPropsType,
  DrawerItemPropsType,
  FivePiecesDoorItemPropsType,
  FivePiecesDrawerItemPropsType,
  HandleOrientationType,
  ItemPropsType,
  NewDoorItemPropsType,
} from '../../classes/Item'
import LightGroup from '../../classes/LightGroup'
import Material from '../../classes/Material'
import Section, {
  DividerPropsType,
  calculateCornerSectionSize,
  calculateCornerSectionTransform,
  makeSection,
} from '../../classes/Section'
import Selecting from '../../classes/Selecting'
import { saveItemsPropsListInLocalStorage } from '../../common/helpers'
import {
  appConfig,
  ConfigsType,
  doorHingehardwareIds,
  doorPoolY,
  drawerSlideAllHardwareIds,
  drawerSlideProps,
  freedomCategoryId,
  newDoorPullX,
  newHandleConfigs,
} from '../../config'
import {
  CabinetGloablsFromDtool,
  CabinetProps,
  CornerCabinetProps,
  DoorHingeType,
  DoorNewVisualTypes,
  DoorPropsType,
  DoorType,
  DoorVisualType,
  DrawerPropsType,
  DrawerSlideType,
  DrawerVisualType,
  HandlePropsType,
  LegPropsType,
  ShelvesPropsType,
  newDoorVisualTypeValues,
  recalculateAllShelvesAndDoorsPositions,
} from '../../redux/cabinetReducer'
import { CabinetWeightText, showMessage } from '../common/Helpers'
import {
  SectionHeightInfoWithUnitSupport,
  TempSectionHeightInputWithUnitSupport,
  kgToLbs,
} from '../common/UnitComponents'
import CabinetCatalogDialog from './CabinetCatalogDialog'
import SectionActions from './SectionActions'
import { IProps, mapDispatchToProps, mapStateToProps } from './ThreeProps'
import { useWeightUnit } from '../../hooks/useUnit'
import PositionHelper from '../../classes/PositionHelper'

type NewDoorDefaultItemsType = {
  one: {
    B200R203: ItemPropsType
    B200R401: ItemPropsType
    B200R500: ItemPropsType
    B600R102: ItemPropsType
    B600R100: ItemPropsType
    B602R102: ItemPropsType
    B100R000: ItemPropsType
  }
  two: {
    B200R203: ItemPropsType
    B200R401: ItemPropsType
    B200R500: ItemPropsType
    B600R102: ItemPropsType
    B600R100: ItemPropsType
    B602R102: ItemPropsType
    B100R000: ItemPropsType
  }
  liftUp: {
    B200R203: ItemPropsType
    B200R401: ItemPropsType
    B200R500: ItemPropsType
    B600R102: ItemPropsType
    B600R100: ItemPropsType
    B602R102: ItemPropsType
    B100R000: ItemPropsType
  }
  drawer: {
    B200R203: ItemPropsType
    B200R401: ItemPropsType
    B200R500: ItemPropsType
    B600R102: ItemPropsType
    B600R100: ItemPropsType
    B602R102: ItemPropsType
    B100R000: ItemPropsType
  }
  corner: {
    B200R203: ItemPropsType
    B200R401: ItemPropsType
    B200R500: ItemPropsType
    B600R102: ItemPropsType
    B600R100: ItemPropsType
    B602R102: ItemPropsType
    B100R000: ItemPropsType
  }
}

type HandleDefaultItemsType = {
  door: {
    pullStandard: ItemPropsType
    pullArch: ItemPropsType
    pullDPH50476: ItemPropsType
    pullDHP30696: ItemPropsType
    pullDHP306128: ItemPropsType
    pullDHP180128: ItemPropsType
    pullDHP465192: ItemPropsType
    pullDHP305MB96: ItemPropsType
    pullDHP305MB128: ItemPropsType
    pullBP723812: ItemPropsType
    pullBP873128: ItemPropsType
    pullBP7470128: ItemPropsType
    knobDHK301: ItemPropsType
    knobDHK401: ItemPropsType
    knobDHK501: ItemPropsType
    noPull: ItemPropsType
  }
  drawer: {
    pullStandard: ItemPropsType
    pullArch: ItemPropsType
    pullDPH50476: ItemPropsType
    pullDHP30696: ItemPropsType
    pullDHP306128: ItemPropsType
    pullDHP180128: ItemPropsType
    pullDHP465192: ItemPropsType
    pullDHP305MB96: ItemPropsType
    pullDHP305MB128: ItemPropsType
    pullBP723812: ItemPropsType
    pullBP873128: ItemPropsType
    pullBP7470128: ItemPropsType
    knobDHK301: ItemPropsType
    knobDHK401: ItemPropsType
    knobDHK501: ItemPropsType
    noPull: ItemPropsType
  }
}

interface IState {
  modifiableSection: number
  selectedSection: SelectedSection | undefined
  sectionPoses: SectionPos[]
  sectionLocks: SectionLock[]
  tempSection: SectionPos | undefined
  dividersPoses: DividerPos[]
  isCatalogOpen: boolean
  isPreviewOpen: boolean
  ovveridenMaterials: undefined | number[]
}

export type SectionPos = {
  name: string
  top: number
  left: number
  height: number
  panelHeight: number
}

export type SelectedSection = {
  name: string
  top: number
  left: number
  height: number
  y: number
}

export type SectionLock = {
  number: number
  isLock: boolean
}

export type DividerPos = {
  name: string
  rightPos: HtmlPos
  leftPos: HtmlPos
}

export type HtmlPos = {
  top: number
  left: number
}

class Three extends Component<IProps & WithSnackbarProps, IState> {
  state = {
    modifiableSection: 1,
    selectedSection: undefined as SelectedSection | undefined,
    sectionPoses: [] as SectionPos[],
    sectionLocks: [] as SectionLock[],
    tempSection: undefined as SectionPos | undefined,
    dividersPoses: [] as DividerPos[],
    isCatalogOpen: false,
    isPreviewOpen: false,
    ovveridenMaterials: undefined as undefined | number[],
  }

  setSelectedSection = (sec: SelectedSection | undefined) => {
    this.setState({ selectedSection: sec })
  }

  setSectionPoses = (arr: SectionPos[]) => {
    this.setState({ sectionPoses: [...arr] })
  }

  setDividerPoses = (arr: DividerPos[]) => {
    this.setState({ dividersPoses: [...arr] })
  }

  myDiv: any
  frameId: any

  scene = new Scene()
  camera = new PerspectiveCamera(
    75,
    window.innerWidth / window.innerHeight,
    0.1,
    20000
  )
  renderer = new WebGLRenderer({ antialias: true, preserveDrawingBuffer: true })

  positionHelper = new PositionHelper(this.renderer, this.camera)

  raycater = new Raycaster()
  mouse = new Vector2()

  //Controls
  orbit = new OrbitControls(this.camera, this.renderer.domElement)
  isOrbitPaused = false

  setOrbitControl = (value: boolean) => {
    if (value && this.isOrbitPaused) {
      this.orbit.reset()
      this.orbit.enabled = true
      this.isOrbitPaused = false
    } else if (!value) {
      this.orbit.saveState()
      this.orbit.enabled = false
      this.isOrbitPaused = true
    }
  }

  //Post Processing
  composer = new EffectComposer(this.renderer)
  // @ts-ignore
  // outlinePass = new CustomOutlinePass(new Vector2(window.innerWidth * 0.75, window.innerHeight - 88), this.scene, this.camera) as OutlinePass
  outlinePass = new OutlinePass(
    new Vector2(window.innerWidth * 0.75, window.innerHeight - 88),
    this.scene,
    this.camera
  )
  renderPass = new RenderPass(this.scene, this.camera)
  effectFXAA = new ShaderPass(FXAAShader)

  needRender = false
  setNeedRender = (value: boolean) => {
    this.needRender = value
  }

  selecting = new Selecting(
    this.scene,
    this.camera,
    this.renderer,
    this.setOrbitControl,
    this.setNeedRender,
    this.setSelectedSection,
    this.setDividerPoses,
    this.setSectionPoses,
    this.props.setSectionProps,
    this.props.addDividers,
    () =>
      !this.props.isCorner
        ? this.props.cabinetProps.sectionProps.dividersProps
        : this.props.cornerCabinetProps.sectionProps.dividersProps,
    () => this.props.configs
  )

  componentDidMount() {
    window.addEventListener('resize', () => {
      this.props.setWindowSize(window.innerWidth, window.innerHeight)
    })

    this.orbit.addEventListener('change', () => {
      this.needRender = true
    })
    window.addEventListener('mousedown', this.onMouseDown)
    window.addEventListener('keydown', this.onKeyDown)

    this.handleWindowResize(window.innerWidth, window.innerHeight)

    this.myDiv.appendChild(this.renderer.domElement)
    this.start()

    //Don't do it Again!!
    // @ts-ignore
    window.children = this.scene.children
    // @ts-ignore
    window.camera = this.camera
    // @ts-ignore
    window.pass = this.outlinePass
    // @ts-ignore
    window.scene = this.scene
    // @ts-ignore
    window.setNeedRender = this.setNeedRender
    // @ts-ignore
    window.light = this.light
    // @ts-ignore
    window.THREE = THREE
    // @ts-ignore
    window.renderer = this.renderer
    // @ts-ignore
    window.renderScene = this.renderScene
    // @ts-ignore
    window.tthis = this
    // @ts-ignore
    window.THREE = THREE
    // @ts-ignore
    window.orbit = this.orbit
    // @ts-ignore
    window.vPoint = function (x, y, z, r = 0.5) {
      var m = new THREE.Mesh(
        new THREE.SphereGeometry(r, 16, 16),
        new THREE.MeshBasicMaterial({ color: 'red' })
      )
      m.position.set(x, y, z)
      // @ts-ignore
      scene.add(m)
      // @ts-ignore
      setNeedRender(true)
    }
    // window.LightGroup = LightGroup;
    // window.renderer = this.renderer
    // window.light = this.light

    // const hashOfScene = this.props.searchParams.get('h')
    // const cabinetInfo = this.props.searchParams.get('c')
    // const token = this.props.searchParams.get('t')
    // const domain = this.props.searchParams.get('d')

    // if (hashOfScene && token) {
    //     this.props.verifyToken(token, this.props.enqueueSnackbar)
    //     this.props.setGCInfo(hashOfScene, cabinetInfo || '', domain || 'localhost')

    //     if (cabinetInfo) {
    //         const info = JSON.parse(cabinetInfo)
    //         this.loadCabinet(info.name, JSON.parse(info.additional))
    //     }
    // }

    // if (true) {
    if (window.frameElement) {
      console.log('----IFRAME MODE----')
      const cabinetInfo = localStorage.getItem('importCabinetInfo')
      if (cabinetInfo) {
        if (this.props.isFirstLoadIframe) {
          const info = JSON.parse(cabinetInfo)
          const cabGlobals = this.loadCabinet(
            info.name,
            JSON.parse(info.additional)
          )

          this.props.applyCabinetGlobalsFromDtool(cabGlobals)
          this.setState({
            ovveridenMaterials: cabGlobals.ovveridenMaterials as any,
          })
        } else {
          const cabinetInfo = localStorage.getItem('exportCabinetInfo')
          if (cabinetInfo) {
            const info = JSON.parse(cabinetInfo)
            this.loadCabinet(info.name, JSON.parse(info.additional))
          }
        }
      }
      this.props.setIsInIframe(true)
      this.props.setIsFirstLoadIframe(false)
    } else {
      //normal mode
      const cabinetInfo = !this.props.isCorner
        ? localStorage.getItem('normalCabinetInfo')
        : localStorage.getItem('cornerCabinetInfo')
      if (cabinetInfo) {
        const info = JSON.parse(cabinetInfo)
        this.loadCabinet(info.name, JSON.parse(info.additional))
      } else {
        this.loadCabinet(
          !this.props.isCorner
            ? appConfig.startNormalCabinetName
            : appConfig.startCornerCabinetName
        )
      }
    }
  }
  componentWillUnmount() {
    this.stop()
    this.myDiv.removeChild(this.renderer.domElement)
  }

  componentDidUpdate(prevProps: IProps, prevState: IState) {
    if (prevProps.windowSize !== this.props.windowSize) {
      this.handleWindowResize(
        this.props.windowSize.width,
        this.props.windowSize.height
      )
    }
    if (
      (prevProps.itemsPropsList !== this.props.itemsPropsList ||
        prevProps.hardwaresList !== this.props.hardwaresList ||
        prevProps.markups !== this.props.markups ||
        prevProps.materials !== this.props.materials) &&
      this.props.markups.length > 0 &&
      this.props.hardwaresList.length > 0 &&
      this.props.materials.length > 0
    ) {
      saveItemsPropsListInLocalStorage(this.props.itemsPropsList)
      this.visualizeItems(this.props.itemsPropsList)
      this.outlinePass.selectedObjects = this.scene.children.filter((child) =>
        this.props.openItemsName.includes(child.name)
      )
    } else if (prevProps.openItemsName !== this.props.openItemsName) {
      this.outlinePass.selectedObjects = this.scene.children.filter((child) =>
        this.props.openItemsName.includes(child.name)
      )
      // this.outlinePass.selectedObjects = this.props.items.filter(item => this.props.openItemsName.includes(item.name)).map(item => item.object3D)
    } else if (
      prevProps.isFrontPanelsVisible !== this.props.isFrontPanelsVisible
    ) {
      for (const child of this.scene.children) {
        if (child.userData.isDoor || child.userData.isDrawer)
          child.visible = this.props.isFrontPanelsVisible
      }
    } else if (
      (prevProps.cabinetProps.height !== this.props.cabinetProps.height ||
        prevProps.cornerCabinetProps.height !==
          this.props.cornerCabinetProps.height) &&
      this.props.isChangingHeight
    ) {
      if (this.state.sectionLocks.every((lock) => lock.isLock === true)) {
        !this.props.isCorner
          ? this.props.setHeight(
              prevProps.cabinetProps.height,
              this.props.configs.thickness,
              false
            )
          : this.props.setCHeight(
              prevProps.cornerCabinetProps.height,
              this.props.configs.thickness,
              false
            )
      } else {
        let newHeight = !this.props.isCorner
          ? this.props.cabinetProps.height
          : this.props.cornerCabinetProps.height

        if (
          prevProps.cabinetProps.height > this.props.cabinetProps.height ||
          prevProps.cornerCabinetProps.height >
            this.props.cornerCabinetProps.height
        ) {
          const delta = !this.props.isCorner
            ? prevProps.cabinetProps.height - this.props.cabinetProps.height
            : prevProps.cornerCabinetProps.height -
              this.props.cornerCabinetProps.height

          let sumOfNonLockedHeights = 0
          let countOfNonLocked = 0

          for (const lock of this.state.sectionLocks.filter((l) => !l.isLock)) {
            countOfNonLocked++
            sumOfNonLockedHeights +=
              this.state.sectionPoses.find(
                (s) => s.name.split('_')[1] === lock.number.toString()
              )?.height || 0
          }

          if (
            delta > sumOfNonLockedHeights - countOfNonLocked * 5 &&
            sumOfNonLockedHeights !== 0
          ) {
            newHeight =
              (!this.props.isCorner
                ? prevProps.cabinetProps.height
                : prevProps.cornerCabinetProps.height) -
              (sumOfNonLockedHeights - countOfNonLocked * 5)
            !this.props.isCorner
              ? this.props.setHeight(
                  newHeight,
                  this.props.configs.thickness,
                  false
                )
              : this.props.setCHeight(
                  newHeight,
                  this.props.configs.thickness,
                  false
                )
          }
        }

        const newDividers = !this.props.isCorner
          ? this.recalculateDividers(
              this.props.cabinetProps.sectionProps.dividersProps,
              newHeight - prevProps.cabinetProps.height,
              this.state.sectionLocks
            )
          : this.recalculateDividers(
              this.props.cornerCabinetProps.sectionProps.dividersProps,
              newHeight - prevProps.cornerCabinetProps.height,
              this.state.sectionLocks
            )

        const newProps = !this.props.isCorner
          ? recalculateAllShelvesAndDoorsPositions(
              clone(newDividers).sort((a, b) => a.top - b.top),
              this.props.cabinetProps.height,
              this.props.cabinetProps.sectionProps.shelvesProps,
              this.props.cabinetProps.sectionProps.doorsProps,
              this.props.cabinetProps.sectionProps.drawersProps,
              this.props.configs.thickness
            )
          : recalculateAllShelvesAndDoorsPositions(
              clone(newDividers).sort((a, b) => a.top - b.top),
              this.props.cornerCabinetProps.height,
              this.props.cornerCabinetProps.sectionProps.shelvesProps,
              this.props.cornerCabinetProps.sectionProps.doorsProps,
              this.props.cornerCabinetProps.sectionProps.drawersProps,
              this.props.configs.thickness
            )

        // console.log(newDividers, 0)

        this.props.setDividers(newDividers)
        this.props.setShelves(newProps.shelvesProps)
        this.props.setDoors(newProps.doorsProps, 'height change three')
        this.props.setDrawers(newProps.drawersProps)
      }
      this.props.setIsChangingHeight(false)
    } else if (
      prevProps.legProps !== this.props.legProps ||
      prevProps.splittedTop !== this.props.splittedTop ||
      prevProps.doorVisualType !== this.props.doorVisualType ||
      prevProps.panelVisualType !== this.props.panelVisualType ||
      prevProps.baseLegCut !== this.props.baseLegCut ||
      prevProps.drawerSlideType !== this.props.drawerSlideType ||
      prevProps.doorHingeType !== this.props.doorHingeType
    ) {
      this.createCabinet()
    } else if (
      prevProps.actualCabinetCategory !== this.props.actualCabinetCategory
    ) {
      if (this.props.actualCabinetCategory?.id === freedomCategoryId) {
        this.setState({
          sectionLocks: this.state.sectionLocks.map((lock) => ({
            ...lock,
            isLock: false,
          })),
        })
      }
    }
    // else if (
    //     prevProps.cabinetAddonD !== this.props.cabinetAddonD ||
    //     prevProps.cabinetAddonP !== this.props.cabinetAddonP ||
    //     prevProps.microvellumName !== this.props.microvellumName ||
    //     prevProps.actualCabinetCategory !== this.props.actualCabinetCategory
    // ) {
    //     this.saveCabinetInLS('exportCabinetInfo')
    // }

    if (
      prevProps.cornerCabinetProps.type !== this.props.cornerCabinetProps.type
    ) {
      this.scene.userData.isCornerTypeChanged = true
    }

    if (prevProps.cabinetProps !== this.props.cabinetProps) {
      this.createCabinet()

      if (
        prevProps.cabinetProps.sectionProps.dividersProps.length !==
        this.props.cabinetProps.sectionProps.dividersProps.length
      ) {
        //Then divider added or removed
        const prev = prevProps.cabinetProps.sectionProps.dividersProps.map(
          (props) => props.top
        )
        const actual = this.props.cabinetProps.sectionProps.dividersProps.map(
          (props) => props.top
        )

        if (actual.length > prev.length && this.props.isAddingDivider) {
          //Then divider added, change shelves/doors/drawers
          const countOfNewDivider = actual.length - prev.length
          let newTop = undefined as undefined | number

          for (const top of actual) {
            if (!newTop) {
              newTop = prev.includes(top) ? undefined : top
            }
          }

          const index = actual
            .sort((a, b) => a - b)
            .findIndex((top) => top === newTop)

          if (index !== -1) {
            const firstSectionNumber = index + 1

            const newShelves = this.props.cabinetProps.sectionProps.shelvesProps
              .filter((shProps) => shProps.sectionNumber !== firstSectionNumber)
              .map((shProps) => {
                if (shProps.sectionNumber > firstSectionNumber) {
                  shProps.sectionNumber += countOfNewDivider
                }
                return shProps
              })

            const newDoors = this.props.cabinetProps.sectionProps.doorsProps
              .filter((dProps) => dProps.sectionNumber !== firstSectionNumber)
              .map((dProps) => {
                if (dProps.sectionNumber > firstSectionNumber) {
                  dProps.sectionNumber += countOfNewDivider
                }
                return dProps
              })

            const newDrawers = this.props.cabinetProps.sectionProps.drawersProps
              .filter((dProps) => dProps.sectionNumber !== firstSectionNumber)
              .map((dProps) => {
                if (dProps.sectionNumber > firstSectionNumber) {
                  dProps.sectionNumber += countOfNewDivider
                }
                return dProps
              })

            this.props.setDoors(newDoors, 'divider count change three')
            this.props.setDrawers(newDrawers)
            this.props.setShelves(newShelves)
            this.props.setIsAddingDivider(false)
          }
        } else if (actual.length < prev.length) {
          //Then divider removed
          //change shelves/doors/drawers part in DELETE_DIVIDER case of cabinet reducer
        }
      }
    }

    if (
      prevState.sectionPoses !== this.state.sectionPoses &&
      this.state.sectionPoses.length > 0
    ) {
      const newLocks = [] as SectionLock[]

      for (const section of this.state.sectionPoses) {
        newLocks.push({
          number: parseInt(section.name.split('_')[1]),
          isLock: false,
        })
      }

      for (const lock of this.state.sectionLocks) {
        const index = newLocks.findIndex(
          (newLock) => newLock.number === lock.number
        )

        if (index !== -1) newLocks[index].isLock = lock.isLock
      }

      this.setState({ sectionLocks: newLocks })
    }

    if (this.props.configs !== prevProps.configs) {
      this.props.setWidth(
        this.props.cabinetProps.width,
        this.props.configs.thickness
      )
      this.props.setHeight(
        this.props.cabinetProps.height,
        this.props.configs.thickness,
        false
      )

      const cabProps = this.props.isCorner
        ? this.props.cornerCabinetProps
        : this.props.cabinetProps

      const newProps = recalculateAllShelvesAndDoorsPositions(
        cabProps.sectionProps.dividersProps.sort((a, b) => a.top - b.top),
        cabProps.height,
        cabProps.sectionProps.shelvesProps,
        cabProps.sectionProps.doorsProps,
        cabProps.sectionProps.drawersProps,
        this.props.configs.thickness
      )

      this.props.setShelves(newProps.shelvesProps)
      this.props.setDoors(newProps.doorsProps, 'config change htree')
      this.props.setDrawers(newProps.drawersProps)
    }

    if (prevProps.isCorner !== this.props.isCorner) {
      const cabinetInfo = !this.props.isCorner
        ? localStorage.getItem('normalCabinetInfo')
        : localStorage.getItem('cornerCabinetInfo')
      if (cabinetInfo) {
        const info = JSON.parse(cabinetInfo)
        this.loadCabinet(info.name, JSON.parse(info.additional))
      }
    }
    if (prevProps.cornerCabinetProps !== this.props.cornerCabinetProps) {
      this.createCabinet()

      if (
        prevProps.cornerCabinetProps.sectionProps.dividersProps.length !==
        this.props.cornerCabinetProps.sectionProps.dividersProps.length
      ) {
        //Then divider added or removed
        const prev =
          prevProps.cornerCabinetProps.sectionProps.dividersProps.map(
            (props) => props.top
          )
        const actual =
          this.props.cornerCabinetProps.sectionProps.dividersProps.map(
            (props) => props.top
          )

        if (actual.length > prev.length && this.props.isAddingDivider) {
          //Then divider added, change shelves/doors/drawers
          const countOfNewDivider = actual.length - prev.length
          let newTop = undefined as undefined | number

          for (const top of actual) {
            if (!newTop) {
              newTop = prev.includes(top) ? undefined : top
            }
          }

          const index = actual
            .sort((a, b) => a - b)
            .findIndex((top) => top === newTop)

          if (index !== -1) {
            const firstSectionNumber = index + 1

            const newShelves =
              this.props.cornerCabinetProps.sectionProps.shelvesProps
                .filter(
                  (shProps) => shProps.sectionNumber !== firstSectionNumber
                )
                .map((shProps) => {
                  if (shProps.sectionNumber > firstSectionNumber) {
                    shProps.sectionNumber += countOfNewDivider
                  }
                  return shProps
                })

            const newDoors =
              this.props.cornerCabinetProps.sectionProps.doorsProps
                .filter((dProps) => dProps.sectionNumber !== firstSectionNumber)
                .map((dProps) => {
                  if (dProps.sectionNumber > firstSectionNumber) {
                    dProps.sectionNumber += countOfNewDivider
                  }
                  return dProps
                })

            const newDrawers =
              this.props.cornerCabinetProps.sectionProps.drawersProps
                .filter((dProps) => dProps.sectionNumber !== firstSectionNumber)
                .map((dProps) => {
                  if (dProps.sectionNumber > firstSectionNumber) {
                    dProps.sectionNumber += countOfNewDivider
                  }
                  return dProps
                })

            this.props.setDoors(newDoors, 'corner divider count chnage three')
            this.props.setDrawers(newDrawers)
            this.props.setShelves(newShelves)
            this.props.setIsAddingDivider(false)
          }
        } else if (actual.length < prev.length) {
          //Then divider removed
          //change shelves/doors/drawers part in DELETE_DIVIDER case of cabinet reducer
        }
      }
    }

    this.setNeedRender(true)
    this.saveCabinetInLS('exportCabinetInfo')
  }

  getPanelHeight = (
    dividersProps: DividerPropsType[],
    sectionHeight: number,
    sectionNumber: number,
    thickness: number,
    doorConfig: ConfigsType['doorConfig']
  ) => {
    let doorHeight =
      sectionHeight +
      (sectionNumber === 1
        ? dividersProps.length === 0
          ? thickness
          : dividersProps[0].type === 'visible' //if first divider is fixed shelf
            ? thickness * 1.5
            : thickness
        : 0) + //If section is the first
      (sectionNumber === dividersProps.length + 1
        ? dividersProps.length === 0
          ? thickness
          : dividersProps[dividersProps.length - 1].type === 'visible' //if last divider is fixed shelf
            ? thickness * 1.5
            : thickness
        : 0) + //If section is the last
      (sectionNumber !== 1 && sectionNumber !== dividersProps.length + 1
        ? dividersProps[sectionNumber - 2].type === 'visible' //if top divider is fixed shelf
          ? thickness / 2
          : 0
        : 0) + //If section is not first or last
      (sectionNumber !== 1 && sectionNumber !== dividersProps.length + 1
        ? dividersProps[sectionNumber - 1].type === 'visible' //if bottom divider is fixed shelf
          ? thickness / 2
          : 0
        : 0) //If section is not first or last

    const sectionType =
      sectionNumber !== 1
        ? sectionNumber === dividersProps.length + 1
          ? 'last'
          : 'middle'
        : dividersProps.length === 0
          ? 'single'
          : 'first'

    const doorActualHeight =
      doorHeight -
      (sectionType !== 'middle'
        ? sectionType === 'single'
          ? doorConfig.topReveal + doorConfig.bottomReveal
          : sectionType === 'first'
            ? doorConfig.topReveal + doorConfig.horizontalGap / 2 //first
            : doorConfig.bottomReveal + doorConfig.horizontalGap / 2 //last
        : doorConfig.horizontalGap) //middle

    return doorActualHeight
  }

  getDoorHandlePositions = (
    d: DoorPropsType,
    cabinetWidth: number,
    cabinetHeight: number,
    legHeight: number,
    doorHeight: number,
    doorConfig: ConfigsType['doorConfig'],
    handleConfig: ConfigsType['handleConfig'],
    isAngled = false
  ) => {
    const doorWidth =
      cabinetWidth -
      (isAngled ? 0 : doorConfig.leftReveal + doorConfig.rightReveal)

    const isVertical = d.handleProps.orientation === 'vertical'

    let distX = newDoorPullX['standard']
    const distY = doorPoolY

    if (
      d.visualType !== 'vGroove' &&
      d.visualType !== 'shaker_v' &&
      d.visualType !== 'shaker_h'
    ) {
      distX = newDoorPullX[d.visualType]
    }

    let handlePosY = 0
    const isHandlePosYNumber = ![
      'top',
      'center',
      'bottom',
      'fromGround',
    ].includes(d.handleProps.position.toString())

    if (isHandlePosYNumber) {
      handlePosY = d.handleProps.position as number
    } else {
      if (d.handleProps.position === 'top') {
        handlePosY = isVertical ? distY : distX
      } else if (d.handleProps.position === 'bottom') {
        handlePosY =
          doorHeight - (!isVertical || d.type === 'liftUp' ? distX : distY)
      } else if (d.handleProps.position === 'center') {
        handlePosY =
          doorHeight / 2 + (isVertical ? handleConfig.legDist / 2 : 0)
      } else if (d.handleProps.position === 'fromGround') {
        const fromGroundValue =
          d.handleProps.positionFromGroundValue ??
          this.props.configs.handlePositionFromGround
        const handleY = fromGroundValue - legHeight - cabinetHeight / 2
        const doorTopY = d.sectionY + doorHeight / 2

        console.log(
          cabinetHeight,
          legHeight,
          this.props.configs.handlePositionFromGround,
          handleY,
          doorHeight,
          d.sectionY
        )

        handlePosY = doorTopY - handleY + handleConfig.legDist / 2
        // handlePosY =
        //   d.sectionY -
        //   (cabinetHeight / 2 - legHeightFromCabinetBottom) +
        //   doorHeight / 2 +
        //   handleConfig.legDist / 2
      }
    }

    // ? d.handleProps.position.toString()[0]
    // : d.handleProps.position.toString()

    let handlePosX = 0

    const isHandlePosXNumber = !['left', 'center', 'right'].includes(
      d.handleProps.positionX.toString()
    )
    // ? d.handleProps.positionX.toString()[0]
    // : d.handleProps.positionX.toString()

    if (isHandlePosXNumber) {
      handlePosX = d.handleProps.positionX as number
    } else {
      if (d.handleProps.orientation === 'double_horizontal') {
        const distFromEdge = 15
        handlePosX = distFromEdge - handleConfig.legDist / 2
      } else if (d.type === 'double') {
        handlePosX =
          (doorWidth - doorConfig.verticalGap) / 2 -
          (isVertical ? distX : distY)
      } else if (d.handleProps.positionX === 'right') {
        handlePosX = doorWidth - (isVertical ? distX : distY)
      } else if (d.handleProps.positionX === 'left') {
        handlePosX = isVertical ? distX : distY
      } else if (d.handleProps.positionX === 'center') {
        console.log(doorWidth, handleConfig.legDist)
        handlePosX = doorWidth / 2 - (isVertical ? 0 : handleConfig.legDist / 2)
      }
    }

    const yPrefix = isHandlePosYNumber
      ? null
      : (d.handleProps.position as string)[0]
    const yStr = isHandlePosYNumber
      ? handlePosY.toString()
      : yPrefix === 'f'
        ? d.handleProps.positionFromGroundValue !== undefined
          ? 'f' + d.handleProps.positionFromGroundValue.toFixed(2)
          : 'f'
        : yPrefix + handlePosY.toFixed(2)

    return {
      x: isHandlePosXNumber
        ? handlePosX.toString()
        : (d.handleProps.positionX as string)[0] + handlePosX.toFixed(2),
      y: yStr,
    }
  }

  getCorner2DoorHandlePositions = (
    d: DoorPropsType,
    doorHeight: number,
    cabinetHeight: number,
    legHeight: number,
    handleConfig: ConfigsType['handleConfig']
  ) => {
    const isVertical = d.handleProps.orientation === 'vertical'
    let distX = newDoorPullX['standard']
    const distY = doorPoolY

    if (
      d.visualType !== 'vGroove' &&
      d.visualType !== 'shaker_v' &&
      d.visualType !== 'shaker_h'
    ) {
      distX = newDoorPullX[d.visualType]
    }

    let handlePosY = 0
    const isHandlePosYNumber = ![
      'top',
      'center',
      'bottom',
      'fromGround',
    ].includes(d.handleProps.position.toString())

    if (isHandlePosYNumber) {
      handlePosY = d.handleProps.position as number
    } else {
      if (d.handleProps.position === 'top') {
        handlePosY = isVertical ? distY : distX
      } else if (d.handleProps.position === 'bottom') {
        handlePosY =
          doorHeight - (!isVertical || d.type === 'liftUp' ? distX : distY)
      } else if (d.handleProps.position === 'center') {
        handlePosY =
          doorHeight / 2 + (isVertical ? handleConfig.legDist / 2 : 0)
      } else if (d.handleProps.position === 'fromGround') {
        const handleY =
          this.props.configs.handlePositionFromGround -
          legHeight -
          cabinetHeight / 2
        const doorTopY = d.sectionY + doorHeight / 2

        // console.log(
        //   cabinetHeight,
        //   legHeight,
        //   this.props.configs.handlePositionFromGround,
        //   handleY,
        //   doorHeight,
        //   d.sectionY
        // )

        handlePosY = doorTopY - handleY + handleConfig.legDist / 2
        // handlePosY =
        //   d.sectionY -
        //   (cabinetHeight / 2 - legHeightFromCabinetBottom) +
        //   doorHeight / 2 +
        //   handleConfig.legDist / 2
      }
    }

    // ? d.handleProps.position.toString()[0]
    // : d.handleProps.position.toString()

    let handlePosX = 0

    const isHandlePosXNumber = !['left', 'center', 'right'].includes(
      d.handleProps.positionX.toString()
    )
    // ? d.handleProps.positionX.toString()[0]
    // : d.handleProps.positionX.toString()

    if (isHandlePosXNumber) {
      handlePosX = d.handleProps.positionX as number
    } else {
      if (d.handleProps.positionX === 'right') {
        handlePosX = isVertical ? distX : distY
      } else if (d.handleProps.positionX === 'left') {
        handlePosX = isVertical ? distX : distY
      }
    }

    return {
      x: isHandlePosXNumber
        ? handlePosX.toString()
        : (d.handleProps.positionX as string)[0] + handlePosX.toFixed(2),
      y: isHandlePosYNumber
        ? handlePosY.toString()
        : (d.handleProps.position as string)[0] + handlePosY.toFixed(2),
    }
  }

  getDoorY = (
    d: DoorPropsType,
    dividersProps: DividerPropsType[],
    doorHeight: number,
    doorActualHeight: number
  ) => {
    const sectionType =
      d.sectionNumber !== 1
        ? d.sectionNumber === dividersProps.length + 1
          ? 'last'
          : 'middle'
        : dividersProps.length === 0
          ? 'single'
          : 'first'

    const thickness = this.props.configs.thickness

    let doorY =
      d.sectionY +
      (d.sectionNumber === 1
        ? dividersProps.length === 0
          ? 0
          : dividersProps[0].type === 'visible' //if first divider is fixed shelf
            ? thickness / 4
            : thickness / 2
        : 0) + //If section is the first
      (d.sectionNumber === dividersProps.length + 1
        ? dividersProps.length === 0
          ? 0
          : dividersProps[dividersProps.length - 1].type === 'visible' //if last divider is fixed shelf
            ? -thickness / 4
            : -thickness / 2
        : 0) + //If section is the last
      (d.sectionNumber !== 1 && d.sectionNumber !== dividersProps.length + 1
        ? dividersProps[d.sectionNumber - 2].type === 'visible' //if top divider is fixed shelf
          ? thickness / 4
          : 0
        : 0) + //If section is not first or last
      (d.sectionNumber !== 1 && d.sectionNumber !== dividersProps.length + 1
        ? dividersProps[d.sectionNumber - 1].type === 'visible' //if bottom divider is fixed shelf
          ? -thickness / 4
          : 0
        : 0) //If section is not first or last

    if (sectionType === 'first') {
      const deltaY =
        doorHeight / 2 -
        (this.props.configs.doorConfig.topReveal + doorActualHeight / 2)
      doorY += deltaY
    } else if (sectionType === 'last') {
      const deltaY =
        this.props.configs.doorConfig.bottomReveal +
        doorActualHeight / 2 -
        doorHeight / 2
      doorY += deltaY
    }

    return doorY
  }

  getHandleTypeName = (
    type: HandlePropsType['type'],
    subType: HandlePropsType['subtype']
  ) => {
    if (type === 'pull') {
      switch (subType) {
        case 'standard':
          return '0'
        case 'arch':
          return '1'
        case 'DHP465-192':
          return '2'
        case 'DHP306-96':
          return '3'
        case 'DHP180-128':
          return '4'
        case 'DHP504-76':
          return '5'
        case 'DHP305MB96':
          return '8'
        case 'DHP305MB128':
          return '9'
        case 'BP723812':
          return '10'
        case 'BP873128':
          return '11'
        case 'BP7470128':
          return '12'
        case 'DHP306-128':
          return '13'
        default:
          return '0'
      }
    } else if (type === 'knob') {
      if (subType === 'DHK401') return '7'
      else if (subType === 'DHK501') return '14'
      else return '6'
    } else if (type === 'noPull') return '99'

    return '0'
  }

  getHandleTypesFromName = (
    value: string
  ): { type: HandlePropsType['type']; subType: HandlePropsType['subtype'] } => {
    switch (value) {
      case '0':
        return {
          type: 'pull',
          subType: 'standard',
        }
      case '1':
        return {
          type: 'pull',
          subType: 'arch',
        }
      case '2':
        return {
          type: 'pull',
          subType: 'DHP465-192',
        }
      case '3':
        return {
          type: 'pull',
          subType: 'DHP306-96',
        }
      case '4':
        return {
          type: 'pull',
          subType: 'DHP180-128',
        }
      case '5':
        return {
          type: 'pull',
          subType: 'DHP504-76',
        }
      case '6':
        return {
          type: 'knob',
          subType: 'DHK301',
        }
      case '7':
        return {
          type: 'knob',
          subType: 'DHK401',
        }
      case '8':
        return {
          type: 'pull',
          subType: 'DHP305MB96',
        }
      case '9':
        return {
          type: 'pull',
          subType: 'DHP305MB128',
        }
      case '10':
        return {
          type: 'pull',
          subType: 'BP723812',
        }
      case '11':
        return {
          type: 'pull',
          subType: 'BP873128',
        }
      case '12':
        return {
          type: 'pull',
          subType: 'BP7470128',
        }
      case '13':
        return {
          type: 'pull',
          subType: 'DHP306-128',
        }
      case '14':
        return {
          type: 'knob',
          subType: 'DHK501',
        }
      case '99':
        return {
          type: 'noPull',
          subType: undefined,
        }
      default:
        return {
          type: 'pull',
          subType: 'standard',
        }
    }
  }

  getDoorNameFromProps = (
    d: DoorPropsType,
    cabinetWidth: number,
    cabinetHeight: number,
    legHeight: number,
    dividersProps: DividerPropsType[],
    thickness: number,
    doorConfig: ConfigsType['doorConfig'],
    handleConfig: ConfigsType['handleConfig'],
    isAngled = false
  ) => {
    const doorType = d.type === 'liftUp' ? 'lu' : d.type[0]
    const doorHeight = this.getPanelHeight(
      dividersProps,
      d.sectionHeight,
      d.sectionNumber,
      thickness,
      doorConfig
    )
    // console.log(doorHeight, 'doorHeight', d)

    const handlePos = this.getDoorHandlePositions(
      d,
      cabinetWidth,
      cabinetHeight,
      legHeight,
      doorHeight,
      doorConfig,
      handleConfig,
      isAngled
    )

    const handleType = this.getHandleTypeName(
      d.handleProps.type,
      d.handleProps.subtype
    )

    const handleOrientation =
      doorType === 'lu'
        ? d.handleProps.orientation === 'double_horizontal'
          ? 'd'
          : 's'
        : d.handleProps.orientation === 'horizontal'
          ? 'h'
          : 'v'

    const visualType =
      d.visualType === 'vGroove'
        ? '0'
        : d.visualType === 'fivePieces'
          ? '1'
          : d.visualType.startsWith('#')
            ? '2'
            : d.visualType.startsWith('shaker')
              ? '3'
              : ''

    let newDoorInfo = ''

    if (visualType === '2') {
      if (d.visualType === '#B200-R203-S01') {
        newDoorInfo += '0'
      } else if (d.visualType === '#B200-R203-S04') {
        newDoorInfo += '1'
      } else if (d.visualType === '#B200-R401-S01') {
        newDoorInfo += '2'
      } else if (d.visualType === '#B200-R401-S04') {
        newDoorInfo += '3'
      } else if (d.visualType === '#B200-R500-S01') {
        newDoorInfo += '4'
      } else if (d.visualType === '#B200-R500-S04') {
        newDoorInfo += '5'
      } else if (d.visualType === '#B600-R102-S01') {
        newDoorInfo += '6'
      } else if (d.visualType === '#B600-R102-S04') {
        newDoorInfo += '7'
      } else if (d.visualType === '#B600-R100-S01') {
        newDoorInfo += '8'
      } else if (d.visualType === '#B600-R100-S04') {
        newDoorInfo += '9'
      } else if (d.visualType === '#B602-R102-S01') {
        newDoorInfo += '10'
      } else if (d.visualType === '#B602-R102-S04') {
        newDoorInfo += '11'
      } else if (d.visualType === '#B100-R000-S01') {
        newDoorInfo += '12'
      } else if (d.visualType === '#B100-R000-S04') {
        newDoorInfo += '13'
      }

      if (newDoorInfo && d.normalMapSplitter) {
        newDoorInfo += ':' + d.normalMapSplitter
      }
    }

    if (visualType === '1' && d.normalMapSplitter) {
      newDoorInfo = '0:' + d.normalMapSplitter
    }

    if (visualType === '3') {
      newDoorInfo = d.visualType === 'shaker_h' ? '0' : '1'
    }

    let doorName = `${doorType}_${d.sectionNumber}_${handlePos.y},${handlePos.x}_${handleType}_${handleOrientation}%${visualType}`

    if (newDoorInfo) {
      doorName += ':' + newDoorInfo
    }

    return doorName
  }

  get2doorCornerDoorNameFromProps = (
    d: DoorPropsType,
    cabinetHeight: number,
    legHeight: number,
    dividersProps: DividerPropsType[],
    thickness: number,
    doorConfig: ConfigsType['doorConfig'],
    handleConfig: ConfigsType['handleConfig']
  ) => {
    const doorType = d.type === 'liftUp' ? 'lu' : d.type[0]
    const doorHeight = this.getPanelHeight(
      dividersProps,
      d.sectionHeight,
      d.sectionNumber,
      thickness,
      doorConfig
    )
    console.log(doorHeight, 'doorHeight')

    const handlePos = this.getCorner2DoorHandlePositions(
      d,
      doorHeight,
      cabinetHeight,
      legHeight,
      handleConfig
    )

    const handleType = this.getHandleTypeName(
      d.handleProps.type,
      d.handleProps.subtype
    )

    const handleOrientation =
      d.handleProps.orientation === 'horizontal' ? 'h' : 'v'

    const visualType =
      d.visualType === 'vGroove'
        ? '0'
        : d.visualType === 'fivePieces'
          ? '1'
          : d.visualType.startsWith('#')
            ? '2'
            : d.visualType.startsWith('shaker')
              ? '3'
              : ''

    let newDoorInfo = ''

    if (visualType === '2') {
      if (d.visualType === '#B200-R203-S01') {
        newDoorInfo += '0'
      } else if (d.visualType === '#B200-R203-S04') {
        newDoorInfo += '1'
      } else if (d.visualType === '#B200-R401-S01') {
        newDoorInfo += '2'
      } else if (d.visualType === '#B200-R401-S04') {
        newDoorInfo += '3'
      } else if (d.visualType === '#B200-R500-S01') {
        newDoorInfo += '4'
      } else if (d.visualType === '#B200-R500-S04') {
        newDoorInfo += '5'
      } else if (d.visualType === '#B600-R102-S01') {
        newDoorInfo += '6'
      } else if (d.visualType === '#B600-R102-S04') {
        newDoorInfo += '7'
      } else if (d.visualType === '#B600-R100-S01') {
        newDoorInfo += '8'
      } else if (d.visualType === '#B600-R100-S04') {
        newDoorInfo += '9'
      } else if (d.visualType === '#B602-R102-S01') {
        newDoorInfo += '10'
      } else if (d.visualType === '#B602-R102-S04') {
        newDoorInfo += '11'
      } else if (d.visualType === '#B100-R000-S01') {
        newDoorInfo += '12'
      } else if (d.visualType === '#B100-R000-S04') {
        newDoorInfo += '13'
      }

      if (newDoorInfo && d.normalMapSplitter) {
        newDoorInfo += ':' + d.normalMapSplitter
      }
    }

    if (visualType === '1' && d.normalMapSplitter) {
      newDoorInfo = '0:' + d.normalMapSplitter
    }

    if (visualType === '3') {
      newDoorInfo = d.visualType === 'shaker_h' ? '0' : '1'
    }

    let doorName = `${doorType}_${d.sectionNumber}_${handlePos.y},${handlePos.x}_${handleType}_${handleOrientation}%${visualType}`

    if (newDoorInfo) {
      doorName += ':' + newDoorInfo
    }

    return doorName
  }

  getDrawerHandlePositions = (
    d: DrawerPropsType,
    cabinetWidth: number,
    drawerHeight: number,
    doorConfig: ConfigsType['doorConfig'],
    drawerConfig: ConfigsType['drawerConfig'],
    handleConfig: ConfigsType['handleConfig']
  ) => {
    const drawerWidth =
      cabinetWidth - doorConfig.leftReveal - doorConfig.rightReveal

    let handlePosY = 0
    const isHandlePosYNumber = !['forDrawer', 'forDrawerCenter'].includes(
      d.handleProps.position.toString()
    )

    let handleRevalFromTop = drawerConfig.handleRevalFromTop

    if (
      d.visualType &&
      d.visualType !== 'standard' &&
      d.visualType !== 'shaker_v' &&
      d.visualType !== 'shaker_h'
    ) {
      handleRevalFromTop = newDoorPullX[d.visualType]
    }

    if (isHandlePosYNumber) {
      handlePosY = d.handleProps.position as number
    } else {
      if (d.handleProps.position === 'forDrawer') {
        handlePosY = handleRevalFromTop
      } else if (d.handleProps.position === 'forDrawerCenter') {
        handlePosY = drawerHeight / 2
      } else {
        // handlePosY = '0'
      }
    }

    let handlePosX = 0

    // debugger
    const isHandlePosXNumber =
      d.handleProps.positionX &&
      !['left', 'center', 'right'].includes(d.handleProps.positionX.toString())

    if (isHandlePosXNumber) {
      handlePosX = d.handleProps.positionX as number
    } else {
      let distFromEdge = handleConfig.distFromEdge

      if (d.handleProps.orientation === 'double_horizontal') {
        const distFromEdge = 15
        handlePosX = distFromEdge - handleConfig.legDist / 2
      } else if (d.handleProps.positionX === 'right') {
        handlePosX = drawerWidth - distFromEdge
      } else if (d.handleProps.positionX === 'left') {
        handlePosX = distFromEdge
      } else if (d.handleProps.positionX === 'center') {
        handlePosX = drawerWidth / 2 - handleConfig.legDist / 2
      }
    }

    return {
      x: isHandlePosXNumber
        ? handlePosX.toString()
        : (d.handleProps.positionX as string)[0] + handlePosX.toFixed(2),
      y: isHandlePosYNumber
        ? handlePosY.toString()
        : (d.handleProps.position === 'forDrawerCenter' ? 'c' : 't') +
          handlePosY.toFixed(2),
    }
  }

  getDrawerNameFromProps = (
    d: DrawerPropsType,
    cabinetWidth: number,
    dividersProps: DividerPropsType[],
    thickness: number,
    doorConfig: ConfigsType['doorConfig'],
    drawerConfig: ConfigsType['drawerConfig'],
    handleConfig: ConfigsType['handleConfig']
  ) => {
    const isDouble = d.handleProps.orientation === 'double_horizontal'

    const drawerHeight = this.getPanelHeight(
      dividersProps,
      d.sectionHeight,
      d.sectionNumber,
      thickness,
      doorConfig
    )

    const handlePos = this.getDrawerHandlePositions(
      d,
      cabinetWidth,
      drawerHeight,
      doorConfig,
      drawerConfig,
      handleConfig
    )

    const handleType = this.getHandleTypeName(
      d.handleProps.type,
      d.handleProps.subtype
    )

    const visualType =
      !d.visualType || d.visualType === 'standard'
        ? '0'
        : d.visualType === 'fivePieces'
          ? '1'
          : d.visualType.startsWith('#')
            ? '2'
            : d.visualType.startsWith('shaker')
              ? '3'
              : ''

    let newDoorInfo = ''

    if (visualType === '2') {
      if (d.visualType === '#B200-R203-S01') {
        newDoorInfo += '0'
      } else if (d.visualType === '#B200-R203-S04') {
        newDoorInfo += '1'
      } else if (d.visualType === '#B200-R401-S01') {
        newDoorInfo += '2'
      } else if (d.visualType === '#B200-R401-S04') {
        newDoorInfo += '3'
      } else if (d.visualType === '#B200-R500-S01') {
        newDoorInfo += '4'
      } else if (d.visualType === '#B200-R500-S04') {
        newDoorInfo += '5'
      } else if (d.visualType === '#B600-R102-S01') {
        newDoorInfo += '6'
      } else if (d.visualType === '#B600-R102-S04') {
        newDoorInfo += '7'
      } else if (d.visualType === '#B600-R100-S01') {
        newDoorInfo += '8'
      } else if (d.visualType === '#B600-R100-S04') {
        newDoorInfo += '9'
      } else if (d.visualType === '#B602-R102-S01') {
        newDoorInfo += '10'
      } else if (d.visualType === '#B602-R102-S04') {
        newDoorInfo += '11'
      } else if (d.visualType === '#B100-R000-S01') {
        newDoorInfo += '12'
      } else if (d.visualType === '#B100-R000-S04') {
        newDoorInfo += '13'
      }
    }

    if (visualType === '3') {
      newDoorInfo = d.visualType === 'shaker_h' ? '0' : '1'
    }

    let drawerName = `${d.sectionNumber}_${handleType}_${handlePos.y},${
      handlePos.x
    }_${isDouble ? 'd' : 's'}%${visualType}`

    if (newDoorInfo) {
      drawerName += ':' + newDoorInfo
    }

    return drawerName
  }

  getDoorHingeName = () => {
    return '@' + (this.props.doorHingeType === 'soft' ? 1 : 0)
  }

  getDrawerSlideName = () => {
    return (
      '@' +
      (this.props.drawerSlideType === 'under_mount'
        ? 2
        : this.props.drawerSlideType === 'soft'
          ? 1
          : 0)
    )
  }

  saveCabinetInLS = (propName = 'cabinet', isCorner = this.props.isCorner) => {
    const addItionalItem = this.props.itemsPropsList.find(
      (i) => i.name === 'Additional Item'
    )

    const importCabinetInfo = localStorage.getItem('importCabinetInfo')
      ? JSON.parse(localStorage.getItem('importCabinetInfo') || '')
      : undefined
    const materialInfo = importCabinetInfo?.name.split('|')[8] || '0_0'

    const legProps = this.props.legProps
    const cabinetType = this.props.cabinetType.startsWith('u')
      ? this.props.cabinetType === 'upperOpen'
        ? 'uo'
        : 'u'
      : this.props.cabinetType[0]
    localStorage.setItem(
      propName,
      JSON.stringify({
        name: !isCorner
          ? `0|${cabinetType}|${parseFloat(
              this.props.cabinetProps.width.toFixed(appConfig.fractionDigits)
            )};${parseFloat(
              this.props.cabinetProps.height.toFixed(appConfig.fractionDigits)
            )};${parseFloat(
              this.props.cabinetProps.depth.toFixed(appConfig.fractionDigits)
            )}|${this.props.cabinetProps.sectionProps.dividersProps
              .map((d) =>
                d.type === 'none'
                  ? 'f' + d.top.toFixed(appConfig.fractionDigits)
                  : 't' + d.top.toFixed(appConfig.fractionDigits)
              )
              .join(';')}|${
              this.props.cabinetProps.sectionProps.doorsProps
                .sort((a, b) => a.sectionNumber - b.sectionNumber)
                .map((d) =>
                  this.getDoorNameFromProps(
                    d,
                    this.props.cabinetProps.width,
                    this.props.cabinetProps.height,
                    this.props.cabinetProps.legHeight,
                    this.props.cabinetProps.sectionProps.dividersProps,
                    this.props.configs.thickness,
                    this.props.configs.doorConfig,
                    this.props.configs.handleConfig
                  )
                )
                .join(';') + this.getDoorHingeName()
            }|${
              this.props.cabinetProps.sectionProps.drawersProps
                .sort((a, b) => a.sectionNumber - b.sectionNumber)
                .map((d) =>
                  this.getDrawerNameFromProps(
                    d,
                    this.props.cabinetProps.width,
                    this.props.cabinetProps.sectionProps.dividersProps,
                    this.props.configs.thickness,
                    this.props.configs.doorConfig,
                    this.props.configs.drawerConfig,
                    this.props.configs.handleConfig
                  )
                )
                .join(';') + this.getDrawerSlideName()
            }|${this.props.cabinetProps.sectionProps.shelvesProps
              .sort((a, b) => a.sectionNumber - b.sectionNumber)
              .map((sh) => '' + sh.sectionNumber + '_' + sh.count)
              .join(';')}|${this.state.sectionLocks
              .map(
                (s) =>
                  (s.number === this.state.modifiableSection ? '*' : '') +
                  (s.isLock ? '1' : '0')
              )
              .join(';')}|${materialInfo}|${
              legProps.type === 'base'
                ? '0_' +
                  (this.props.baseLegCut ??
                    this.props.configs.baseLegConfig.cutLength) +
                  '_0:' +
                  (this.props.legProps.baseSubType === 'old' ? '1' : '0')
                : legProps.type === 'baseIsland'
                  ? '0_' +
                    (this.props.baseLegCut ??
                      this.props.configs.baseLegConfig.cutLength) +
                    '_1:' +
                    (this.props.legProps.baseSubType === 'old' ? '1' : '0')
                  : legProps.type === 'baseIsland2'
                    ? '0_' +
                      (this.props.baseLegCut ??
                        this.props.configs.baseLegConfig.cutLength) +
                      '_2:' +
                      (this.props.legProps.baseSubType === 'old' ? '1' : '0')
                    : legProps.type === 'noToeKick'
                      ? '1'
                      : legProps.type === 'standard'
                        ? '2'
                        : legProps.type === 'standard2_1'
                          ? '4_1'
                          : legProps.type === 'standard2_2'
                            ? '4_2'
                            : legProps.type === 'noLeg'
                              ? '9'
                              : '3'
            }|${this.props.cabinetProps.legHeight}|${
              this.props.cabinetAddonD
            }_${this.props.cabinetAddonP}${
              this.props.actualCabinetCategory
                ? '$' + this.props.actualCabinetCategory.id
                : ''
            }${
              this.props.microvellumName !== ''
                ? '#' + this.props.microvellumName
                : ''
            }`
          : `${this.props.cornerCabinetProps.type === 'angled' ? 1 : 2}|${
              cabinetType
            }|${parseFloat(
              this.props.cornerCabinetProps.height.toFixed(
                appConfig.fractionDigits
              )
            )};${parseFloat(
              this.props.cornerCabinetProps.width1.toFixed(
                appConfig.fractionDigits
              )
            )};${parseFloat(
              this.props.cornerCabinetProps.width2.toFixed(
                appConfig.fractionDigits
              )
            )};${parseFloat(
              this.props.cornerCabinetProps.depth1.toFixed(
                appConfig.fractionDigits
              )
            )};${parseFloat(
              this.props.cornerCabinetProps.depth2.toFixed(
                appConfig.fractionDigits
              )
            )};${parseFloat(
              this.props.cornerCabinetProps.backWidth1.toFixed(
                appConfig.fractionDigits
              )
            )};${parseFloat(
              this.props.cornerCabinetProps.backWidth2.toFixed(
                appConfig.fractionDigits
              )
            )}|${this.props.cornerCabinetProps.sectionProps.dividersProps
              .map((d) =>
                d.type === 'none'
                  ? 'f' + d.top.toFixed(appConfig.fractionDigits)
                  : 't' + d.top.toFixed(appConfig.fractionDigits)
              )
              .join(';')}|${
              this.props.cornerCabinetProps.sectionProps.doorsProps
                .sort((a, b) => a.sectionNumber - b.sectionNumber)
                .map((d) => {
                  if (this.props.cornerCabinetProps.type === 'angled') {
                    const width = calculateCornerSectionSize(
                      this.props.cornerCabinetProps.width1,
                      this.props.cornerCabinetProps.width2,
                      this.props.cornerCabinetProps.depth1,
                      this.props.cornerCabinetProps.depth2,
                      this.props.cornerCabinetProps.thickness
                    )

                    return this.getDoorNameFromProps(
                      d,
                      width,
                      this.props.cornerCabinetProps.height,
                      this.props.cornerCabinetProps.legHeight,
                      this.props.cornerCabinetProps.sectionProps.dividersProps,
                      this.props.configs.thickness,
                      this.props.configs.doorConfig,
                      this.props.configs.handleConfig,
                      true
                    )
                  } else {
                    return this.get2doorCornerDoorNameFromProps(
                      d,
                      this.props.cornerCabinetProps.height,
                      this.props.cornerCabinetProps.legHeight,
                      this.props.cornerCabinetProps.sectionProps.dividersProps,
                      this.props.configs.thickness,
                      this.props.configs.doorConfig,
                      this.props.configs.handleConfig
                    )
                  }
                })
                .join(';') + this.getDrawerSlideName()
            }|${this.props.cornerCabinetProps.sectionProps.drawersProps
              .sort((a, b) => a.sectionNumber - b.sectionNumber)
              .map(
                (d) =>
                  d.sectionNumber.toString() +
                  '_' +
                  this.getHandleTypeName(
                    d.handleProps.type,
                    d.handleProps.subtype
                  )
              )
              .join(
                ';'
              )}|${this.props.cornerCabinetProps.sectionProps.shelvesProps
              .sort((a, b) => a.sectionNumber - b.sectionNumber)
              .map((sh) => '' + sh.sectionNumber + '_' + sh.count)
              .join(';')}|${this.state.sectionLocks
              .map(
                (s) =>
                  (s.number === this.state.modifiableSection ? '*' : '') +
                  (s.isLock ? '1' : '0')
              )
              .join(';')}|${materialInfo}|${
              legProps.type === 'standard2_1'
                ? '4_1'
                : legProps.type === 'standard2_2'
                  ? '4_2'
                  : legProps.type === 'base'
                    ? '0_' +
                      (this.props.baseLegCut ??
                        this.props.configs.baseLegConfig.cutLength) +
                      '_0:' +
                      (this.props.legProps.baseSubType === 'old' ? '1' : '0')
                    : legProps.type === 'baseIsland'
                      ? '0_' +
                        (this.props.baseLegCut ??
                          this.props.configs.baseLegConfig.cutLength) +
                        '_1:' +
                        (this.props.legProps.baseSubType === 'old'
                          ? '1'
                          : '0') +
                        (legProps.subType === 'cornerLeft'
                          ? '_0'
                          : legProps.subType === 'cornerRight'
                            ? '_1'
                            : '')
                      : legProps.type === 'noLeg'
                        ? '9'
                        : '2'
            }|${this.props.cornerCabinetProps.legHeight}|${
              this.props.cabinetAddonD
            }_${this.props.cabinetAddonP}${
              this.props.actualCabinetCategory
                ? '$' + this.props.actualCabinetCategory.id
                : ''
            }${
              this.props.microvellumName !== ''
                ? '#' + this.props.microvellumName
                : ''
            }`,
        additional: JSON.stringify({
          hardwareProps: addItionalItem ? addItionalItem.hardwaresProps : [],
          links: addItionalItem ? addItionalItem.links : [],
        }),
      })
    )
  }

  loadCabinetFromLS = () => {
    const cabinet = localStorage.getItem('cabinet')
      ? JSON.parse(localStorage.getItem('cabinet') || '')
      : undefined

    if (cabinet) {
      this.loadCabinet(cabinet.name, JSON.parse(cabinet.additional))
    }
  }

  validateCabinetName = (name: string) => {
    //0|t|150;191;60.4|t25.95;t126.91;f147.00;f167.10|d_2_c|3;4;5|2_3|2|0_0|0|0|1_10
    const sectionsRightCount = 12
    const props = name.split('|')

    const neededSectionsCount = sectionsRightCount - props.length

    for (let i = 0; i < neededSectionsCount; i++) {
      props.push('')
    }

    if (props[7] === '') {
      //non locked section number default - 1
      props[7] =
        '0' +
        (props[3].split(';').length > 0 ? ';' : '') +
        props[3]
          .split(';')
          .map((d) => '0')
          .join(';')
    }

    if (props[7].length === 1) {
      const modifiableSection = props[7]
      props[7] = modifiableSection === '1' ? '*0' : '0'

      const dividersCount = props[3] === '' ? 0 : props[3].split(';').length
      if (dividersCount > 0) {
        for (let i = 2; i < dividersCount + 2; i++) {
          props[7] += ';' + (i.toString() === modifiableSection ? '*0' : '0')
        }
      }
    }

    if (props[8] === '') {
      //materials ids
      props[8] = '0_0'
    }

    if (props[9] === '') {
      // leg type
      props[9] = '0'
    }

    if (props[10] === '') {
      //leg height
      props[10] = props[1].startsWith('u') ? '0' : '12'
    }

    if (props[11] === '') {
      // addons
      props[11] = '0_0'
    }

    return props.join('|')
  }

  loadCabinet = (
    _name: string,
    additional: { hardwareProps: any[]; links: any[] } = {
      hardwareProps: [],
      links: [],
    }
  ): CabinetGloablsFromDtool => {
    const [__name, microvellumName] = _name.split('#')
    const [name, categoryId] = __name.split('$')
    const props = this.validateCabinetName(name).split('|')

    let drawerSlideType: DrawerSlideType = 'standard'
    let doorHingeType: DoorHingeType = 'standard'

    let panelVisualType = 'vGroove'
    let handleType = 'pull'
    let handleSubType = 'standard'

    const legProps = {
      on: true,
      type: 'base',
    } as LegPropsType

    let legHeight = 0
    let baseLegCut = this.props.configs.baseLegConfig.cutLength

    let ovveridenMaterials: number[] | undefined

    if (props.length === 12) {
      const isCorner = props[0] === '0' ? false : true
      const cornerType = props[0] === '1' ? 'angled' : '2door'
      const type =
        props[1] === 'u'
          ? 'upper'
          : props[1] === 'uo'
            ? 'upperOpen'
            : props[1] === 'b'
              ? 'base'
              : 'tall'
      const splittedTop = type === 'base'

      const dividersProps =
        props[3] === ''
          ? []
          : (props[3].split(';').map((d) => ({
              type: d[0] === 't' ? 'visible' : 'none',
              top: parseFloat(d.slice(1)),
              uuid: MathUtils.generateUUID(),
            })) as DividerPropsType[])

      const [doorPropsStr, doorHingeStr] = props[4].split('@')
      doorHingeType = doorHingeStr === '1' ? 'soft' : 'standard'

      const doorsProps =
        doorPropsStr === ''
          ? []
          : (doorPropsStr.split(';').map((door) => {
              let [d, _visualType] = door.split('%')

              _visualType = _visualType ? _visualType : '0'

              let visualType: DoorVisualType = 'vGroove'
              let splitters = ''

              if (_visualType[0] === '1') {
                visualType = 'fivePieces'
                const [_, __, _splitters] = _visualType.split(':')
                splitters = _splitters || ''
              } else if (_visualType[0] === '2') {
                const [_, newDoorType, _splitters] = _visualType.split(':')

                let newDoorTypeIndex = parseInt(newDoorType)
                newDoorTypeIndex =
                  isNaN(newDoorTypeIndex) || newDoorTypeIndex > 13
                    ? 0
                    : newDoorTypeIndex
                visualType = newDoorVisualTypeValues[newDoorTypeIndex]

                splitters = _splitters || ''
              } else if (_visualType[0] === '3') {
                const [_, direction] = _visualType.split(':')

                visualType = direction === '0' ? 'shaker_h' : 'shaker_v'
              }

              const { type: handleType, subType: handleSubType } =
                this.getHandleTypesFromName(d.split('_')[3] || '')

              let handleOrientation: HandleOrientationType = 'vertical'

              if (d.split('_')[0] === 'lu') {
                handleOrientation =
                  d.split('_').length >= 5
                    ? d.split('_')[4] === 'd'
                      ? 'double_horizontal'
                      : 'horizontal'
                    : 'horizontal'
              } else {
                handleOrientation =
                  d.split('_').length >= 5
                    ? d.split('_')[4] === 'h'
                      ? 'horizontal'
                      : 'vertical'
                    : 'vertical'
              }

              let [handlePosY, handlePosX] = d.split('_')[2].split(',')

              if (!handlePosX) {
                handlePosX =
                  d.split('_')[0] === 'l'
                    ? 'r'
                    : d.split('_')[0] === 'r'
                      ? 'l'
                      : 'c'
              }

              return {
                type:
                  d.split('_')[0] === 'l'
                    ? 'left'
                    : d.split('_')[0] === 'r'
                      ? 'right'
                      : d.split('_')[0] === 'd'
                        ? 'double'
                        : 'liftUp',
                visualType,
                normalMapSplitter: splitters,
                sectionNumber: parseInt(d.split('_')[1]),
                sectionHeight: 0,
                sectionY: 0,
                handleProps: {
                  type: handleType,
                  subtype: handleSubType,
                  position:
                    handlePosY[0] === 't'
                      ? 'top'
                      : handlePosY[0] === 'c'
                        ? 'center'
                        : handlePosY[0] === 'b'
                          ? 'bottom'
                          : handlePosY[0] === 'f'
                            ? 'fromGround'
                            : (parseFloat(
                                handlePosY
                              ) as HandlePropsType['position']),
                  positionFromGroundValue:
                    handlePosY[0] === 'f' && handlePosY.length > 1
                      ? parseFloat(handlePosY.slice(1)) > 0
                        ? parseFloat(handlePosY.slice(1))
                        : undefined
                      : undefined,
                  positionX:
                    handlePosX[0] === 'l'
                      ? 'left'
                      : handlePosX[0] === 'c'
                        ? 'center'
                        : handlePosX[0] === 'r'
                          ? 'right'
                          : (parseFloat(
                              handlePosX
                            ) as HandlePropsType['positionX']),
                  orientation: handleOrientation,
                } as HandlePropsType,
                uuid: MathUtils.generateUUID(),
              }
            }) as DoorPropsType[])

      // console.log(_name, props[4], doorsProps)
      const [drawerPropsStr, drawerSlideStr] = props[5].split('@')
      console.log(
        'drawerSlideStr',
        _name,
        this.validateCabinetName(name),
        props,
        props[5],
        drawerSlideStr
      )
      drawerSlideType =
        drawerSlideStr === '2'
          ? 'under_mount'
          : drawerSlideStr === '1'
            ? 'soft'
            : 'standard'

      const drawersProps =
        drawerPropsStr === ''
          ? []
          : (drawerPropsStr.split(';').map((drawer) => {
              let [d, _visualType] = drawer.split('%')

              _visualType = _visualType ? _visualType : '0'

              let visualType: DrawerVisualType = 'standard'

              if (_visualType[0] === '1') {
                visualType = 'fivePieces'
              } else if (_visualType[0] === '2') {
                const [_, newDoorType] = _visualType.split(':')

                let newDoorTypeIndex = parseInt(newDoorType)
                newDoorTypeIndex =
                  isNaN(newDoorTypeIndex) || newDoorTypeIndex > 13
                    ? 0
                    : newDoorTypeIndex
                visualType = newDoorVisualTypeValues[newDoorTypeIndex]
              } else if (_visualType[0] === '3') {
                const [_, direction] = _visualType.split(':')

                visualType = direction === '0' ? 'shaker_h' : 'shaker_v'
              }

              const { type: handleType, subType: handleSubType } =
                this.getHandleTypesFromName(d.split('_')[1] || '')

              const handleOrientation: HandleOrientationType =
                d.split('_').length >= 3
                  ? d.split('_')[3] === 'd'
                    ? 'double_horizontal'
                    : 'horizontal'
                  : 'horizontal'

              let [handlePosY, handlePosX] =
                d.split('_').length > 2 ? d.split('_')[2].split(',') : ['', '']

              if (!handlePosY) handlePosY = 't'

              if (!handlePosX) handlePosX = 'c'

              return {
                sectionNumber: parseInt(d.split('_')[0]),
                sectionHeight: 0,
                sectionY: 0,
                visualType,
                handleProps: {
                  type: handleType,
                  subtype: handleSubType,
                  orientation: handleOrientation,
                  position:
                    handlePosY[0] === 't'
                      ? 'forDrawer'
                      : handlePosY[0] === 'c'
                        ? 'forDrawerCenter'
                        : parseFloat(handlePosY),
                  positionX:
                    handlePosX[0] === 'l'
                      ? 'left'
                      : handlePosX[0] === 'c'
                        ? 'center'
                        : handlePosX[0] === 'r'
                          ? 'right'
                          : parseFloat(handlePosX),
                } as HandlePropsType,
                uuid: MathUtils.generateUUID(),
              }
            }) as DrawerPropsType[])

      const shelvesProps =
        props[6] === ''
          ? []
          : (props[6].split(';').map((d) => ({
              sectionNumber: parseInt(d.split('_')[0]),
              count: parseInt(d.split('_')[1]),
              sectionHeight: 0,
              sectionY: 0,
            })) as ShelvesPropsType[])

      const sectionLocks = [] as SectionLock[]
      const sectionsInfo = props[7].split(';')
      let modifiableSection = -1

      for (let i = 0; i < sectionsInfo.length; i++) {
        if (sectionsInfo[i][0] === '*') {
          modifiableSection = i + 1
          sectionLocks.push({
            number: i + 1,
            isLock: sectionsInfo[i][1] === '1' ? true : false,
          })
        } else {
          sectionLocks.push({
            number: i + 1,
            isLock: sectionsInfo[i][0] === '1' ? true : false,
          })
        }
      }

      // if (props.length === 11) {
      legProps.on = true
      legProps.type = props[9].startsWith('0')
        ? 'base'
        : props[9] === '1'
          ? 'noToeKick'
          : props[9] === '2'
            ? 'standard'
            : props[9] === '4_1'
              ? 'standard2_1'
              : props[9] === '4_2'
                ? 'standard2_2'
                : props[9] === '9'
                  ? 'noLeg'
                  : 'separateBase'
      legHeight = parseFloat(props[10])

      if (legProps.type === 'base') {
        const [_, cutLength, _subType, islandSubtype] = props[9].split('_')
        baseLegCut = cutLength ? parseFloat(cutLength) : baseLegCut
        const [subType, baseSubtype] = (_subType || '').split(':')

        legProps.baseSubType = baseSubtype === '1' ? 'old' : 'new'

        if (subType === '1') {
          legProps.type = 'baseIsland'
        } else if (subType === '2') {
          legProps.type = 'baseIsland2'
        }

        if (islandSubtype === '0') {
          legProps.subType = 'cornerLeft'
        } else if (islandSubtype === '1') {
          legProps.subType = 'cornerRight'
        }
      }

      legProps.on = type.startsWith('upper') ? false : true
      // console.log(name, doorsProps)

      const thickness = this.props.configs.thickness

      if (!isCorner) {
        const [w, h, d] = props[2].split(';').map((v) => parseFloat(v))
        const newProps = recalculateAllShelvesAndDoorsPositions(
          clone(dividersProps).sort((a, b) => a.top - b.top),
          h,
          shelvesProps,
          doorsProps,
          drawersProps,
          this.props.configs.thickness
        )
        // console.log('bug hunt', newProps)

        const sectionProps = {
          name: 'section',
          width: w - thickness * 2,
          height: h - thickness * 2,
          y: 0,
          dividersProps,
          doorsProps: newProps.doorsProps,
          drawersProps: newProps.drawersProps,
          shelvesProps: newProps.shelvesProps,
        }

        const section = makeSection(sectionProps, thickness)
        this.addSectionToScene(section, d)
        this.setSectionPoses(
          this.selecting.getSectionsPoses(section.width, dividersProps)
        )

        this.props.setCabinet(
          w,
          h,
          d,
          legHeight,
          type,
          splittedTop,
          legProps,
          baseLegCut,
          dividersProps,
          newProps.doorsProps,
          newProps.drawersProps,
          newProps.shelvesProps,
          this.props.configs.thickness
        )
      } else {
        const [h, w1, w2, d1, d2, bw1, bw2] = props[2]
          .split(';')
          .map((v) => parseFloat(v))

        const newProps = recalculateAllShelvesAndDoorsPositions(
          clone(dividersProps).sort((a, b) => a.top - b.top),
          h,
          shelvesProps,
          doorsProps,
          drawersProps,
          this.props.configs.thickness
        )
        // console.log('bug hunt', newProps)

        const sectionProps = {
          name: 'section',
          width: calculateCornerSectionSize(w1, w2, d1, d2, thickness),
          height: h - thickness * 2,
          y: 0,
          dividersProps,
          doorsProps: newProps.doorsProps,
          drawersProps: newProps.drawersProps,
          shelvesProps: newProps.shelvesProps,
        }

        const section = makeSection(sectionProps, thickness)
        this.addSectionToScene(
          section,
          calculateCornerSectionTransform(w1, w2, d1, d2, thickness)
        )
        this.setSectionPoses(
          this.selecting.getSectionsPoses(section.width, dividersProps)
        )

        this.props.setCornerCabinet(
          cornerType,
          h,
          w1,
          w2,
          d1,
          d2,
          bw1,
          bw2,
          legHeight,
          type,
          splittedTop,
          legProps,
          baseLegCut,
          dividersProps,
          newProps.doorsProps,
          newProps.drawersProps,
          newProps.shelvesProps,
          this.props.configs.thickness
        )
      }

      const [cMatId, dMatId] = props[8].split('_').map((v) => parseFloat(v))
      ovveridenMaterials = [cMatId, dMatId]

      const [addonD, addonP] = props[11].split('_').map((n) => parseFloat(n))

      this.setState({ sectionLocks, modifiableSection })
      this.props.setCabinetAddons(addonD, addonP)

      const addItionalItem = this.props.itemsPropsList.find(
        (i) => i.name === 'Additional Item'
      )

      if (addItionalItem) {
        addItionalItem.hardwaresProps = additional.hardwareProps
        addItionalItem.links = additional.links
      }

      this.props.setItemsPropsList(this.props.itemsPropsList)

      this.props.setActualCabinetCategory(
        categoryId
          ? this.props.categoriesList.find((c) => c.id === parseInt(categoryId))
          : undefined
      )
      if (categoryId) this.props.chooseActualCabinetSizes(false)

      this.props.setMicrovellumName(microvellumName ? microvellumName : '')
      console.log(drawerSlideType)
      this.props.setDrawerSlideType(drawerSlideType)
      this.props.setDoorHingeType(doorHingeType)

      if (doorsProps.length > 0) {
        panelVisualType = doorsProps[0].visualType
        handleType = doorsProps[0].handleProps.type
        handleSubType = doorsProps[0].handleProps.subtype || ''
      } else if (drawersProps.length > 0) {
        panelVisualType =
          drawersProps[0].visualType === 'standard'
            ? 'vGroove'
            : (drawersProps[0].visualType as any)
        handleType = drawersProps[0].handleProps.type
        handleSubType = drawersProps[0].handleProps.subtype || ''
      }
    }

    return {
      panelVisualType,
      handleType,
      handleSubType,
      legProps,
      legHeight,
      baseLegCut,
      ovveridenMaterials,
    } as CabinetGloablsFromDtool
  }

  recalculateDividers = (
    dividers: DividerPropsType[],
    deltaHeight: number,
    locks: SectionLock[]
  ) => {
    if (dividers.length === 0) return []

    const lockedSectionNumber = locks.filter(
      (lock) => lock.isLock === true
    ).length

    if (lockedSectionNumber === locks.length) return dividers

    const sectionDeltaHeight =
      deltaHeight / (locks.length - lockedSectionNumber)

    const newDividers = clone(dividers)

    if (!locks[0].isLock) {
      newDividers[0].top += sectionDeltaHeight
    }

    for (let i = 1; i < locks.length - 1; i++) {
      if (locks[i].isLock) {
        newDividers[i].top =
          newDividers[i - 1].top + (dividers[i].top - dividers[i - 1].top)
      } else {
        newDividers[i].top =
          newDividers[i - 1].top +
          (dividers[i].top - dividers[i - 1].top) +
          sectionDeltaHeight
      }
    }

    return newDividers
  }

  deleteCabinetFromScene = (itemsPropsList: ItemPropsType[]) => {
    const removableChildrenNames = [
      'Right Side',
      'Left Side',
      'Right Side Base Leg',
      'Left Side Base Leg',
      'Back',
      'Bottom',
      'Top',
      'Splitted Top',
      'No Toe Kick Front',
      'Base Leg Front',
      'Base Leg Back',
      'Base Leg Front 1',
      'Base Leg Front 2',
      'Front Right Side',
      'Front Right Side Base Leg',
      'Back Right Side',
      'Front Left Side',
      'Front Left Side Base Leg',
      'Back Left Side',
      'Corner Standard Leg Short',
    ]

    const itemPropsTypesNeedToRemove = [
      'door',
      'fivePiecesDoor',
      'newDoor',
      'drawer',
      'fivePiecesDrawer',
      'leg',
      'leg2',
      'separateBase',
      'cornerTwoDoor',
      'cornerTwoDoorFivePieces',
      'cornerNewDoor',
      'cornerLegs',
      'cornerLegs2',
      'cornerOneLeg',
    ]

    for (const itemProps of itemsPropsList) {
      if (
        itemPropsTypesNeedToRemove.includes(itemProps.props.type) &&
        itemProps.render
      )
        removableChildrenNames.push(itemProps.name)
    }

    const removableChildren = []

    for (const child of this.scene.children) {
      if (removableChildrenNames.includes(child.name))
        removableChildren.push(child)
      else if (child.name.slice(0, 5) === 'Shelf') removableChildren.push(child)
      else if (child.name.includes('Fixed Shelf')) removableChildren.push(child)
    }

    for (const child of removableChildren) {
      this.scene.remove(child)
    }
  }

  removeUnusedItems = (itemsPropsList: ItemPropsType[]) => {
    const removableItems = []

    for (const itemProps of itemsPropsList) {
      if (itemProps.name.includes('Fixed Shelf')) removableItems.push(itemProps)
    }

    for (const itemProps of itemsPropsList) {
      if (itemProps.name.slice(0, 5) === 'Shelf') removableItems.push(itemProps)
    }

    for (const itemProps of itemsPropsList) {
      if (
        (itemProps.props.type === 'door' ||
          itemProps.props.type === 'cornerTwoDoor' ||
          itemProps.props.type === 'cornerTwoDoorFivePieces' ||
          itemProps.props.type === 'cornerNewDoor' ||
          itemProps.props.type === 'fivePiecesDoor' ||
          itemProps.props.type === 'newDoor') &&
        itemProps.render
      )
        removableItems.push(itemProps)
    }

    for (const itemProps of itemsPropsList) {
      if (
        (itemProps.props.type === 'drawer' ||
          itemProps.props.type === 'fivePiecesDrawer') &&
        itemProps.render
      )
        removableItems.push(itemProps)
    }

    for (const itemProps of itemsPropsList) {
      if (
        ['leg', 'leg2', 'cornerLegs', 'cornerLegs2', 'cornerOneLeg'].includes(
          itemProps.props.type
        ) &&
        itemProps.render
      )
        removableItems.push(itemProps)
    }

    for (const itemProps of removableItems) {
      const index = itemsPropsList.indexOf(itemProps)
      if (index !== -1) {
        itemsPropsList.splice(index, 1)
      }
    }

    //clear legs
    // let index = itemsPropsList.findIndex(itemProps => (itemProps.props.type === 'leg' && itemProps.props.subType === 'standard' && itemProps.render))
    // if (index !== -1) {
    //     itemsPropsList.splice(index, 1)
    // }

    // index = itemsPropsList.findIndex(itemProps => (itemProps.props.type === 'leg2' && itemProps.props.subType === 'short' && itemProps.render))
    // if (index !== -1) {
    //     itemsPropsList.splice(index, 1)
    // }

    // index = itemsPropsList.findIndex(itemProps => (itemProps.props.type === 'cornerLegs' && itemProps.render))
    // if (index !== -1) {
    //     itemsPropsList.splice(index, 1)
    // }

    // index = itemsPropsList.findIndex(itemProps => (itemProps.props.type === 'cornerLegs2' && itemProps.render))
    // if (index !== -1) {
    //     itemsPropsList.splice(index, 1)
    // }

    let index = itemsPropsList.findIndex(
      (itemProps) => itemProps.props.type === 'separateBase' && itemProps.render
    )
    if (index !== -1) {
      itemsPropsList.splice(index, 1)
    }

    return removableItems
  }

  createCabinet = () => {
    this.deleteCabinetFromScene(this.props.itemsPropsList)
    const removableItems = this.removeUnusedItems(this.props.itemsPropsList)

    const normalCabinetSheetNames = [
      'Right Side',
      'Left Side',
      'Right Side Base Leg',
      'Left Side Base Leg',
      'Splitted Top',
      'No Toe Kick Front',
      'Base Leg Front',
      'Base Leg Back',
      'Standard Legs',
      'Standard Legs 2 Short',
      'Standard Legs 2 Tall',
    ]

    const cornerCabinetSheetNames = [
      'Front Right Side',
      'Front Right Side Base Leg',
      'Back Right Side',
      'Front Left Side',
      'Front Left Side Base Leg',
      'Back Left Side',
      'Corner Standard Legs',
      'Corner Standard Legs 2 Short',
      'Corner Standard Legs 2 Tall',
      'Base Leg Front',
      'Base Leg Front 1',
      'Base Leg Front 2',
    ]

    for (const itemProps of this.props.itemsPropsList) {
      if (normalCabinetSheetNames.includes(itemProps.name))
        itemProps.render = !this.props.isCorner
      else if (cornerCabinetSheetNames.includes(itemProps.name))
        itemProps.render = this.props.isCorner

      if (itemProps.name === 'Bottom' || itemProps.name === 'Top') {
        if (itemProps.props.type === 'cornerHorizontalSheet') {
          itemProps.render = this.props.isCorner
        } else {
          itemProps.render = !this.props.isCorner
        }
      }

      if (itemProps.name.slice(0, 5) === 'Shelf') {
        if (itemProps.props.type === 'cornerHorizontalSheet') {
          itemProps.render = this.props.isCorner
        } else {
          itemProps.render = !this.props.isCorner
        }
      }

      if (itemProps.name.includes('Fixed Shelf')) {
        if (itemProps.props.type === 'cornerHorizontalSheet') {
          itemProps.render = this.props.isCorner
        } else {
          itemProps.render = !this.props.isCorner
        }
      }
    }

    if (!this.props.isCorner) {
      this.createNormalCabinet(
        this.props.cabinetProps,
        this.props.itemsPropsList,
        removableItems
      )
    } else {
      this.createCornerCabinet(
        this.props.cornerCabinetProps,
        this.props.itemsPropsList,
        removableItems
      )
    }
  }

  getNewDoorDefaultItems = (
    itemsPropsList: ItemPropsType[]
  ): NewDoorDefaultItemsType | false => {
    const B200R203One = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorOne' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B200R203'
    )
    const B200R401One = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorOne' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B200R401'
    )
    const B200R500One = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorOne' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B200R500'
    )
    const B600R102One = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorOne' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B600R102'
    )
    const B600R100One = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorOne' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B600R100'
    )
    const B602R102One = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorOne' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B602R102'
    )
    const B100R000One = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorOne' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B100R000'
    )

    const B200R203Two = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorTwo' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B200R203'
    )
    const B200R401Two = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorTwo' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B200R401'
    )
    const B200R500Two = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorTwo' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B200R500'
    )
    const B600R102Two = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorTwo' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B600R102'
    )
    const B600R100Two = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorTwo' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B600R100'
    )
    const B602R102Two = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorTwo' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B602R102'
    )
    const B100R000Two = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorTwo' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B100R000'
    )

    const B200R203LiftUp = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorLiftUp' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B200R203'
    )
    const B200R401LiftUp = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorLiftUp' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B200R401'
    )
    const B200R500LiftUp = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorLiftUp' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B200R500'
    )
    const B600R102LiftUp = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorLiftUp' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B600R102'
    )
    const B600R100LiftUp = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorLiftUp' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B600R100'
    )
    const B602R102LiftUp = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorLiftUp' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B602R102'
    )
    const B100R000LiftUp = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorLiftUp' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B100R000'
    )

    const B200R203Drawer = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorDrawer' &&
        i.props.type === 'drawer' &&
        (i.props.visualType as string) === 'B200R203'
    )
    const B200R401Drawer = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorDrawer' &&
        i.props.type === 'drawer' &&
        (i.props.visualType as string) === 'B200R401'
    )
    const B200R500Drawer = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorDrawer' &&
        i.props.type === 'drawer' &&
        (i.props.visualType as string) === 'B200R500'
    )
    const B600R102Drawer = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorDrawer' &&
        i.props.type === 'drawer' &&
        (i.props.visualType as string) === 'B600R102'
    )
    const B600R100Drawer = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorDrawer' &&
        i.props.type === 'drawer' &&
        (i.props.visualType as string) === 'B600R100'
    )
    const B602R102Drawer = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorDrawer' &&
        i.props.type === 'drawer' &&
        (i.props.visualType as string) === 'B602R102'
    )
    const B100R000Drawer = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorDrawer' &&
        i.props.type === 'drawer' &&
        (i.props.visualType as string) === 'B100R000'
    )

    const B200R203Corner = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorCorner' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B200R203'
    )
    const B200R401Corner = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorCorner' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B200R401'
    )
    const B200R500Corner = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorCorner' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B200R500'
    )
    const B600R102Corner = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorCorner' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B600R102'
    )
    const B600R100Corner = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorCorner' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B600R100'
    )
    const B602R102Corner = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorCorner' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B602R102'
    )
    const B100R000Corner = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorCorner' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B100R000'
    )

    if (
      B200R203One &&
      B200R401One &&
      B200R500One &&
      B600R102One &&
      B600R100One &&
      B602R102One &&
      B100R000One &&
      B200R203Two &&
      B200R401Two &&
      B200R500Two &&
      B600R102Two &&
      B600R100Two &&
      B602R102Two &&
      B100R000Two &&
      B200R203LiftUp &&
      B200R401LiftUp &&
      B200R500LiftUp &&
      B600R102LiftUp &&
      B600R100LiftUp &&
      B602R102LiftUp &&
      B100R000LiftUp &&
      B200R203Drawer &&
      B200R401Drawer &&
      B200R500Drawer &&
      B600R102Drawer &&
      B600R100Drawer &&
      B602R102Drawer &&
      B100R000Drawer &&
      B200R203Corner &&
      B200R401Corner &&
      B200R500Corner &&
      B600R102Corner &&
      B600R100Corner &&
      B602R102Corner &&
      B100R000Corner
    ) {
      B200R203One.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B200R401One.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B200R500One.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B600R102One.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B600R100One.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B602R102One.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B100R000One.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]

      B200R203Two.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B200R401Two.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B200R500Two.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B600R102Two.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B600R100Two.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B602R102Two.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B100R000Two.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]

      B200R203LiftUp.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B200R401LiftUp.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B200R500LiftUp.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B600R102LiftUp.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B600R100LiftUp.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B602R102LiftUp.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B100R000LiftUp.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]

      B200R203Drawer.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B200R401Drawer.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B200R500Drawer.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B600R102Drawer.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B600R100Drawer.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B602R102Drawer.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B100R000Drawer.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]

      B200R203Corner.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B200R401Corner.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B200R500Corner.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B600R102Corner.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B600R100Corner.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B602R102Corner.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B100R000Corner.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]

      B200R203One.childrenProps = []
      B200R401One.childrenProps = []
      B200R500One.childrenProps = []
      B600R102One.childrenProps = []
      B600R100One.childrenProps = []
      B602R102One.childrenProps = []
      B100R000One.childrenProps = []

      B200R203Two.childrenProps = []
      B200R401Two.childrenProps = []
      B200R500Two.childrenProps = []
      B600R102Two.childrenProps = []
      B600R100Two.childrenProps = []
      B602R102Two.childrenProps = []
      B100R000Two.childrenProps = []

      B200R203LiftUp.childrenProps = []
      B200R401LiftUp.childrenProps = []
      B200R500LiftUp.childrenProps = []
      B600R102LiftUp.childrenProps = []
      B600R100LiftUp.childrenProps = []
      B602R102LiftUp.childrenProps = []
      B100R000LiftUp.childrenProps = []

      B200R203Drawer.childrenProps = []
      B200R401Drawer.childrenProps = []
      B200R500Drawer.childrenProps = []
      B600R102Drawer.childrenProps = []
      B600R100Drawer.childrenProps = []
      B602R102Drawer.childrenProps = []
      B100R000Drawer.childrenProps = []

      B200R203Corner.childrenProps = []
      B200R401Corner.childrenProps = []
      B200R500Corner.childrenProps = []
      B600R102Corner.childrenProps = []
      B600R100Corner.childrenProps = []
      B602R102Corner.childrenProps = []
      B100R000Corner.childrenProps = []

      return {
        one: {
          B200R203: B200R203One,
          B200R401: B200R401One,
          B200R500: B200R500One,
          B600R102: B600R102One,
          B600R100: B600R100One,
          B602R102: B602R102One,
          B100R000: B100R000One,
        },
        two: {
          B200R203: B200R203Two,
          B200R401: B200R401Two,
          B200R500: B200R500Two,
          B600R102: B600R102Two,
          B600R100: B600R100Two,
          B602R102: B602R102Two,
          B100R000: B100R000Two,
        },
        liftUp: {
          B200R203: B200R203LiftUp,
          B200R401: B200R401LiftUp,
          B200R500: B200R500LiftUp,
          B600R102: B600R102LiftUp,
          B600R100: B600R100LiftUp,
          B602R102: B602R102LiftUp,
          B100R000: B100R000LiftUp,
        },
        drawer: {
          B200R203: B200R203Drawer,
          B200R401: B200R401Drawer,
          B200R500: B200R500Drawer,
          B600R102: B600R102Drawer,
          B600R100: B600R100Drawer,
          B602R102: B602R102Drawer,
          B100R000: B100R000Drawer,
        },
        corner: {
          B200R203: B200R203Corner,
          B200R401: B200R401Corner,
          B200R500: B200R500Corner,
          B600R102: B600R102Corner,
          B600R100: B600R100Corner,
          B602R102: B602R102Corner,
          B100R000: B100R000Corner,
        },
      }
    } else return false
  }

  chooseNewDoorDefaultItem = (
    items: NewDoorDefaultItemsType,
    visualType: DoorNewVisualTypes,
    doorType: DoorType | 'drawer' | 'cornerTwoDoor'
  ): ItemPropsType => {
    const [B, R, S] = visualType.slice(1).split('-')

    if (doorType === 'double') {
      // @ts-ignore
      return items.two[B + R]
    }

    if (doorType === 'liftUp') {
      // @ts-ignore
      return items.liftUp[B + R]
    }

    if (doorType === 'drawer') {
      // @ts-ignore
      return items.drawer[B + R]
    }

    if (doorType === 'cornerTwoDoor') {
      // @ts-ignore
      return items.corner[B + R]
    }

    // @ts-ignore
    return items.one[B + R]
  }

  getHandleDefaultItems = (
    itemsPropsList: ItemPropsType[]
  ): HandleDefaultItemsType | false => {
    const pullStandardDoor = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'standard' &&
        i.props.for === 'door'
    )

    const pullStandardDrawer = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'standard' &&
        i.props.for === 'drawer'
    )

    const pullArchDoor = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'arch' &&
        i.props.for === 'door'
    )

    const pullArchDrawer = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'arch' &&
        i.props.for === 'drawer'
    )

    const pullDPH50476Door = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'DHP504-76' &&
        i.props.for === 'door'
    )

    const pullDPH50476Drawer = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'DHP504-76' &&
        i.props.for === 'drawer'
    )

    const pullDHP30696Door = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'DHP306-96' &&
        i.props.for === 'door'
    )

    const pullDHP30696Drawer = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'DHP306-96' &&
        i.props.for === 'drawer'
    )

    const pullDHP306128Door = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'DHP306-128' &&
        i.props.for === 'door'
    )

    const pullDHP306128Drawer = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'DHP306-128' &&
        i.props.for === 'drawer'
    )

    const pullDHP180128Door = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'DHP180-128' &&
        i.props.for === 'door'
    )

    const pullDHP180128Drawer = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'DHP180-128' &&
        i.props.for === 'drawer'
    )

    const pullDHP465192Door = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'DHP465-192' &&
        i.props.for === 'door'
    )

    const pullDHP305MB96Door = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'DHP305MB96' &&
        i.props.for === 'door'
    )

    const pullDHP305MB96Drawer = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'DHP305MB96' &&
        i.props.for === 'drawer'
    )

    const pullDHP305MB128Door = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'DHP305MB128' &&
        i.props.for === 'door'
    )

    const pullDHP305MB128Drawer = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'DHP305MB128' &&
        i.props.for === 'drawer'
    )

    const pullBP723812Door = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'BP723812' &&
        i.props.for === 'door'
    )

    const pullBP723812Drawer = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'BP723812' &&
        i.props.for === 'drawer'
    )

    const pullBP873128Door = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'BP873128' &&
        i.props.for === 'door'
    )

    const pullBP873128Drawer = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'BP873128' &&
        i.props.for === 'drawer'
    )

    const pullDHP465192Drawer = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'DHP465-192' &&
        i.props.for === 'drawer'
    )

    const pullBP7470128Door = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'BP7470128' &&
        i.props.for === 'door'
    )

    const pullBP7470128Drawer = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'BP7470128' &&
        i.props.for === 'drawer'
    )

    const knobDHK301Door = itemsPropsList.find(
      (i) =>
        i.name === 'knobHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'knob' &&
        i.props.subType2 === 'DHK301' &&
        i.props.for === 'door'
    )

    const knobDHK301Drawer = itemsPropsList.find(
      (i) =>
        i.name === 'knobHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'knob' &&
        i.props.subType2 === 'DHK301' &&
        i.props.for === 'drawer'
    )

    const knobDHK401Door = itemsPropsList.find(
      (i) =>
        i.name === 'knobHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'knob' &&
        i.props.subType2 === 'DHK401' &&
        i.props.for === 'door'
    )

    const knobDHK401Drawer = itemsPropsList.find(
      (i) =>
        i.name === 'knobHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'knob' &&
        i.props.subType2 === 'DHK401' &&
        i.props.for === 'drawer'
    )

    const knobDHK501Door = itemsPropsList.find(
      (i) =>
        i.name === 'knobHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'knob' &&
        i.props.subType2 === 'DHK501' &&
        i.props.for === 'door'
    )

    const knobDHK501Drawer = itemsPropsList.find(
      (i) =>
        i.name === 'knobHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'knob' &&
        i.props.subType2 === 'DHK501' &&
        i.props.for === 'drawer'
    )

    const noPullDoor = itemsPropsList.find(
      (i) =>
        i.name === 'noPullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'noPull' &&
        i.props.for === 'door'
    )

    const noPullDrawer = itemsPropsList.find(
      (i) =>
        i.name === 'noPullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'noPull' &&
        i.props.for === 'drawer'
    )

    if (
      pullStandardDoor &&
      pullStandardDrawer &&
      pullArchDoor &&
      pullArchDrawer &&
      pullDPH50476Door &&
      pullDPH50476Drawer &&
      pullDHP30696Door &&
      pullDHP30696Drawer &&
      pullDHP306128Door &&
      pullDHP306128Drawer &&
      pullDHP180128Door &&
      pullDHP180128Drawer &&
      pullDHP465192Door &&
      pullDHP465192Drawer &&
      pullDHP305MB96Door &&
      pullDHP305MB96Drawer &&
      pullDHP305MB128Door &&
      pullDHP305MB128Drawer &&
      pullBP723812Door &&
      pullBP723812Drawer &&
      pullBP873128Door &&
      pullBP873128Drawer &&
      pullBP7470128Door &&
      pullBP7470128Drawer &&
      knobDHK301Door &&
      knobDHK301Drawer &&
      knobDHK401Door &&
      knobDHK401Drawer &&
      knobDHK501Door &&
      knobDHK501Drawer &&
      noPullDoor &&
      noPullDrawer
    ) {
      return {
        door: {
          pullStandard: pullStandardDoor,
          pullArch: pullArchDoor,
          pullDPH50476: pullDPH50476Door,
          pullDHP30696: pullDHP30696Door,
          pullDHP306128: pullDHP306128Door,
          pullDHP180128: pullDHP180128Door,
          pullDHP465192: pullDHP465192Door,
          pullDHP305MB96: pullDHP305MB96Door,
          pullDHP305MB128: pullDHP305MB128Door,
          pullBP723812: pullBP723812Door,
          pullBP873128: pullBP873128Door,
          pullBP7470128: pullBP7470128Door,
          knobDHK301: knobDHK301Door,
          knobDHK401: knobDHK401Door,
          knobDHK501: knobDHK501Door,
          noPull: noPullDoor,
        },
        drawer: {
          pullStandard: pullStandardDrawer,
          pullArch: pullArchDrawer,
          pullDPH50476: pullDPH50476Drawer,
          pullDHP30696: pullDHP30696Drawer,
          pullDHP306128: pullDHP306128Drawer,
          pullDHP180128: pullDHP180128Drawer,
          pullDHP465192: pullDHP465192Drawer,
          pullDHP305MB96: pullDHP305MB96Drawer,
          pullDHP305MB128: pullDHP305MB128Drawer,
          pullBP723812: pullBP723812Drawer,
          pullBP873128: pullBP873128Drawer,
          pullBP7470128: pullBP7470128Drawer,
          knobDHK301: knobDHK301Drawer,
          knobDHK401: knobDHK401Drawer,
          knobDHK501: knobDHK501Drawer,
          noPull: noPullDrawer,
        },
      }
    } else return false
  }

  chooseHandleDefaultItem = (
    items: HandleDefaultItemsType,
    type: HandlePropsType['type'],
    subtype: HandlePropsType['subtype'],
    for_: 'door' | 'drawer'
  ): ItemPropsType => {
    if (type === 'noPull') return items[for_].noPull

    if (type === 'pull') {
      switch (subtype) {
        case 'standard':
          return items[for_].pullStandard
        case 'arch':
          return items[for_].pullArch
        case 'DHP180-128':
          return items[for_].pullDHP180128
        case 'DHP306-96':
          return items[for_].pullDHP30696
        case 'DHP306-128':
          return items[for_].pullDHP306128
        case 'DHP465-192':
          return items[for_].pullDHP465192
        case 'DHP504-76':
          return items[for_].pullDPH50476
        case 'DHP305MB96':
          return items[for_].pullDHP305MB96
        case 'DHP305MB128':
          return items[for_].pullDHP305MB128
        case 'BP723812':
          return items[for_].pullBP723812
        case 'BP873128':
          return items[for_].pullBP873128
        case 'BP7470128':
          return items[for_].pullBP7470128
        default:
          return items[for_].pullStandard
      }
    } else if (type === 'knob') {
      if (subtype === 'DHK401') return items[for_].knobDHK401
      else if (subtype === 'DHK501') return items[for_].knobDHK501

      return items[for_].knobDHK301
    }

    return items[for_].pullStandard
  }

  createNormalCabinet = (
    props: CabinetProps,
    itemsPropsList: ItemPropsType[],
    removableItems: ItemPropsType[]
  ) => {
    // console.time('createCabinet')

    if (props.sectionProps.drawersProps.length) {
      //Checking drawer minimum sizes
      // if (this.props.configs.drawerConfig.minimumDepth > props.depth) {
      //   this.props.setDrawers([])
      //   showMessage(this.props.enqueueSnackbar, 'Drawers removed!', 'warning')
      //   return
      // }

      const filteredDrawersProps = props.sectionProps.drawersProps.filter(
        (dp) =>
          dp.sectionHeight >= this.props.configs.drawerConfig.minimumHeight
      )

      if (
        filteredDrawersProps.length < props.sectionProps.drawersProps.length
      ) {
        this.props.setDrawers(filteredDrawersProps)
        showMessage(this.props.enqueueSnackbar, 'Drawer removed!', 'warning')
        return
      }
    }

    const doorConfig = this.props.configs.doorConfig
    const drawerConfig = this.props.configs.drawerConfig
    const thickness = this.props.configs.thickness
    const isNewBase = this.props.legProps.baseSubType !== 'old'

    for (const itemProps of itemsPropsList) {
      if (itemProps.name === 'Right Side') {
        itemProps.props = {
          ...itemProps.props,
          type: 'shelf',
          width:
            props.height +
            (this.props.legProps.on && this.props.legProps.type === 'noToeKick'
              ? props.legHeight
              : 0), //this.props.configs.noToeKickLegConfig.height : 0),
          length: props.depth,
        }

        itemProps.matrix = [
          2.220446049250313e-16,
          -0,
          -1,
          0,
          0,
          1,
          -0,
          0,
          1,
          0,
          2.220446049250313e-16,
          0,
          (props.width - thickness) / 2,
          this.props.legProps.on && this.props.legProps.type === 'noToeKick'
            ? -props.legHeight / 2
            : 0, //y
          0,
          1,
        ]

        if (this.props.legProps.on) {
          itemProps.render =
            this.props.legProps.type !== 'base' &&
            this.props.legProps.type !== 'baseIsland' &&
            this.props.legProps.type !== 'baseIsland2'
        } else {
          itemProps.render = true
        }
      } else if (itemProps.name === 'Left Side') {
        itemProps.props = {
          ...itemProps.props,
          type: 'shelf',
          width:
            props.height +
            (this.props.legProps.on && this.props.legProps.type === 'noToeKick'
              ? props.legHeight
              : 0), //this.props.configs.noToeKickLegConfig.height : 0),
          length: props.depth,
        }

        itemProps.matrix = [
          2.220446049250313e-16,
          -0,
          -1,
          0,
          0,
          1,
          -0,
          0,
          1,
          0,
          2.220446049250313e-16,
          0,
          (-props.width + thickness) / 2,
          this.props.legProps.on && this.props.legProps.type === 'noToeKick'
            ? -props.legHeight / 2
            : 0, //y
          0,
          1,
        ]

        if (this.props.legProps.on) {
          itemProps.render =
            this.props.legProps.type !== 'base' &&
            this.props.legProps.type !== 'baseIsland' &&
            this.props.legProps.type !== 'baseIsland2'
        } else {
          itemProps.render = true
        }
      } else if (itemProps.name === 'Left Side Base Leg') {
        const cut =
          this.props.legProps.baseSubType === 'old' ? 0 : this.props.baseLegCut

        itemProps.props = {
          ...itemProps.props,
          type: 'sideSheetBaseLeg',
          cabinetHeight: props.height,
          legHeight: props.legHeight,
          width: props.depth,
          cutLength: cut,
          backCut: this.props.legProps.type === 'baseIsland' ? cut : undefined,
          isNewBase: this.props.legProps.baseSubType !== 'old',
        }

        itemProps.matrix = [
          -2.220446049250313e-16,
          1.2246467991473532e-16,
          1,
          0,
          -2.465190328815662e-32,
          -1,
          1.2246467991473532e-16,
          0,
          1,
          0,
          2.220446049250313e-16,
          0,
          -props.width / 2,
          props.height / 2,
          -props.depth / 2,
          1,
        ]

        itemProps.render =
          this.props.legProps.on &&
          (this.props.legProps.type === 'base' ||
            this.props.legProps.type === 'baseIsland' ||
            this.props.legProps.type === 'baseIsland2')
      } else if (itemProps.name === 'Right Side Base Leg') {
        const cut =
          this.props.legProps.baseSubType === 'old' ? 0 : this.props.baseLegCut

        itemProps.props = {
          ...itemProps.props,
          type: 'sideSheetBaseLeg',
          cabinetHeight: props.height,
          legHeight: props.legHeight,
          width: props.depth,
          cutLength: cut,
          backCut: this.props.legProps.type === 'baseIsland' ? cut : undefined,
          isNewBase: this.props.legProps.baseSubType !== 'old',
        }

        itemProps.matrix = [
          -2.220446049250313e-16,
          1.2246467991473532e-16,
          1,
          0,
          -2.465190328815662e-32,
          -1,
          1.2246467991473532e-16,
          0,
          1,
          0,
          2.220446049250313e-16,
          0,
          props.width / 2 - thickness,
          props.height / 2,
          -props.depth / 2,
          1,
        ]

        itemProps.render =
          this.props.legProps.on &&
          (this.props.legProps.type === 'base' ||
            this.props.legProps.type === 'baseIsland' ||
            this.props.legProps.type === 'baseIsland2')
      } else if (itemProps.name === 'Top' && itemProps.props.type === 'shelf') {
        const gapForBack =
          this.props.legProps.type === 'baseIsland' ||
          this.props.legProps.type === 'baseIsland2'
            ? thickness
            : 0

        itemProps.props = {
          ...itemProps.props,
          type: 'shelf',
          width: props.width - thickness * 2,
          length: props.depth - gapForBack,
        }

        itemProps.matrix = [
          2.220446049250313e-16,
          2.220446049250313e-16,
          1,
          0,
          -1,
          0,
          2.220446049250313e-16,
          0,
          0,
          -1,
          2.220446049250313e-16,
          0,
          0,
          (props.height - thickness) / 2,
          gapForBack / 2,

          1,
        ]
      } else if (itemProps.name === 'Splitted Top') {
        itemProps.props = {
          ...itemProps.props,
          type: 'splittedTop',
          cabinetWidth: props.width - thickness * 2,
          cabinetDepth: props.depth,
          sheetWidth: this.props.configs.splittedTopSheetWidth,
        }

        itemProps.matrix = [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          (props.height - thickness) / 2,
          0,
          1,
        ]
      } else if (
        itemProps.name === 'Bottom' &&
        itemProps.props.type === 'shelf'
      ) {
        itemProps.render = this.props.cabinetType !== 'upperOpen'

        const gapForBack =
          this.props.legProps.type === 'baseIsland' ||
          this.props.legProps.type === 'baseIsland2'
            ? thickness
            : 0

        itemProps.props = {
          ...itemProps.props,
          type: 'shelf',
          width: props.width - thickness * 2,
          length: props.depth - gapForBack,
        }

        itemProps.matrix = [
          2.220446049250313e-16,
          2.220446049250313e-16,
          1,
          0,
          -1,
          0,
          2.220446049250313e-16,
          0,
          0,
          -1,
          2.220446049250313e-16,
          0,
          0,
          (-props.height + thickness) / 2,
          gapForBack / 2,
          1,
        ]
      } else if (itemProps.name === 'Back') {
        const extendForBottom =
          this.props.legProps.type === 'baseIsland' ||
          this.props.cabinetType === 'upperOpen'
            ? thickness
            : this.props.legProps.type === 'baseIsland2'
              ? thickness + props.legHeight
              : 0

        const extendForTop =
          this.props.legProps.type === 'baseIsland' ||
          this.props.legProps.type === 'baseIsland2'
            ? thickness
            : 0

        itemProps.props = {
          ...itemProps.props,
          type: 'shelf',
          width: props.height - thickness * 2 + extendForBottom + extendForTop,
          length: props.width - thickness * 2,
        }

        itemProps.matrix = [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          -extendForBottom / 2 + extendForTop / 2,
          (-props.depth + thickness) / 2,
          1,
        ]
      } else if (itemProps.name.slice(0, 5) === 'Shelf') {
        // Ghost
        itemProps.props = {
          ...itemProps.props,
          type: 'shelf',
          width: props.depth - thickness,
          length: props.width - thickness * 2,
        }
      }
      // else if (itemProps.name === 'Standard Legs') {
      //     itemProps.props = {
      //         ...itemProps.props,
      //         type: 'leg',
      //         subType: 'standard',
      //         cabinetWidth: props.width,
      //         cabinetDepth: props.depth
      //     }

      //     itemProps.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -props.height / 2, 0, 1]
      // }
      else if (itemProps.name === 'No Toe Kick Front') {
        itemProps.props = {
          ...itemProps.props,
          type: 'shelf',
          width: props.legHeight, //this.props.configs.noToeKickLegConfig.height,
          length: props.width,
        }

        itemProps.matrix = [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          (-props.height - props.legHeight) / 2,
          (props.depth + thickness) / 2,
          1,
        ]
        itemProps.render =
          this.props.legProps.type === 'noToeKick' && this.props.legProps.on
      } else if (itemProps.name === 'Base Leg Front') {
        itemProps.props = {
          ...itemProps.props,
          type: 'shelf',
          length: props.legHeight, //this.props.configs.baseLegConfig.height,
          width: props.width - (isNewBase ? 0 : 2 * thickness),
        }

        itemProps.matrix = [
          2.220446049250313e-16,
          1,
          0,
          0,
          -1,
          2.220446049250313e-16,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          (-props.height - props.legHeight) / 2,
          (props.depth + thickness) / 2 -
            (this.props.baseLegCut ??
              this.props.configs.baseLegConfig.cutLength) -
            thickness,
          1,
        ]
        itemProps.render =
          this.props.legProps.on &&
          (this.props.legProps.type === 'base' ||
            this.props.legProps.type === 'baseIsland' ||
            this.props.legProps.type === 'baseIsland2')
      } else if (itemProps.name === 'Base Leg Back') {
        itemProps.props = {
          ...itemProps.props,
          type: 'shelf',
          length: props.legHeight, //this.props.configs.baseLegConfig.height,
          width: props.width - (isNewBase ? 0 : 2 * thickness),
        }

        itemProps.matrix = [
          2.220446049250313e-16,
          1,
          0,
          0,
          -1,
          2.220446049250313e-16,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          (-props.height - props.legHeight) / 2,
          -(
            (props.depth + thickness) / 2 -
            (this.props.baseLegCut ??
              this.props.configs.baseLegConfig.cutLength) -
            thickness
          ),
          1,
        ]
        itemProps.render =
          this.props.legProps.on && this.props.legProps.type === 'baseIsland'
      }
    }

    const section = makeSection(props.sectionProps, thickness)

    // tops

    const tIndex = itemsPropsList.findIndex(
      (item) => item.name === 'Top' && item.props.type === 'shelf'
    )
    const stIndex = itemsPropsList.findIndex(
      (item) => item.name === 'Splitted Top'
    )

    if (tIndex !== -1 && stIndex !== -1) {
      if (this.props.splittedTop) {
        if (
          props.depth > this.props.configs.minimumNonSplittedTopDepth &&
          props.width > this.props.configs.minimumNonSplittedTopWidth
        ) {
          itemsPropsList[tIndex].render = false
          itemsPropsList[stIndex].render = true
        } else {
          itemsPropsList[tIndex].render = true
          itemsPropsList[stIndex].render = false
        }
      } else {
        itemsPropsList[tIndex].render = true
        itemsPropsList[stIndex].render = false
      }
    }

    const fixedShelfItem = itemsPropsList.find(
      (props) => props.name === 'fixed'
    )

    if (fixedShelfItem)
      for (const divider of section.dividers) {
        if (divider.type === 'visible') {
          const oldItem = removableItems.find(
            (item) => item.uuid === divider.uuid
          )

          const itemProps = oldItem ? clone(oldItem) : clone(fixedShelfItem)

          itemProps.uuid = divider.uuid
          itemProps.name = 'Fixed Shelf ' + divider.object.name.split('_')[1]
          itemProps.props = {
            type: 'shelf',
            length: props.depth - thickness,
            width: props.width - thickness * 2,
          }

          // const mesh = new Mesh()
          // mesh.position.set(0, divider.object.position.y, thickness / 2)
          // mesh.rotateZ(Math.PI / 2)

          itemProps.matrix = [
            2.220446049250313e-16,
            2.220446049250313e-16,
            1,
            0,
            -1,
            0,
            2.220446049250313e-16,
            0,
            0,
            -1,
            2.220446049250313e-16,
            0,
            0,
            divider.object.position.y,
            thickness / 2,
            1,
          ]

          // itemProps.matrix[13] = divider.object.position.y
          // itemProps.matrix[14] = thickness / 2
          itemProps.render = true

          itemsPropsList.push(itemProps)
        }
      }

    // =================Adjustable Shelves==================

    const shelfItemProps = itemsPropsList.find(
      (props) => props.name === 'shelf'
    )

    if (shelfItemProps) {
      // const ys = []

      // let temp = centerY - sectionHeight / 2
      // for (let i = 0; i < count; i++) {
      //     temp += sectionHeight / (count + 1)
      //     ys.push(temp)
      // }

      // this.removeTempDividers()

      // ys.reverse().forEach((y, i) => {
      // const shelf = createSheet(
      //     this.props.cabinetProps.width.value - 2 * thickness,
      //     this.props.cabinetProps.depth.value - thickness,
      //     // 1
      // )

      // shelf.name = 'tempShelf'
      // shelf.position.y = y
      // shelf.position.z += thickness / 2 - .01
      // shelf.rotation.x += Math.PI / 2

      // shelf.userData.names = sectionName === 'section' ? '1_' + (i + 1).toString() : sectionName.split('_')[1] + '_' + (i + 1).toString()

      // this.scene.add(shelf)
      // })

      for (const shelfProps of props.sectionProps.shelvesProps) {
        // debugger
        const ys = []

        let temp = shelfProps.sectionY - shelfProps.sectionHeight / 2
        for (let i = 0; i < shelfProps.count; i++) {
          temp += shelfProps.sectionHeight / (shelfProps.count + 1)
          ys.push(temp)
        }

        ys.reverse().forEach((y, i) => {
          const itemProps = clone(shelfItemProps)

          itemProps.name = `Shelf_${shelfProps.sectionNumber}_${i + 1}`

          itemProps.props = {
            type: 'shelf',
            length: props.depth - thickness,
            width: props.width - thickness * 2,
          }

          itemProps.matrix = [
            2.220446049250313e-16,
            2.220446049250313e-16,
            1,
            0,
            -1,
            0,
            2.220446049250313e-16,
            0,
            0,
            -1,
            2.220446049250313e-16,
            0,
            0,
            y,
            thickness / 2 - 0.01,
            1,
          ]
          // const matrix = new Matrix4()
          // matrix.makeRotationX(Math.PI / 2)
          // matrix.setPosition(0, y, thickness / 2 - 0.01)

          // itemProps.matrix = matrix.elements
          itemProps.render = true

          itemsPropsList.push(itemProps)
        })
      }
    }

    // =================Doors==================

    const vGrooveOneItem = itemsPropsList.find(
      (props) => props.name === 'vGrooveOne'
    )
    const vGrooveTwoItem = itemsPropsList.find(
      (props) => props.name === 'vGrooveTwo'
    )
    const fivePiecesOneItem = itemsPropsList.find(
      (props) => props.name === 'fivePiecesOne'
    )
    const fivePiecesTwoItem = itemsPropsList.find(
      (props) => props.name === 'fivePiecesTwo'
    )
    const fivePiecesLiftUp = itemsPropsList.find(
      (props) => props.name === 'fivePiecesLiftUp'
    )
    const vGrooveLiftUpItem = itemsPropsList.find(
      (props) => props.name === 'vGrooveLiftUp'
    )

    const shakerOneItem = itemsPropsList.find(
      (props) => props.name === 'shakerOne'
    )
    const shakerTwoItem = itemsPropsList.find(
      (props) => props.name === 'shakerTwo'
    )

    const shakerLiftUpItem = itemsPropsList.find(
      (props) => props.name === 'shakerLiftUp'
    )

    const newDoorOneItems = this.getNewDoorDefaultItems(itemsPropsList)
    const handleItems = this.getHandleDefaultItems(itemsPropsList)

    if (
      vGrooveOneItem &&
      vGrooveTwoItem &&
      fivePiecesOneItem &&
      fivePiecesTwoItem &&
      vGrooveLiftUpItem &&
      fivePiecesLiftUp &&
      newDoorOneItems &&
      shakerOneItem &&
      shakerTwoItem &&
      shakerLiftUpItem &&
      handleItems
    )
      for (const doorProps of props.sectionProps.doorsProps) {
        //left <-> right
        const oldItem = removableItems.find(
          (item) => item.uuid === doorProps.uuid
        )

        // console.log(oldItem, doorProps)

        const itemProps = oldItem
          ? clone(oldItem)
          : clone(
              doorProps.type === 'liftUp'
                ? doorProps.visualType === 'vGroove'
                  ? vGrooveLiftUpItem
                  : doorProps.visualType.startsWith('shaker')
                    ? shakerLiftUpItem
                    : doorProps.visualType.startsWith('#')
                      ? this.chooseNewDoorDefaultItem(
                          newDoorOneItems,
                          doorProps.visualType as DoorNewVisualTypes,
                          'liftUp'
                        )
                      : fivePiecesLiftUp
                : doorProps.type === 'double'
                  ? doorProps.visualType === 'vGroove'
                    ? vGrooveTwoItem
                    : doorProps.visualType.startsWith('shaker')
                      ? shakerTwoItem
                      : doorProps.visualType.startsWith('#')
                        ? this.chooseNewDoorDefaultItem(
                            newDoorOneItems,
                            doorProps.visualType as DoorNewVisualTypes,
                            'double'
                          )
                        : fivePiecesTwoItem
                  : doorProps.visualType === 'vGroove'
                    ? vGrooveOneItem
                    : doorProps.visualType.startsWith('shaker')
                      ? shakerOneItem
                      : doorProps.visualType.startsWith('#')
                        ? this.chooseNewDoorDefaultItem(
                            newDoorOneItems,
                            doorProps.visualType as DoorNewVisualTypes,
                            'left'
                          )
                        : fivePiecesOneItem
            )

        // console.log(oldItem, doorProps, itemProps)

        itemProps.uuid = doorProps.uuid

        const sectionType =
          doorProps.sectionNumber !== 1
            ? doorProps.sectionNumber ===
              props.sectionProps.dividersProps.length + 1
              ? 'last'
              : 'middle'
            : props.sectionProps.dividersProps.length === 0
              ? 'single'
              : 'first'

        let doorHeight =
          doorProps.sectionHeight +
          (doorProps.sectionNumber === 1
            ? props.sectionProps.dividersProps.length === 0
              ? thickness
              : props.sectionProps.dividersProps[0].type === 'visible' //if first divider is fixed shelf
                ? thickness * 1.5
                : thickness
            : 0) + //If section is the first
          (doorProps.sectionNumber ===
          props.sectionProps.dividersProps.length + 1
            ? props.sectionProps.dividersProps.length === 0
              ? thickness
              : props.sectionProps.dividersProps[
                    props.sectionProps.dividersProps.length - 1
                  ].type === 'visible' //if last divider is fixed shelf
                ? thickness * 1.5
                : thickness
            : 0) + //If section is the last
          (doorProps.sectionNumber !== 1 &&
          doorProps.sectionNumber !==
            props.sectionProps.dividersProps.length + 1
            ? props.sectionProps.dividersProps[doorProps.sectionNumber - 2]
                .type === 'visible' //if top divider is fixed shelf
              ? thickness / 2
              : 0
            : 0) + //If section is not first or last
          (doorProps.sectionNumber !== 1 &&
          doorProps.sectionNumber !==
            props.sectionProps.dividersProps.length + 1
            ? props.sectionProps.dividersProps[doorProps.sectionNumber - 1]
                .type === 'visible' //if bottom divider is fixed shelf
              ? thickness / 2
              : 0
            : 0) //If section is not first or last

        const doorActualHeight =
          doorHeight -
          (sectionType !== 'middle'
            ? sectionType === 'single'
              ? doorConfig.topReveal + doorConfig.bottomReveal
              : sectionType === 'first'
                ? doorConfig.topReveal + doorConfig.horizontalGap / 2 //first
                : doorConfig.bottomReveal + doorConfig.horizontalGap / 2 //last
            : doorConfig.horizontalGap) //middle

        itemProps.name = `${
          doorProps.type === 'left'
            ? 'Left'
            : doorProps.type === 'right'
              ? 'Right'
              : 'Double'
        } Door ${doorProps.sectionNumber}`

        const resolvedSplitter =
          this.resolveSplitter(
            doorProps.normalMapSplitter,
            doorActualHeight,
            doorProps.sectionY,
            props.height,
            props.legHeight
          ) || ''

        if (doorProps.visualType.startsWith('#')) {
          const vType = doorProps.visualType as DoorNewVisualTypes
          const dWidth =
            props.width - doorConfig.leftReveal - doorConfig.rightReveal
          const holeSizes = getNewDoorHoleSizes(
            doorProps.type === 'double',
            vType,
            dWidth,
            doorActualHeight,
            resolvedSplitter
          )
          // console.log(holeSizes)

          itemProps.props = {
            type: 'newDoor',
            visualType: vType,
            subType: doorProps.type,
            sectionType,
            width: dWidth,
            height: doorActualHeight,
            splitters: resolvedSplitter,
            holeWidth: holeSizes.width,
            glassHeight: holeSizes.glassHeight,
            cleanHeight: holeSizes.cleanHeight,
            mirrorHeight: holeSizes.mirrorHeight,
            frostedHeight: holeSizes.frostedHeight,
          }
        } else {
          if (doorProps.visualType === 'fivePieces') {
            const dWidth =
              props.width - doorConfig.leftReveal - doorConfig.rightReveal

            const _props = getFivePiecesDoorProps(
              doorProps.type === 'double',
              dWidth,
              doorActualHeight,
              resolvedSplitter,
              this.props.configs.fivePiecesConfig.pieceWidth,
              this.props.configs.doorConfig
            )

            itemProps.props = {
              type: 'fivePiecesDoor',
              visualType: doorProps.visualType || this.props.doorVisualType,
              subType: doorProps.type,
              sectionType,
              width:
                props.width - doorConfig.leftReveal - doorConfig.rightReveal,
              height: doorActualHeight,
              splitters: resolvedSplitter,
              holeWidth: _props.holeWidth,
              cleanHeight: _props.cleanHeight,
              glassHeight: _props.glassHeight,
              mirrorHeight: _props.mirrorHeight,
              frostedHeight: _props.frostedHeight,
              sheetHeight: _props.sheetHeight,
              piecesLength: _props.piecesLength,
              piecesWidth: this.props.configs.fivePiecesConfig.pieceWidth,
            }
          } else {
            itemProps.props = {
              type: 'door',
              visualType: doorProps.visualType || this.props.doorVisualType,
              subType: doorProps.type,
              sectionType,
              width:
                props.width - doorConfig.leftReveal - doorConfig.rightReveal,
              height: doorActualHeight,
              // splitters: resolvedSplitter,
            }

            // itemProps.props.splitters =
            //   itemProps.props.visualType === 'fivePieces'
            //     ? resolvedSplitter
            //     : undefined
          }
        }

        itemProps.matrix[13] =
          doorProps.sectionY +
          (doorProps.sectionNumber === 1
            ? props.sectionProps.dividersProps.length === 0
              ? 0
              : props.sectionProps.dividersProps[0].type === 'visible' //if first divider is fixed shelf
                ? thickness / 4
                : thickness / 2
            : 0) + //If section is the first
          (doorProps.sectionNumber ===
          props.sectionProps.dividersProps.length + 1
            ? props.sectionProps.dividersProps.length === 0
              ? 0
              : props.sectionProps.dividersProps[
                    props.sectionProps.dividersProps.length - 1
                  ].type === 'visible' //if last divider is fixed shelf
                ? -thickness / 4
                : -thickness / 2
            : 0) + //If section is the last
          (doorProps.sectionNumber !== 1 &&
          doorProps.sectionNumber !==
            props.sectionProps.dividersProps.length + 1
            ? props.sectionProps.dividersProps[doorProps.sectionNumber - 2]
                .type === 'visible' //if top divider is fixed shelf
              ? thickness / 4
              : 0
            : 0) + //If section is not first or last
          (doorProps.sectionNumber !== 1 &&
          doorProps.sectionNumber !==
            props.sectionProps.dividersProps.length + 1
            ? props.sectionProps.dividersProps[doorProps.sectionNumber - 1]
                .type === 'visible' //if bottom divider is fixed shelf
              ? -thickness / 4
              : 0
            : 0) //If section is not first or last

        if (sectionType === 'first') {
          const deltaY =
            doorHeight / 2 - (doorConfig.topReveal + doorActualHeight / 2)
          itemProps.matrix[13] += deltaY
        } else if (sectionType === 'last') {
          const deltaY =
            doorConfig.bottomReveal + doorActualHeight / 2 - doorHeight / 2
          itemProps.matrix[13] += deltaY
        }

        itemProps.matrix[14] = props.depth / 2 + thickness / 2
        itemProps.matrix[12] = doorConfig.leftReveal - doorConfig.rightReveal
        itemProps.render = true

        if (doorProps.type === 'liftUp') {
          if (doorProps.handleProps.orientation === 'double_horizontal') {
            const lName = `${doorProps.handleProps.type[0].toUpperCase()}${doorProps.handleProps.type.slice(
              1
            )} ${doorProps.handleProps.subtype} Left Handle`
            const rName = `${doorProps.handleProps.type[0].toUpperCase()}${doorProps.handleProps.type.slice(
              1
            )} ${doorProps.handleProps.subtype} Right Handle`

            const rOldItem = itemProps.childrenProps.find(
              (item) =>
                item.name === rName &&
                item.props.type === 'handle' &&
                item.props.subType === doorProps.handleProps.type &&
                item.props.subType2 === doorProps.handleProps.subtype
            )
            const lOldItem = itemProps.childrenProps.find(
              (item) =>
                item.name === lName &&
                item.props.type === 'handle' &&
                item.props.subType === doorProps.handleProps.type &&
                item.props.subType2 === doorProps.handleProps.subtype
            )

            const lHandleItemProps = lOldItem
              ? clone(lOldItem)
              : clone(
                  this.chooseHandleDefaultItem(
                    handleItems,
                    doorProps.handleProps.type,
                    doorProps.handleProps.subtype,
                    'door'
                  )
                )

            const rHandleItemProps = rOldItem
              ? clone(rOldItem)
              : clone(
                  this.chooseHandleDefaultItem(
                    handleItems,
                    doorProps.handleProps.type,
                    doorProps.handleProps.subtype,
                    'door'
                  )
                )

            lHandleItemProps.props = {
              type: 'handle',
              subType: doorProps.handleProps.type,
              subType2: doorProps.handleProps.subtype,
              position: doorProps.handleProps.position,
              orientation: doorProps.handleProps.orientation,
              hPosition: 'left',
            }
            rHandleItemProps.props = {
              type: 'handle',
              subType: doorProps.handleProps.type,
              subType2: doorProps.handleProps.subtype,
              position: doorProps.handleProps.position,
              orientation: doorProps.handleProps.orientation,
              hPosition: 'right',
            }

            lHandleItemProps.name = lName
            rHandleItemProps.name = rName

            lHandleItemProps.render = true
            rHandleItemProps.render = true

            lHandleItemProps.matrix = this.calculateLiftUpDoubleHandleMatrix(
              doorProps.handleProps.position,
              doorProps.handleProps.positionX,
              doorProps.visualType,
              doorProps.handleProps.type,
              doorProps.handleProps.subtype,
              itemProps.props.height,
              itemProps.props.width,
              true,
              this.props.configs.handleConfig
            )

            rHandleItemProps.matrix = this.calculateLiftUpDoubleHandleMatrix(
              doorProps.handleProps.position,
              doorProps.handleProps.positionX,
              doorProps.visualType,
              doorProps.handleProps.type,
              doorProps.handleProps.subtype,
              itemProps.props.height,
              itemProps.props.width,
              false,
              this.props.configs.handleConfig
            )

            itemProps.childrenProps = [lHandleItemProps, rHandleItemProps]
          } else {
            const handleName = `${doorProps.handleProps.type[0].toUpperCase()}${doorProps.handleProps.type.slice(
              1
            )} ${doorProps.handleProps.subtype} Handle`

            const oldHandleItem = itemProps.childrenProps.find(
              (item) =>
                item.name === handleName &&
                item.props.type === 'handle' &&
                item.props.subType === doorProps.handleProps.type &&
                item.props.subType2 === doorProps.handleProps.subtype
            )

            const handleItemProps = oldHandleItem
              ? clone(oldHandleItem)
              : clone(
                  this.chooseHandleDefaultItem(
                    handleItems,
                    doorProps.handleProps.type,
                    doorProps.handleProps.subtype,
                    'door'
                  )
                )

            handleItemProps.props = {
              type: 'handle',
              subType: doorProps.handleProps.type,
              subType2: doorProps.handleProps.subtype,
              position: doorProps.handleProps.position,
              orientation: doorProps.handleProps.orientation,
              hPosition: 'center',
            }
            handleItemProps.name = handleName
            handleItemProps.render = true

            handleItemProps.matrix = this.calculateLiftUpDoorHandleMatrix(
              doorProps.handleProps.type,
              doorProps.handleProps.subtype,
              itemProps.props.height,
              doorProps.handleProps.position,
              doorProps.handleProps.positionX,
              doorProps.visualType,
              itemProps.props.width,
              this.props.configs.handleConfig
            )

            itemProps.childrenProps = [handleItemProps]
            itemProps.name = `Lift Up Door ${doorProps.sectionNumber}`
          }
        } else {
          if (doorProps.type === 'double') {
            const lName = `${doorProps.handleProps.type[0].toUpperCase()}${doorProps.handleProps.type.slice(
              1
            )} ${doorProps.handleProps.subtype} Left Handle`
            const rName = `${doorProps.handleProps.type[0].toUpperCase()}${doorProps.handleProps.type.slice(
              1
            )} ${doorProps.handleProps.subtype} Right Handle`

            const rOldItem = itemProps.childrenProps.find(
              (item) =>
                item.name === rName &&
                item.props.type === 'handle' &&
                item.props.subType === doorProps.handleProps.type &&
                item.props.subType2 === doorProps.handleProps.subtype
            )
            const lOldItem = itemProps.childrenProps.find(
              (item) =>
                item.name === lName &&
                item.props.type === 'handle' &&
                item.props.subType === doorProps.handleProps.type &&
                item.props.subType2 === doorProps.handleProps.subtype
            )

            const lHandleItemProps = lOldItem
              ? clone(lOldItem)
              : clone(
                  this.chooseHandleDefaultItem(
                    handleItems,
                    doorProps.handleProps.type,
                    doorProps.handleProps.subtype,
                    'door'
                  )
                )

            const rHandleItemProps = rOldItem
              ? clone(rOldItem)
              : clone(
                  this.chooseHandleDefaultItem(
                    handleItems,
                    doorProps.handleProps.type,
                    doorProps.handleProps.subtype,
                    'door'
                  )
                )

            lHandleItemProps.props = {
              type: 'handle',
              subType: doorProps.handleProps.type,
              subType2: doorProps.handleProps.subtype,
              position: doorProps.handleProps.position,
              orientation: doorProps.handleProps.orientation,
              hPosition: 'left',
            }
            rHandleItemProps.props = {
              type: 'handle',
              subType: doorProps.handleProps.type,
              subType2: doorProps.handleProps.subtype,
              position: doorProps.handleProps.position,
              orientation: doorProps.handleProps.orientation,
              hPosition: 'right',
            }

            lHandleItemProps.name = lName
            rHandleItemProps.name = rName

            lHandleItemProps.render = true
            rHandleItemProps.render = true

            lHandleItemProps.matrix = this.calculateHandlePosition(
              doorProps.handleProps.type,
              doorProps.handleProps.subtype,
              lHandleItemProps.props.orientation === 'vertical',
              itemProps.props,
              itemProps.matrix[13],
              doorProps.handleProps.position,
              doorProps.handleProps.positionX,
              'left',
              doorProps.handleProps.positionFromGroundValue
            )
            rHandleItemProps.matrix = this.calculateHandlePosition(
              doorProps.handleProps.type,
              doorProps.handleProps.subtype,
              rHandleItemProps.props.orientation === 'vertical',
              itemProps.props,
              itemProps.matrix[13],
              doorProps.handleProps.position,
              doorProps.handleProps.positionX,
              'right',
              doorProps.handleProps.positionFromGroundValue
            )

            itemProps.childrenProps = [lHandleItemProps, rHandleItemProps]
          } else {
            const name = `${doorProps.handleProps.type[0].toUpperCase()}${doorProps.handleProps.type.slice(
              1
            )} ${doorProps.handleProps.subtype} Handle`

            const oldItem = itemProps.childrenProps.find(
              (item) =>
                item.name === name &&
                item.props.type === 'handle' &&
                item.props.subType === doorProps.handleProps.type &&
                item.props.subType2 === doorProps.handleProps.subtype
            )

            console.log(oldItem)

            // const handleItemProps = oldItem
            //   ? clone(oldItem)
            //   : clone(
            //       doorProps.handleProps.type === 'standard'
            //         ? handleItem
            //         : archHandleItem
            //     )

            const handleItemProps = oldItem
              ? clone(oldItem)
              : clone(
                  this.chooseHandleDefaultItem(
                    handleItems,
                    doorProps.handleProps.type,
                    doorProps.handleProps.subtype,
                    'door'
                  )
                )

            handleItemProps.props = {
              type: 'handle',
              subType: doorProps.handleProps.type,
              subType2: doorProps.handleProps.subtype,
              position: doorProps.handleProps.position,
              orientation: doorProps.handleProps.orientation,
              hPosition: doorProps.type === 'left' ? 'right' : 'left',
            }
            handleItemProps.name = `${handleItemProps.props.subType[0].toUpperCase()}${handleItemProps.props.subType.slice(
              1
            )} ${handleItemProps.props.subType2} Handle`
            handleItemProps.render = true
            handleItemProps.matrix = this.calculateHandlePosition(
              doorProps.handleProps.type,
              doorProps.handleProps.subtype,
              handleItemProps.props.orientation === 'vertical',
              itemProps.props,
              itemProps.matrix[13],
              doorProps.handleProps.position,
              doorProps.handleProps.positionX,
              undefined,
              doorProps.handleProps.positionFromGroundValue
            )

            itemProps.childrenProps = [handleItemProps]
          }

          // Add hinge hardware
          const doorHingeHardwareId =
            doorHingehardwareIds[this.props.doorHingeType]

          const shIndex = itemProps.hardwaresProps.findIndex(
            (hProps) =>
              hProps.id === doorHingehardwareIds.standard ||
              hProps.id === doorHingehardwareIds.soft
          )

          if (shIndex !== -1) {
            itemProps.hardwaresProps.splice(shIndex, 1)
          }

          const localId =
            Math.max(...itemProps.hardwaresProps.map((id) => id.localId), 0) + 1
          itemProps.hardwaresProps.push({
            id: doorHingeHardwareId,
            localId,
            count: doorProps.type === 'double' ? 2 : 1,
          })

          const lIndex = itemProps.links.findIndex(
            (link) =>
              link.hId === doorHingehardwareIds.standard.toString() ||
              link.hId === doorHingehardwareIds.soft.toString()
          )

          if (lIndex !== -1) {
            itemProps.links.splice(lIndex, 1)
          }

          itemProps.links.push({
            hId: localId.toString(),
            hProp: 'height',
            itemProp: 'height',
          })
        }
        itemsPropsList.push(itemProps)
      }

    // =================Drawers==================

    const drawerItem = itemsPropsList.find((props) => props.name === 'drawer')
    const fivePiecesDrawerItem = itemsPropsList.find(
      (props) => props.name === 'fivePiecesDrawer'
    )
    const shakerDrawerItem = itemsPropsList.find(
      (props) => props.name === 'shakerDrawer'
    )

    if (
      drawerItem &&
      fivePiecesDrawerItem &&
      shakerDrawerItem &&
      handleItems &&
      newDoorOneItems
    )
      for (const drawerProps of props.sectionProps.drawersProps) {
        const oldItem = removableItems.find(
          (item) => item.uuid === drawerProps.uuid
        )

        const itemProps = oldItem
          ? clone(oldItem)
          : clone(
              drawerProps.visualType?.startsWith('#')
                ? this.chooseNewDoorDefaultItem(
                    newDoorOneItems,
                    drawerProps.visualType as DoorNewVisualTypes,
                    'drawer'
                  )
                : drawerProps.visualType === 'fivePieces'
                  ? fivePiecesDrawerItem
                  : drawerProps.visualType?.startsWith('shaker')
                    ? shakerDrawerItem
                    : drawerItem
            )

        console.log(itemProps)

        itemProps.uuid = drawerProps.uuid

        const sectionType =
          drawerProps.sectionNumber !== 1
            ? drawerProps.sectionNumber ===
              props.sectionProps.dividersProps.length + 1
              ? 'last'
              : 'middle'
            : props.sectionProps.dividersProps.length === 0
              ? 'single'
              : 'first'

        let drawerHeight =
          drawerProps.sectionHeight +
          (drawerProps.sectionNumber === 1
            ? props.sectionProps.dividersProps.length === 0
              ? thickness
              : props.sectionProps.dividersProps[0].type === 'visible' //if first divider is fixed shelf
                ? thickness * 1.5
                : thickness
            : 0) + //If section is the first
          (drawerProps.sectionNumber ===
          props.sectionProps.dividersProps.length + 1
            ? props.sectionProps.dividersProps.length === 0
              ? thickness
              : props.sectionProps.dividersProps[
                    props.sectionProps.dividersProps.length - 1
                  ].type === 'visible' //if last divider is fixed shelf
                ? thickness * 1.5
                : thickness
            : 0) + //If section is the last
          (drawerProps.sectionNumber !== 1 &&
          drawerProps.sectionNumber !==
            props.sectionProps.dividersProps.length + 1
            ? props.sectionProps.dividersProps[drawerProps.sectionNumber - 2]
                .type === 'visible' //if top divider is fixed shelf
              ? thickness / 2
              : 0
            : 0) + //If section is not first or last
          (drawerProps.sectionNumber !== 1 &&
          drawerProps.sectionNumber !==
            props.sectionProps.dividersProps.length + 1
            ? props.sectionProps.dividersProps[drawerProps.sectionNumber - 1]
                .type === 'visible' //if bottom divider is fixed shelf
              ? thickness / 2
              : 0
            : 0) //If section is not first or last

        const drawerActualHeight =
          drawerHeight -
          (sectionType !== 'middle'
            ? sectionType === 'single'
              ? doorConfig.topReveal + doorConfig.bottomReveal
              : sectionType === 'first'
                ? doorConfig.topReveal + doorConfig.horizontalGap / 2 //first
                : doorConfig.bottomReveal + doorConfig.horizontalGap / 2 //last
            : doorConfig.horizontalGap) //middle

        itemProps.name = `Drawer ${drawerProps.sectionNumber}`

        let temp = drawerActualHeight - drawerConfig.boxHeightBottomMargin
        let possibleBoxHeight =
          temp - drawerConfig.boxHeights[1].minimumTopMargin

        if (possibleBoxHeight < drawerConfig.boxHeights[0].value) {
          possibleBoxHeight = temp - drawerConfig.boxHeights[0].minimumTopMargin
        }
        console.log(drawerConfig.boxHeights)
        const boxHeight =
          possibleBoxHeight >= drawerConfig.boxHeights[5].value
            ? drawerConfig.boxHeights[5].value
            : possibleBoxHeight >= drawerConfig.boxHeights[4].value
              ? drawerConfig.boxHeights[4].value
              : possibleBoxHeight >= drawerConfig.boxHeights[3].value
                ? drawerConfig.boxHeights[3].value
                : possibleBoxHeight >= drawerConfig.boxHeights[2].value
                  ? drawerConfig.boxHeights[2].value
                  : possibleBoxHeight >= drawerConfig.boxHeights[1].value
                    ? drawerConfig.boxHeights[1].value
                    : drawerConfig.boxHeights[0].value

        const cabinetInsideDepth = props.depth - drawerConfig.boxDepthMargin

        const boxDepth =
          cabinetInsideDepth >= drawerConfig.boxDepths[5]
            ? drawerConfig.boxDepths[5]
            : cabinetInsideDepth >= drawerConfig.boxDepths[4]
              ? drawerConfig.boxDepths[4]
              : cabinetInsideDepth >= drawerConfig.boxDepths[3]
                ? drawerConfig.boxDepths[3]
                : cabinetInsideDepth >= drawerConfig.boxDepths[2]
                  ? drawerConfig.boxDepths[2]
                  : cabinetInsideDepth >= drawerConfig.boxDepths[1]
                    ? drawerConfig.boxDepths[1]
                    : drawerConfig.boxDepths[0]

        const drawerSlideTypeProps =
          drawerSlideProps[this.props.drawerSlideType]
        const slideProps =
          [...drawerSlideTypeProps]
            .reverse()
            .find((sp) => cabinetInsideDepth >= sp.value) ??
          drawerSlideTypeProps[0]

        if (drawerProps.visualType === 'fivePieces') {
          const dWidth =
            props.width - doorConfig.leftReveal - doorConfig.rightReveal

          const drawerMaxHeight = 7.25 * 2.54

          const _props = getFivePiecesDrawerProps(
            dWidth,
            drawerActualHeight,
            this.props.configs.fivePiecesConfig.pieceWidth,
            this.props.configs.fivePiecesConfig.pieceWidth /
              (drawerActualHeight < drawerMaxHeight ? 2 : 1)
          )

          itemProps.props = {
            type: 'fivePiecesDrawer',
            visualType: 'fivePieces',
            sectionType,
            width: props.width - doorConfig.leftReveal - doorConfig.rightReveal,
            height: drawerActualHeight,
            centerWidth: _props.centerWidth,
            centerHeight: _props.centerHeight,
            piecesArea: _props.piecesArea,
            boxHeight,
            boxDepth,
            boxWidth:
              props.width - thickness * 2 - drawerConfig.boxWidthMargin * 2,
            depth: props.depth,
          }
        } else {
          itemProps.props = {
            type: 'drawer',
            visualType: drawerProps.visualType || 'standard',
            sectionType,
            width: props.width - doorConfig.leftReveal - doorConfig.rightReveal,
            height: drawerActualHeight,
            depth: props.depth,
            boxHeight,
            boxDepth,
            boxWidth:
              props.width - thickness * 2 - drawerConfig.boxWidthMargin * 2,
          }
        }

        //add drawer box hardware and links
        const index = drawerConfig.boxHeights.findIndex(
          (b) => b.value === boxHeight
        )

        if (index !== -1) {
          const drawerBoxHardwareId = drawerConfig.boxHeights[index].hardwareId

          const hIndex = itemProps.hardwaresProps.findIndex((hProps) =>
            drawerConfig.boxHeights.map((b) => b.hardwareId).includes(hProps.id)
          )

          if (hIndex === -1) {
            const localId =
              Math.max(...itemProps.hardwaresProps.map((id) => id.localId), 0) +
              1
            itemProps.hardwaresProps.push({
              id: drawerBoxHardwareId,
              localId,
              count: 1,
            })

            itemProps.links.push(
              ...[
                {
                  hId: localId.toString(),
                  hProp: 'height',
                  itemProp: 'boxHeight',
                },
                {
                  hId: localId.toString(),
                  hProp: 'width',
                  itemProp: 'boxWidth',
                },
                {
                  hId: localId.toString(),
                  hProp: 'depth',
                  itemProp: 'boxDepth',
                },
              ]
            )
          } else {
            itemProps.hardwaresProps[hIndex] = {
              ...itemProps.hardwaresProps[hIndex],
              id: drawerBoxHardwareId,
            }
          }

          // Add slide hardware
          const drawerSlideHardwareId = slideProps.hardwareId

          const shIndex = itemProps.hardwaresProps.findIndex((hProps) =>
            drawerSlideAllHardwareIds.includes(hProps.id)
          )

          if (shIndex === -1) {
            const localId =
              Math.max(...itemProps.hardwaresProps.map((id) => id.localId), 0) +
              1
            itemProps.hardwaresProps.push({
              id: drawerSlideHardwareId,
              localId,
              count: 1,
            })
          } else {
            itemProps.hardwaresProps[shIndex] = {
              ...itemProps.hardwaresProps[shIndex],
              id: drawerSlideHardwareId,
            }
          }
        }

        itemProps.matrix[13] =
          drawerProps.sectionY +
          (drawerProps.sectionNumber === 1
            ? props.sectionProps.dividersProps.length === 0
              ? 0
              : props.sectionProps.dividersProps[0].type === 'visible' //if first divider is fixed shelf
                ? thickness / 4
                : thickness / 2
            : 0) + //If section is the first
          (drawerProps.sectionNumber ===
          props.sectionProps.dividersProps.length + 1
            ? props.sectionProps.dividersProps.length === 0
              ? 0
              : props.sectionProps.dividersProps[
                    props.sectionProps.dividersProps.length - 1
                  ].type === 'visible' //if last divider is fixed shelf
                ? -thickness / 4
                : -thickness / 2
            : 0) + //If section is the last
          (drawerProps.sectionNumber !== 1 &&
          drawerProps.sectionNumber !==
            props.sectionProps.dividersProps.length + 1
            ? props.sectionProps.dividersProps[drawerProps.sectionNumber - 2]
                .type === 'visible' //if top divider is fixed shelf
              ? thickness / 4
              : 0
            : 0) + //If section is not first or last
          (drawerProps.sectionNumber !== 1 &&
          drawerProps.sectionNumber !==
            props.sectionProps.dividersProps.length + 1
            ? props.sectionProps.dividersProps[drawerProps.sectionNumber - 1]
                .type === 'visible' //if bottom divider is fixed shelf
              ? -thickness / 4
              : 0
            : 0) //If section is not first or last

        if (sectionType === 'first') {
          const deltaY =
            drawerHeight / 2 - (doorConfig.topReveal + drawerActualHeight / 2)
          itemProps.matrix[13] += deltaY
        } else if (sectionType === 'last') {
          const deltaY =
            doorConfig.bottomReveal + drawerActualHeight / 2 - drawerHeight / 2
          itemProps.matrix[13] += deltaY
        }

        itemProps.matrix[14] = props.depth / 2 + thickness / 2
        itemProps.matrix[12] = doorConfig.leftReveal - doorConfig.rightReveal
        itemProps.render = true

        //  Handle part

        if (drawerProps.handleProps.orientation === 'double_horizontal') {
          const lName = `${drawerProps.handleProps.type[0].toUpperCase()}${drawerProps.handleProps.type.slice(
            1
          )} ${drawerProps.handleProps.subtype} Left Handle`
          const rName = `${drawerProps.handleProps.type[0].toUpperCase()}${drawerProps.handleProps.type.slice(
            1
          )} ${drawerProps.handleProps.subtype} Right Handle`

          const rOldItem = itemProps.childrenProps.find(
            (item) =>
              item.name === rName &&
              item.props.type === 'handle' &&
              item.props.subType === drawerProps.handleProps.type &&
              item.props.subType2 === drawerProps.handleProps.subtype
          )
          const lOldItem = itemProps.childrenProps.find(
            (item) =>
              item.name === lName &&
              item.props.type === 'handle' &&
              item.props.subType === drawerProps.handleProps.type &&
              item.props.subType2 === drawerProps.handleProps.subtype
          )

          // const lHandleItemProps = lOldItem
          //   ? clone(lOldItem)
          //   : clone(
          //       drawerProps.handleProps.type === 'arch'
          //         ? drawerArchHandleItem
          //         : drawerHandleItem
          //     )
          // const rHandleItemProps = rOldItem
          //   ? clone(rOldItem)
          //   : clone(
          //       drawerProps.handleProps.type === 'arch'
          //         ? drawerArchHandleItem
          //         : drawerHandleItem
          //     )

          const lHandleItemProps = lOldItem
            ? clone(lOldItem)
            : clone(
                this.chooseHandleDefaultItem(
                  handleItems,
                  drawerProps.handleProps.type,
                  drawerProps.handleProps.subtype,
                  'drawer'
                )
              )

          const rHandleItemProps = rOldItem
            ? clone(rOldItem)
            : clone(
                this.chooseHandleDefaultItem(
                  handleItems,
                  drawerProps.handleProps.type,
                  drawerProps.handleProps.subtype,
                  'drawer'
                )
              )

          lHandleItemProps.props = {
            type: 'handle',
            subType: drawerProps.handleProps.type,
            subType2: drawerProps.handleProps.subtype,
            position: drawerProps.handleProps.position,
            orientation: drawerProps.handleProps.orientation,
            hPosition: 'left',
          }
          rHandleItemProps.props = {
            type: 'handle',
            subType: drawerProps.handleProps.type,
            subType2: drawerProps.handleProps.subtype,
            position: drawerProps.handleProps.position,
            orientation: drawerProps.handleProps.orientation,
            hPosition: 'right',
          }

          lHandleItemProps.name = lName
          rHandleItemProps.name = rName

          lHandleItemProps.render = true
          rHandleItemProps.render = true

          lHandleItemProps.matrix = this.calculateDrawerDoubleHandleMatrix(
            drawerProps.visualType || 'standard',
            drawerProps.handleProps.position,
            drawerProps.handleProps.positionX,
            drawerProps.handleProps.type,
            drawerProps.handleProps.subtype,
            itemProps.props.height,
            itemProps.props.width,
            true,
            this.props.configs.handleConfig
          )

          rHandleItemProps.matrix = this.calculateDrawerDoubleHandleMatrix(
            drawerProps.visualType || 'standard',
            drawerProps.handleProps.position,
            drawerProps.handleProps.positionX,
            drawerProps.handleProps.type,
            drawerProps.handleProps.subtype,
            itemProps.props.height,
            itemProps.props.width,
            false,
            this.props.configs.handleConfig
          )

          itemProps.childrenProps = [lHandleItemProps, rHandleItemProps]
        } else {
          const handleName = `${drawerProps.handleProps.type[0].toUpperCase()}${drawerProps.handleProps.type.slice(
            1
          )} ${drawerProps.handleProps.subtype} Handle`

          const oldHandleItem = itemProps.childrenProps.find(
            (item) =>
              item.name === handleName &&
              item.props.type === 'handle' &&
              item.props.subType === drawerProps.handleProps.type &&
              item.props.subType2 === drawerProps.handleProps.subtype
          )

          // const handleItemProps = oldHandleItem
          //   ? clone(oldHandleItem)
          //   : clone(
          //       drawerProps.handleProps.type === 'arch'
          //         ? drawerArchHandleItem
          //         : drawerHandleItem
          //     )

          const handleItemProps = oldHandleItem
            ? clone(oldHandleItem)
            : clone(
                this.chooseHandleDefaultItem(
                  handleItems,
                  drawerProps.handleProps.type,
                  drawerProps.handleProps.subtype,
                  'drawer'
                )
              )

          handleItemProps.props = {
            type: 'handle',
            subType: drawerProps.handleProps.type,
            subType2: drawerProps.handleProps.subtype,
            position: drawerProps.handleProps.position,
            orientation: drawerProps.handleProps.orientation || 'horizontal',
            hPosition: 'center',
          }

          // console.log(handleItemProps.props)
          handleItemProps.name = handleName
          handleItemProps.render = true

          handleItemProps.matrix = this.calculateDrawerHandleMatrix(
            drawerProps.visualType || 'standard',
            drawerProps.handleProps.position,
            drawerProps.handleProps.type,
            drawerProps.handleProps.subtype,
            itemProps.props.height,
            drawerProps.handleProps.positionX,
            itemProps.props.width,
            this.props.configs.handleConfig
          )

          itemProps.childrenProps = [handleItemProps]
        }

        itemsPropsList.push(itemProps)
      }

    // =================Legs==================

    const legsItem = itemsPropsList.find((props) => props.name === 'legs')
    const legs2ShortItem = itemsPropsList.find(
      (props) => props.name === 'legs2Short'
    )
    const legs2TallItem = itemsPropsList.find(
      (props) => props.name === 'legs2Tall'
    )
    const separateBaseItem = itemsPropsList.find(
      (props) => props.props.type === 'separateBase'
    )

    if (
      this.props.legProps.on &&
      legsItem &&
      separateBaseItem &&
      legs2ShortItem &&
      legs2TallItem
      // &&
      // noLegsItem
    ) {
      if (this.props.legProps.type === 'standard') {
        if (
          itemsPropsList.findIndex((item) => item.name === 'Standard Legs') ===
          -1
        ) {
          const itemProps = clone(legsItem)

          itemProps.name = 'Standard Legs'

          itemProps.props = {
            type: 'leg',
            subType: 'standard',
            cabinetWidth: props.width,
            cabinetDepth: props.depth,
            height: props.legHeight,
          }

          itemProps.matrix = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            -props.height / 2,
            0,
            1,
          ]
          itemProps.render = true

          itemsPropsList.push(itemProps)
        }
      } else if (this.props.legProps.type === 'noLeg') {
      } else if (this.props.legProps.type === 'standard2_1') {
        if (
          itemsPropsList.findIndex(
            (item) => item.name === 'Standard Legs 2 Short'
          ) === -1
        ) {
          const itemProps = clone(legs2ShortItem)

          itemProps.name = 'Standard Legs 2 Short'

          itemProps.props = {
            type: 'leg2',
            subType: 'short',
            cabinetWidth: props.width,
            cabinetDepth: props.depth,
            height: props.legHeight,
          }

          itemProps.matrix = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            -props.height / 2,
            0,
            1,
          ]
          itemProps.render = true

          itemsPropsList.push(itemProps)
        }
      } else if (this.props.legProps.type === 'standard2_2') {
        if (
          itemsPropsList.findIndex(
            (item) => item.name === 'Standard Legs 2 Tall'
          ) === -1
        ) {
          const itemProps = clone(legs2TallItem)

          itemProps.name = 'Standard Legs 2 Tall'

          itemProps.props = {
            type: 'leg2',
            subType: 'tall',
            cabinetWidth: props.width,
            cabinetDepth: props.depth,
            height: props.legHeight,
          }

          itemProps.matrix = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            -props.height / 2,
            0,
            1,
          ]
          itemProps.render = true

          itemsPropsList.push(itemProps)
        }
      }
      // else if (this.props.legProps.type === 'noToeKick') {
      //     const itemProps = clone(sheetItem)

      //     itemProps.name = 'No Toe Kick Front'

      //     itemProps.props = {
      //         ...itemProps.props,
      //         type: 'shelf',
      //         width: this.props.configs.noToeKickLegConfig.height,
      //         length: props.width,
      //     }

      //     itemProps.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, (-props.height - this.props.configs.noToeKickLegConfig.height) / 2, (props.depth + thickness) / 2, 1]
      //     itemProps.render = true

      //     itemsPropsList.push(itemProps)
      // }
      // else if (this.props.legProps.type === 'base') {
      //     const itemProps = clone(sheetItem)

      //     itemProps.name = 'Base Leg Front'

      //     itemProps.props = {
      //         ...itemProps.props,
      //         type: 'shelf',
      //         width: this.props.configs.baseLegConfig.height,
      //         length: props.width,
      //     }

      //     itemProps.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, (-props.height - this.props.configs.baseLegConfig.height) / 2, (props.depth + thickness) / 2 - this.props.configs.baseLegConfig.cutLength, 1]
      //     itemProps.render = true

      //     itemsPropsList.push(itemProps)
      // }
      else if (this.props.legProps.type === 'separateBase') {
        const itemProps = clone(separateBaseItem)

        itemProps.name = 'Separate Base Platform'

        itemProps.props = {
          ...itemProps.props,
          type: 'separateBase',
          width:
            props.width - 2 * this.props.configs.separateBaseConfig.sideMargin,
          height: props.legHeight, //this.props.configs.separateBaseConfig.platformHeight,
          depth:
            props.depth - this.props.configs.separateBaseConfig.frontMargin,
        }

        itemProps.matrix = [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          (-props.height - props.legHeight) / 2,
          0,
          1,
        ]
        itemProps.render = true

        itemsPropsList.push(itemProps)
      }
    }
    // else if (!this.props.legProps.on) {
    //     const index = itemsPropsList.findIndex(itemProps => (itemProps.props.type === 'leg' && itemProps.render))
    //     if (index !== -1) {
    //         const sIndex = this.scene.children.findIndex(ch => ch.name === itemsPropsList[index].name)
    //         if (sIndex !== -1)
    //             this.scene.remove(this.scene.children[sIndex])

    //         itemsPropsList.splice(index, 1)
    //     }
    // }

    // const sectionProps = clone(props.sectionProps)

    // sectionProps.width = props.width.value - thickness * 2
    // sectionProps.height = props.height.value - thickness * 2

    // this.props.setSectionProps(sectionProps)

    const additionalItem = itemsPropsList.find(
      (i) => i.name === 'Additional Item'
    )

    if (additionalItem) {
      const _props = {} as { [key: string]: number }

      for (const iProps of itemsPropsList.filter(
        (i) => i.name !== 'Additional Item' && i.render
      )) {
        for (const key in iProps.props) {
          // @ts-ignore
          if (typeof iProps.props[key] === 'number') {
            // @ts-ignore
            _props[iProps.name + '_' + key] = iProps.props[key]
          }
        }
      }

      additionalItem.props = {
        type: 'additional',
        cabinetWidth: props.width,
        cabinetHeight: props.height,
        cabinetDepth: props.depth,
        ..._props,
      }
    }

    this.addSectionToScene(section, props.depth)
    this.selecting.checkIfSelected(section)

    this.props.setSection(section)

    this.props.setItemsPropsList(itemsPropsList)

    this.setSectionPoses(this.selecting.getSectionsPoses(props.width))

    // saveCabinetPropsInLocalStorage(props, this.props.doorType, this.props.doorVisualType, this.props.legProps, this.props.splittedTop, this.props.cabinetType)
    this.saveCabinetInLS('normalCabinetInfo', false)
    this.saveCabinetInLS('exportCabinetInfo')

    // console.timeEnd('createCabinet')
  }

  createCornerCabinet = (
    props: CornerCabinetProps,
    itemsPropsList: ItemPropsType[],
    removableItems: ItemPropsType[]
  ) => {
    console.log('createCabinet')

    const doorConfig = this.props.configs.doorConfig
    const thickness = this.props.configs.thickness
    const legProps = this.props.legProps
    const isNewBase = this.props.legProps.baseSubType !== 'old'

    for (const itemProps of itemsPropsList) {
      if (itemProps.name === 'Front Left Side') {
        itemProps.props = {
          ...itemProps.props,
          type: 'shelf',
          width:
            props.height +
            (legProps.on && legProps.type === 'noToeKick'
              ? props.legHeight
              : 0),
          length: props.depth1,
        }

        itemProps.matrix = [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          props.depth1 / 2,
          legProps.on && legProps.type === 'noToeKick'
            ? -props.legHeight / 2
            : 0, //y
          props.width1 - thickness / 2,
          1,
        ]

        if (this.props.legProps.on) {
          itemProps.render =
            legProps.type !== 'base' && legProps.type !== 'baseIsland'
        } else {
          itemProps.render = true
        }
      } else if (itemProps.name === 'Front Left Side Base Leg') {
        itemProps.props = {
          ...itemProps.props,
          type: 'sideSheetBaseLeg',
          cabinetHeight: props.height,
          legHeight: props.legHeight,
          width: props.depth1,
          cutLength: this.props.baseLegCut,
          isNewBase: this.props.legProps.baseSubType !== 'old',
        }
        itemProps.matrix = [
          1,
          0,
          0,
          0,
          0,
          -1,
          1.2246467991473532e-16,
          0,
          0,
          -1.2246467991473532e-16,
          -1,
          0,
          0, //x
          props.height / 2,
          props.width1, //- thickness / 2, //z
          1,
        ]
        itemProps.render =
          this.props.legProps.on &&
          (legProps.type === 'base' || legProps.type === 'baseIsland')
      } else if (itemProps.name === 'Back Left Side') {
        const sheetLength =
          legProps.on &&
          legProps.type === 'baseIsland' &&
          legProps.subType !== 'cornerRight'
            ? props.width1
            : props.width1 - props.backWidth1 - thickness

        const sheetHeight =
          props.height +
          (legProps.on &&
          (legProps.type === 'noToeKick' || legProps.type === 'baseIsland')
            ? props.legHeight
            : 0)

        itemProps.props = {
          ...itemProps.props,
          type: 'shelf',
          width: sheetHeight,
          length: sheetLength,
        }

        let z =
          props.backWidth1 +
          (props.width1 - props.backWidth1) / 2 -
          thickness / 2

        if (
          legProps.on &&
          legProps.type === 'baseIsland' &&
          legProps.subType !== 'cornerRight'
        ) {
          z = sheetLength / 2
        }

        itemProps.matrix = [
          2.220446049250313e-16,
          -0,
          -1,
          0,
          0,
          1,
          -0,
          0,
          1,
          0,
          2.220446049250313e-16,
          0,
          thickness / 2,
          legProps.on &&
          (legProps.type === 'noToeKick' || legProps.type === 'baseIsland')
            ? -props.legHeight / 2
            : 0, //y
          z,
          1,
        ]
      } else if (itemProps.name === 'Front Right Side') {
        itemProps.props = {
          ...itemProps.props,
          type: 'shelf',
          width:
            props.height +
            (legProps.on && legProps.type === 'noToeKick'
              ? props.legHeight
              : 0),
          length: props.depth2,
        }

        itemProps.matrix = [
          2.220446049250313e-16,
          -0,
          -1,
          0,
          0,
          1,
          -0,
          0,
          1,
          0,
          2.220446049250313e-16,
          0,
          props.width2 - thickness / 2,
          legProps.on && legProps.type === 'noToeKick'
            ? -props.legHeight / 2
            : 0,
          props.depth2 / 2,
          1,
        ]

        if (this.props.legProps.on) {
          itemProps.render =
            legProps.type !== 'base' && legProps.type !== 'baseIsland'
        } else {
          itemProps.render = true
        }
      } else if (itemProps.name === 'Front Right Side Base Leg') {
        itemProps.props = {
          ...itemProps.props,
          type: 'sideSheetBaseLeg',
          cabinetHeight: props.height,
          legHeight: props.legHeight,
          width: props.depth2,
          cutLength: this.props.baseLegCut,
          isNewBase: this.props.legProps.baseSubType !== 'old',
        }

        itemProps.matrix = [
          2.220446049250313e-16,
          1.2246467991473532e-16,
          1,
          0,
          0,
          -1,
          1.2246467991473532e-16,
          0,
          1,
          -2.465190328815662e-32,
          -2.220446049250313e-16,
          0,
          props.width2 - thickness,
          props.height / 2,
          0,
          1,
        ]
        itemProps.render =
          this.props.legProps.on &&
          (legProps.type === 'base' || legProps.type === 'baseIsland')
      } else if (itemProps.name === 'Back Right Side') {
        const sheetLength =
          legProps.on &&
          legProps.type === 'baseIsland' &&
          legProps.subType !== 'cornerLeft'
            ? props.width2
            : props.width2 - props.backWidth2 - thickness

        const sheetHeight =
          props.height +
          (legProps.on &&
          (legProps.type === 'noToeKick' || legProps.type === 'baseIsland')
            ? props.legHeight
            : 0)

        itemProps.props = {
          ...itemProps.props,
          type: 'shelf',
          width: sheetHeight,
          length: sheetLength,
        }

        let x =
          props.backWidth2 +
          (props.width2 - props.backWidth2) / 2 -
          thickness / 2

        if (
          legProps.on &&
          legProps.type === 'baseIsland' &&
          legProps.subType !== 'cornerLeft'
        ) {
          x = sheetLength / 2
        }

        itemProps.matrix = [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          x,
          legProps.on &&
          (legProps.type === 'noToeKick' || legProps.type === 'baseIsland')
            ? -props.legHeight / 2
            : 0,
          thickness / 2,
          1,
        ]
      } else if (
        itemProps.name === 'Top' &&
        itemProps.props.type === 'cornerHorizontalSheet'
      ) {
        itemProps.props = {
          ...itemProps.props,
          type: 'cornerHorizontalSheet',
          subType: props.type,
          width1: props.width1,
          width2: props.width2,
          backWidth1: props.backWidth1,
          backWidth2: props.backWidth2,
          depth1: props.depth1,
          depth2: props.depth2,
          thickness,
        }

        itemProps.matrix = [
          1,
          0,
          0,
          0,
          0,
          2.220446049250313e-16,
          1,
          0,
          0,
          -1,
          2.220446049250313e-16,
          0,
          0,
          props.height / 2,
          0,
          1,
        ]
      } else if (
        itemProps.name === 'Bottom' &&
        itemProps.props.type === 'cornerHorizontalSheet'
      ) {
        itemProps.props = {
          type: 'cornerHorizontalSheet',
          subType: props.type,
          width1: props.width1,
          width2: props.width2,
          backWidth1: props.backWidth1,
          backWidth2: props.backWidth2,
          depth1: props.depth1,
          depth2: props.depth2,
          thickness,
        }

        itemProps.matrix = [
          1,
          0,
          0,
          0,
          0,
          2.220446049250313e-16,
          1,
          0,
          0,
          -1,
          2.220446049250313e-16,
          0,
          0,
          -props.height / 2 + thickness,
          0,
          1,
        ]

        itemProps.render = this.props.cabinetType !== 'upperOpen'
      } else if (itemProps.name === 'Back') {
        //https://docs.google.com/drawings/d/1K7u-zPlLSAsqcnGt1ggNBfdGwkeSukW6IkEClD1JSj4/edit?usp=sharing

        // const e1 = props.width1 - props.backWidth1 - thickness //old backWidth calculation, some calculations can be useless now, but for fast reaching result algorithm not been changed
        const e1 = props.backWidth1 - thickness //edge
        const e2 = props.backWidth2 - thickness
        const hyp = (e1 ** 2 + e2 ** 2) ** 0.5 //hypotenuse

        const x1 = (thickness * hyp) / e2
        const x2 = (thickness * hyp) / e1
        const l1 = (thickness * e1) / e2 //length margin, == y
        const l2 = (thickness * e2) / e1

        const _e1 = e1 + thickness + l1
        const _e2 = e2 + thickness + l2
        const _hyp = hyp + x1 + x2
        const h = (_e1 * _e2) / _hyp // height of _triangle

        const z = (_e1 ** 2 - h ** 2) ** 0.5

        itemProps.props = {
          ...itemProps.props,
          type: 'shelf',
          width: props.height,
          length: hyp + l1 + l2,
        }

        const angle = Math.asin(e2 / hyp)

        const mesh = new Mesh()

        mesh.rotateY(Math.PI / 2 - angle)
        mesh.translateZ(h + thickness / 2)
        mesh.translateX(hyp / 2 - (z - x1))
        mesh.translateX((l2 - l1) / 2)

        mesh.updateMatrix()

        itemProps.matrix = [...mesh.matrix.elements]
      } else if (itemProps.name === 'Base Leg Front') {
        const cutLength =
          this.props.baseLegCut ?? this.props.configs.baseLegConfig.cutLength

        const e1 = props.width2 - props.depth1 + cutLength - thickness / 2 //edge
        const e2 = props.width1 - props.depth2 + cutLength - thickness / 2 //edge
        const hyp = (e1 ** 2 + e2 ** 2) ** 0.5 //hypotenuse

        const x = props.width1 - e1 / 2 - thickness //* 1.5
        const z = props.width2 - e2 / 2 - thickness //* 1.5

        itemProps.props = {
          ...itemProps.props,
          type: 'shelf',
          length: props.legHeight, //this.props.configs.baseLegConfig.height,
          width: hyp, // + thickness,
        }

        itemProps.matrix = [
          2.220446049250313e-16,
          1,
          -1.1102230246251565e-16,
          0,
          -0.7071067811865475,
          2.220446049250313e-16,
          0.7071067811865476,
          0,
          0.7071067811865476,
          0,
          0.7071067811865475,
          0,
          x,
          (-props.height - props.legHeight) / 2,
          z,
          1,
        ]

        itemProps.render =
          this.props.legProps.on &&
          (legProps.type === 'base' || legProps.type === 'baseIsland') &&
          props.type === 'angled'
      } else if (itemProps.name === 'Base Leg Front 1') {
        const cutLength =
          this.props.baseLegCut ?? this.props.configs.baseLegConfig.cutLength

        const length =
          props.width1 - props.depth2 + cutLength - (isNewBase ? 0 : thickness) //edge

        const x = props.depth1 - cutLength - thickness / 2
        const z = props.width1 - length / 2 - (isNewBase ? 0 : thickness)

        itemProps.props = {
          ...itemProps.props,
          type: 'shelf',
          length: props.legHeight, //this.props.configs.baseLegConfig.height,
          width: length, // + thickness,
        }

        itemProps.matrix = [
          0,
          1,
          -2.220446049250313e-16,
          0,
          -2.220446049250313e-16,
          2.220446049250313e-16,
          1,
          0,
          1,
          0,
          2.220446049250313e-16,
          0,
          x,
          (-props.height - props.legHeight) / 2,
          z,
          1,
        ]

        itemProps.render =
          this.props.legProps.on &&
          (legProps.type === 'base' || legProps.type === 'baseIsland') &&
          props.type === '2door'
      } else if (itemProps.name === 'Base Leg Front 2') {
        const cutLength =
          this.props.baseLegCut ?? this.props.configs.baseLegConfig.cutLength

        const length =
          props.width2 - props.depth1 + cutLength + (isNewBase ? thickness : 0)

        const x = props.width2 - length / 2 - (isNewBase ? 0 : thickness)
        const z = props.depth2 - cutLength - thickness / 2

        itemProps.props = {
          ...itemProps.props,
          type: 'shelf',
          length: props.legHeight, //this.props.configs.baseLegConfig.height,
          width: length, // + thickness,
        }

        itemProps.matrix = [
          2.220446049250313e-16,
          1,
          0,
          0,
          -1,
          2.220446049250313e-16,
          0,
          0,
          0,
          0,
          1,
          0,
          x,
          (-props.height - props.legHeight) / 2,
          z,
          1,
        ]

        itemProps.render =
          this.props.legProps.on &&
          (legProps.type === 'base' || legProps.type === 'baseIsland') &&
          props.type === '2door'
      }
      // else if (itemProps.name.slice(0, 5) === 'Shelf') {
      //     itemProps.props = {
      //         ...itemProps.props,
      //         type: 'shelf',
      //         width: props.depth - thickness,
      //         length: props.width - thickness * 2
      //     }
      // }
    }

    const section = makeSection(props.sectionProps, thickness)

    // =================Fixed Shelves==================

    const fixedShelfItem = itemsPropsList.find(
      (props) => props.name === 'cornerFixed'
    )

    if (fixedShelfItem)
      for (const divider of section.dividers) {
        if (divider.type === 'visible') {
          const oldItem = removableItems.find(
            (item) => item.uuid === divider.uuid
          )

          const itemProps = oldItem ? clone(oldItem) : clone(fixedShelfItem)

          itemProps.uuid = divider.uuid
          itemProps.name = 'Fixed Shelf ' + divider.object.name.split('_')[1]
          itemProps.props = {
            type: 'cornerHorizontalSheet',
            subType: props.type,
            width1: props.width1,
            width2: props.width2,
            backWidth1: props.backWidth1,
            backWidth2: props.backWidth2,
            depth1: props.depth1,
            depth2: props.depth2,
            thickness,
          }

          itemProps.matrix[13] = divider.object.position.y + thickness / 2
          // itemProps.matrix[14] = thickness / 2
          itemProps.render = true

          itemsPropsList.push(itemProps)
        }
      }

    // =================Adjustable Shelves==================

    const shelfItemProps = itemsPropsList.find(
      (props) => props.name === 'cornerShelf'
    )

    if (shelfItemProps) {
      for (const shelfProps of props.sectionProps.shelvesProps) {
        // debugger
        const ys = []

        let temp = shelfProps.sectionY - shelfProps.sectionHeight / 2
        for (let i = 0; i < shelfProps.count; i++) {
          temp += shelfProps.sectionHeight / (shelfProps.count + 1)
          ys.push(temp)
        }

        ys.reverse().forEach((y, i) => {
          const itemProps = clone(shelfItemProps)

          itemProps.name = `Shelf_${shelfProps.sectionNumber}_${i + 1}`

          itemProps.props = {
            type: 'cornerHorizontalSheet',
            subType: props.type,
            width1: props.width1,
            width2: props.width2,
            backWidth1: props.backWidth1,
            backWidth2: props.backWidth2,
            depth1: props.depth1,
            depth2: props.depth2,
            thickness,
          }

          const matrix = new Matrix4()
          matrix.makeRotationX(Math.PI / 2)
          matrix.setPosition(0, y, 0)

          itemProps.matrix = matrix.elements
          itemProps.render = true

          itemsPropsList.push(itemProps)
        })
      }
    }

    // =================Doors==================

    const vGrooveOneCornerItem = itemsPropsList.find(
      (props) => props.name === 'vGrooveOneCorner'
    )
    const cornerTwoDoorItem = itemsPropsList.find(
      (props) => props.name === 'corner2door'
    )
    const vGrooveLiftUpItem = itemsPropsList.find(
      (props) => props.name === 'vGrooveLiftUp'
    )

    const fivePiecesOneItem = itemsPropsList.find(
      (props) => props.name === 'fivePiecesOne'
    )
    const fivePiecesLiftUp = itemsPropsList.find(
      (props) => props.name === 'fivePiecesLiftUp'
    )
    const fivePiecesCornerItem = itemsPropsList.find(
      (props) => props.name === 'fivePiecesCorner'
    )

    const shakerOneItem = itemsPropsList.find(
      (props) => props.name === 'shakerOne'
    )
    const shakerLiftUpItem = itemsPropsList.find(
      (props) => props.name === 'shakerLiftUp'
    )
    const shakerCornerItem = itemsPropsList.find(
      (props) => props.name === 'shakerCorner'
    )
    const newDoorOneItems = this.getNewDoorDefaultItems(itemsPropsList)
    const handleItems = this.getHandleDefaultItems(itemsPropsList)

    // const handleItem = itemsPropsList.find((props) => props.name === 'handle')
    // const archHandleItem = itemsPropsList.find(
    //   (props) => props.name === 'archHandle'
    // )

    // const drawerHandleItem = itemsPropsList.find(
    //   (props) => props.name === 'drawerHandle'
    // )
    // const drawerArchHandleItem = itemsPropsList.find(
    //   (props) => props.name === 'drawerArchHandle'
    // )

    if (
      cornerTwoDoorItem &&
      vGrooveOneCornerItem &&
      vGrooveLiftUpItem &&
      handleItems &&
      fivePiecesOneItem &&
      fivePiecesLiftUp &&
      fivePiecesCornerItem &&
      shakerOneItem &&
      shakerLiftUpItem &&
      shakerCornerItem &&
      newDoorOneItems
    ) {
      for (const doorProps of props.sectionProps.doorsProps) {
        //left <-> right
        const oldItem = this.scene.userData.isCornerTypeChanged
          ? undefined
          : removableItems.find((item) => item.uuid === doorProps.uuid)

        const itemProps = oldItem
          ? clone(oldItem)
          : clone(
              props.type === '2door'
                ? doorProps.visualType === 'fivePieces'
                  ? fivePiecesCornerItem
                  : doorProps.visualType.startsWith('#')
                    ? this.chooseNewDoorDefaultItem(
                        newDoorOneItems,
                        doorProps.visualType as DoorNewVisualTypes,
                        'cornerTwoDoor'
                      )
                    : doorProps.visualType.startsWith('shaker')
                      ? shakerLiftUpItem
                      : cornerTwoDoorItem
                : doorProps.type === 'liftUp'
                  ? doorProps.visualType === 'vGroove'
                    ? vGrooveLiftUpItem
                    : doorProps.visualType.startsWith('shaker')
                      ? shakerLiftUpItem
                      : doorProps.visualType.startsWith('#')
                        ? this.chooseNewDoorDefaultItem(
                            newDoorOneItems,
                            doorProps.visualType as DoorNewVisualTypes,
                            'liftUp'
                          )
                        : fivePiecesLiftUp
                  : doorProps.visualType === 'vGroove'
                    ? vGrooveOneCornerItem
                    : doorProps.visualType.startsWith('shaker')
                      ? shakerOneItem
                      : doorProps.visualType.startsWith('#')
                        ? this.chooseNewDoorDefaultItem(
                            newDoorOneItems,
                            doorProps.visualType as DoorNewVisualTypes,
                            'left'
                          )
                        : fivePiecesOneItem
            )
        // : clone(doorProps.type === 'double'
        //     ? this.props.doorVisualType === 'vGroove' ? vGrooveTwoItem : fivePiecesTwoItem
        //     : this.props.doorVisualType === 'vGroove' ? vGrooveOneItem : fivePiecesOneItem
        // )

        itemProps.uuid = doorProps.uuid

        const sectionType =
          doorProps.sectionNumber !== 1
            ? doorProps.sectionNumber ===
              props.sectionProps.dividersProps.length + 1
              ? 'last'
              : 'middle'
            : props.sectionProps.dividersProps.length === 0
              ? 'single'
              : 'first'

        let doorHeight =
          doorProps.sectionHeight +
          (doorProps.sectionNumber === 1
            ? props.sectionProps.dividersProps.length === 0
              ? thickness
              : props.sectionProps.dividersProps[0].type === 'visible' //if first divider is fixed shelf
                ? thickness * 1.5
                : thickness
            : 0) + //If section is the first
          (doorProps.sectionNumber ===
          props.sectionProps.dividersProps.length + 1
            ? props.sectionProps.dividersProps.length === 0
              ? thickness
              : props.sectionProps.dividersProps[
                    props.sectionProps.dividersProps.length - 1
                  ].type === 'visible' //if last divider is fixed shelf
                ? thickness * 1.5
                : thickness
            : 0) + //If section is the last
          (doorProps.sectionNumber !== 1 &&
          doorProps.sectionNumber !==
            props.sectionProps.dividersProps.length + 1
            ? props.sectionProps.dividersProps[doorProps.sectionNumber - 2]
                .type === 'visible' //if top divider is fixed shelf
              ? thickness / 2
              : 0
            : 0) + //If section is not first or last
          (doorProps.sectionNumber !== 1 &&
          doorProps.sectionNumber !==
            props.sectionProps.dividersProps.length + 1
            ? props.sectionProps.dividersProps[doorProps.sectionNumber - 1]
                .type === 'visible' //if bottom divider is fixed shelf
              ? thickness / 2
              : 0
            : 0) //If section is not first or last

        const doorActualHeight =
          doorHeight -
          (sectionType !== 'middle'
            ? sectionType === 'single'
              ? doorConfig.topReveal + doorConfig.bottomReveal
              : sectionType === 'first'
                ? doorConfig.topReveal + doorConfig.horizontalGap / 2 //first
                : doorConfig.bottomReveal + doorConfig.horizontalGap / 2 //last
            : doorConfig.horizontalGap) //middle

        // itemProps.name = `${doorProps.type === 'left' ? 'Left' : doorProps.type === 'right' ? 'Right' : 'Double'} Door ${doorProps.sectionNumber}`
        itemProps.name = `${
          doorProps.type === 'left' ? 'Left' : 'Right'
        } Corner Door ${doorProps.sectionNumber}`

        const sideGap = 0.3175 //.125"
        const dThickness = thickness

        const resolvedSplitter =
          this.resolveSplitter(
            doorProps.normalMapSplitter,
            doorActualHeight,
            doorProps.sectionY,
            props.height,
            props.legHeight
          ) || ''

        if (props.type === '2door') {
          const width1 =
            props.width1 -
            props.depth2 -
            dThickness -
            sideGap -
            doorConfig.leftReveal
          const width2 =
            props.width2 -
            props.depth1 -
            dThickness -
            sideGap -
            doorConfig.rightReveal

          if (doorProps.visualType === 'fivePieces') {
            const _props = getFivePiecesCornerTwoDoorProps(
              width1,
              width2,
              doorActualHeight,
              resolvedSplitter,
              this.props.configs.fivePiecesConfig.pieceWidth,
              this.props.configs.doorConfig
            )

            itemProps.props = {
              type: 'cornerTwoDoorFivePieces',
              visualType: doorProps.visualType,
              subType:
                doorProps.type === 'double' || doorProps.type === 'liftUp'
                  ? 'left'
                  : doorProps.type,
              sectionType,
              width1,
              width2,
              height: doorActualHeight,
              thickness: dThickness,
              splitters: resolvedSplitter,
              piecesLength: _props.piecesLength,
              holeWidth: _props.holeWidth,
              piecesWidth: this.props.configs.fivePiecesConfig.pieceWidth,
              sheetHeight: _props.sheetHeight,
              cleanHeight: _props.cleanHeight,
              frostedHeight: _props.frostedHeight,
              glassHeight: _props.glassHeight,
              mirrorHeight: _props.mirrorHeight,
            }
          } else if (doorProps.visualType.startsWith('#')) {
            const vType = doorProps.visualType as DoorNewVisualTypes

            const holeSizes = getNewDoorHoleSizes(
              doorProps.type === 'double',
              vType,
              width1,
              doorActualHeight,
              resolvedSplitter
            )

            const holeSizes2 = getNewDoorHoleSizes(
              doorProps.type === 'double',
              vType,
              width2,
              doorActualHeight,
              resolvedSplitter
            )

            const holeWidth = holeSizes.width + holeSizes2.width
            // console.log(holeSizes)

            itemProps.props = {
              type: 'cornerNewDoor',
              visualType: vType,
              subType:
                doorProps.type === 'double' || doorProps.type === 'liftUp'
                  ? 'left'
                  : doorProps.type,
              sectionType,
              width: width1 + width2,
              width1,
              width2,
              height: doorActualHeight,
              splitters: resolvedSplitter,
              holeWidth,
              glassHeight: holeSizes.glassHeight,
              cleanHeight: holeSizes.cleanHeight,
              mirrorHeight: holeSizes.mirrorHeight,
              frostedHeight: holeSizes.frostedHeight,
              thickness: this.props.configs.thickness,
            }
          } else {
            itemProps.props = {
              type: 'cornerTwoDoor',
              visualType: doorProps.visualType,
              subType:
                doorProps.type === 'double' || doorProps.type === 'liftUp'
                  ? 'left'
                  : doorProps.type,
              sectionType,
              width1,
              width2,
              width: width1 + width2,
              height: doorActualHeight,
              thickness: dThickness,
              splitters: resolvedSplitter,
            }
          }

          itemProps.matrix = [...new Matrix4().elements]
          itemProps.matrix[12] =
            props.depth1 +
            (props.width2 - props.depth1) / 2 +
            sideGap / 2 -
            doorConfig.rightReveal / 2 //+ dThickness
          itemProps.matrix[14] =
            props.depth2 +
            (props.width1 - props.depth2) / 2 +
            sideGap / 2 -
            doorConfig.leftReveal / 2
        } else {
          //angled
          const width = calculateCornerSectionSize(
            props.width1,
            props.width2,
            props.depth1,
            props.depth2,
            props.thickness
          )

          if (doorProps.visualType.startsWith('#')) {
            const vType = doorProps.visualType as DoorNewVisualTypes
            const dWidth = width //- doorConfig.leftReveal - doorConfig.rightReveal
            const holeSizes = getNewDoorHoleSizes(
              doorProps.type === 'double',
              vType,
              dWidth,
              doorActualHeight,
              resolvedSplitter
            )
            // console.log(holeSizes)

            itemProps.props = {
              type: 'newDoor',
              visualType: vType,
              subType: doorProps.type,
              sectionType,
              width: dWidth,
              height: doorActualHeight,
              splitters: resolvedSplitter,
              holeWidth: holeSizes.width,
              glassHeight: holeSizes.glassHeight,
              cleanHeight: holeSizes.cleanHeight,
              mirrorHeight: holeSizes.mirrorHeight,
              frostedHeight: holeSizes.frostedHeight,
            }
          } else {
            if (doorProps.visualType === 'fivePieces') {
              const dWidth = width // - doorConfig.leftReveal - doorConfig.rightReveal

              const _props = getFivePiecesDoorProps(
                doorProps.type === 'double',
                dWidth,
                doorActualHeight,
                resolvedSplitter,
                this.props.configs.fivePiecesConfig.pieceWidth,
                this.props.configs.doorConfig
              )

              itemProps.props = {
                type: 'fivePiecesDoor',
                visualType: doorProps.visualType || this.props.doorVisualType,
                subType: doorProps.type,
                sectionType,
                width: width, // - doorConfig.leftReveal - doorConfig.rightReveal,
                height: doorActualHeight,
                splitters: resolvedSplitter,
                holeWidth: _props.holeWidth,
                cleanHeight: _props.cleanHeight,
                glassHeight: _props.glassHeight,
                mirrorHeight: _props.mirrorHeight,
                frostedHeight: _props.frostedHeight,
                sheetHeight: _props.sheetHeight,
                piecesLength: _props.piecesLength,
                piecesWidth: this.props.configs.fivePiecesConfig.pieceWidth,
              }
            } else {
              itemProps.props = {
                type: 'door',
                visualType: doorProps.visualType || this.props.doorVisualType,
                subType: doorProps.type === 'double' ? 'left' : doorProps.type,
                sectionType,
                width: width,
                height: doorActualHeight,
                // thickness: dThickness
              }
            }
          }

          const transform = calculateCornerSectionTransform(
            props.width1,
            props.width2,
            props.depth1,
            props.depth2,
            props.thickness,
            true
          )
          const matrix = new Matrix4()
          matrix.makeRotationY(transform.angle)
          matrix.setPosition(transform.x, 0, transform.z)
          itemProps.matrix = clone(matrix.elements)
          // itemProps.matrix[12] = props.depth1 + (props.width2 - props.depth1) / 2 + sideGap / 2 - doorConfig.rightReveal / 2//+ dThickness
          // itemProps.matrix[14] = props.depth2 + (props.width1 - props.depth2) / 2 + sideGap / 2 - doorConfig.leftReveal / 2
        }

        itemProps.matrix[13] =
          doorProps.sectionY +
          (doorProps.sectionNumber === 1
            ? props.sectionProps.dividersProps.length === 0
              ? 0
              : props.sectionProps.dividersProps[0].type === 'visible' //if first divider is fixed shelf
                ? thickness / 4
                : thickness / 2
            : 0) + //If section is the first
          (doorProps.sectionNumber ===
          props.sectionProps.dividersProps.length + 1
            ? props.sectionProps.dividersProps.length === 0
              ? 0
              : props.sectionProps.dividersProps[
                    props.sectionProps.dividersProps.length - 1
                  ].type === 'visible' //if last divider is fixed shelf
                ? -thickness / 4
                : -thickness / 2
            : 0) + //If section is the last
          (doorProps.sectionNumber !== 1 &&
          doorProps.sectionNumber !==
            props.sectionProps.dividersProps.length + 1
            ? props.sectionProps.dividersProps[doorProps.sectionNumber - 2]
                .type === 'visible' //if top divider is fixed shelf
              ? thickness / 4
              : 0
            : 0) + //If section is not first or last
          (doorProps.sectionNumber !== 1 &&
          doorProps.sectionNumber !==
            props.sectionProps.dividersProps.length + 1
            ? props.sectionProps.dividersProps[doorProps.sectionNumber - 1]
                .type === 'visible' //if bottom divider is fixed shelf
              ? -thickness / 4
              : 0
            : 0) //If section is not first or last

        if (sectionType === 'first') {
          const deltaY =
            doorHeight / 2 - (doorConfig.topReveal + doorActualHeight / 2)
          itemProps.matrix[13] += deltaY
        } else if (sectionType === 'last') {
          const deltaY =
            doorConfig.bottomReveal + doorActualHeight / 2 - doorHeight / 2
          itemProps.matrix[13] += deltaY
        }

        itemProps.render = true

        if (doorProps.type === 'liftUp') {
          const dWidth = calculateCornerSectionSize(
            props.width1,
            props.width2,
            props.depth1,
            props.depth2,
            props.thickness
          )

          if (doorProps.handleProps.orientation === 'double_horizontal') {
            const lName = `${doorProps.handleProps.type[0].toUpperCase()}${doorProps.handleProps.type.slice(
              1
            )} ${doorProps.handleProps.subtype} Left Handle`
            const rName = `${doorProps.handleProps.type[0].toUpperCase()}${doorProps.handleProps.type.slice(
              1
            )} ${doorProps.handleProps.subtype} Right Handle`

            const rOldItem = itemProps.childrenProps.find(
              (item) => item.name === rName
            )
            const lOldItem = itemProps.childrenProps.find(
              (item) => item.name === lName
            )

            const lHandleItemProps = lOldItem
              ? clone(lOldItem)
              : clone(
                  this.chooseHandleDefaultItem(
                    handleItems,
                    doorProps.handleProps.type,
                    doorProps.handleProps.subtype,
                    'drawer'
                  )
                )
            const rHandleItemProps = rOldItem
              ? clone(rOldItem)
              : clone(
                  this.chooseHandleDefaultItem(
                    handleItems,
                    doorProps.handleProps.type,
                    doorProps.handleProps.subtype,
                    'drawer'
                  )
                )

            lHandleItemProps.props = {
              type: 'handle',
              subType: doorProps.handleProps.type,
              subType2: doorProps.handleProps.subtype,
              position: doorProps.handleProps.position,
              orientation: doorProps.handleProps.orientation,
              hPosition: 'left',
            }
            rHandleItemProps.props = {
              type: 'handle',
              subType: doorProps.handleProps.type,
              subType2: doorProps.handleProps.subtype,
              position: doorProps.handleProps.position,
              orientation: doorProps.handleProps.orientation,
              hPosition: 'right',
            }

            lHandleItemProps.name = lName
            rHandleItemProps.name = rName

            lHandleItemProps.render = true
            rHandleItemProps.render = true

            lHandleItemProps.matrix = this.calculateLiftUpDoubleHandleMatrix(
              doorProps.handleProps.position,
              doorProps.handleProps.positionX,
              doorProps.visualType,
              doorProps.handleProps.type,
              doorProps.handleProps.subtype,
              itemProps.props.height,
              dWidth,
              true,
              this.props.configs.handleConfig
            )

            rHandleItemProps.matrix = this.calculateLiftUpDoubleHandleMatrix(
              doorProps.handleProps.position,
              doorProps.handleProps.positionX,
              doorProps.visualType,
              doorProps.handleProps.type,
              doorProps.handleProps.subtype,
              itemProps.props.height,
              dWidth,
              false,
              this.props.configs.handleConfig
            )

            itemProps.childrenProps = [lHandleItemProps, rHandleItemProps]
          } else {
            const handleName = `${doorProps.handleProps.type[0].toUpperCase()}${doorProps.handleProps.type.slice(
              1
            )} ${doorProps.handleProps.subtype} Handle`

            const oldHandleItem = itemProps.childrenProps.find(
              (item) => item.name === handleName
            )

            const handleItemProps = oldHandleItem
              ? clone(oldHandleItem)
              : clone(
                  this.chooseHandleDefaultItem(
                    handleItems,
                    doorProps.handleProps.type,
                    doorProps.handleProps.subtype,
                    'drawer'
                  )
                )

            handleItemProps.props = {
              type: 'handle',
              subType: doorProps.handleProps.type,
              subType2: doorProps.handleProps.subtype,
              position: doorProps.handleProps.position,
              orientation: doorProps.handleProps.orientation,
              hPosition: 'center',
            }
            handleItemProps.name = handleName
            handleItemProps.render = true

            handleItemProps.matrix = this.calculateLiftUpDoorHandleMatrix(
              doorProps.handleProps.type,
              doorProps.handleProps.subtype,
              (itemProps.props as DoorItemPropsType).height,
              doorProps.handleProps.position,
              doorProps.handleProps.positionX,
              doorProps.visualType,
              dWidth,
              this.props.configs.handleConfig
            )

            itemProps.childrenProps = [handleItemProps]
            itemProps.name = `Lift Up Door ${doorProps.sectionNumber}`
          }
        } else {
          if (doorProps.type === 'double') {
            // const lName = `${doorProps.handleProps.type[0].toUpperCase()}${doorProps.handleProps.type.slice(1)} Left Handle`
            // const rName = `${doorProps.handleProps.type[0].toUpperCase()}${doorProps.handleProps.type.slice(1)} Right Handle`
            // const rOldItem = itemProps.childrenProps.find(item => item.name === rName)
            // const lOldItem = itemProps.childrenProps.find(item => item.name === lName)
            // const lHandleItemProps = lOldItem ? clone(lOldItem) : clone(handleItem)
            // const rHandleItemProps = rOldItem ? clone(rOldItem) : clone(handleItem)
            // lHandleItemProps.props = {
            //     type: 'handle',
            //     subType: doorProps.handleProps.type,
            //     position: doorProps.handleProps.position
            // }
            // rHandleItemProps.props = {
            //     type: 'handle',
            //     subType: doorProps.handleProps.type,
            //     position: doorProps.handleProps.position
            // }
            // lHandleItemProps.name = lName
            // rHandleItemProps.name = rName
            // lHandleItemProps.render = true
            // rHandleItemProps.render = true
            // lHandleItemProps.matrix = this.calculateHandlePosition(itemProps.props, itemProps.matrix[13], doorProps.handleProps.position, 'left')
            // rHandleItemProps.matrix = this.calculateHandlePosition(itemProps.props, itemProps.matrix[13], doorProps.handleProps.position, 'right')
            // itemProps.childrenProps = [lHandleItemProps, rHandleItemProps]
          } else {
            const name = `${doorProps.handleProps.type[0].toUpperCase()}${doorProps.handleProps.type.slice(
              1
            )} ${doorProps.handleProps.subtype} Handle`

            const oldItem = itemProps.childrenProps.find(
              (item) => item.name === name
            )

            const handleItemProps = oldItem
              ? clone(oldItem)
              : clone(
                  this.chooseHandleDefaultItem(
                    handleItems,
                    doorProps.handleProps.type,
                    doorProps.handleProps.subtype,
                    'door'
                  )
                )
            handleItemProps.props = {
              type: 'handle',
              subType: doorProps.handleProps.type,
              subType2: doorProps.handleProps.subtype,
              position: doorProps.handleProps.position,
              orientation: doorProps.handleProps.orientation || 'vertical',
              hPosition:
                typeof doorProps.handleProps.positionX === 'number'
                  ? 'left'
                  : doorProps.handleProps.positionX === 'left'
                    ? 'left'
                    : 'right',
            }
            handleItemProps.name = `${handleItemProps.props.subType[0].toUpperCase()}${handleItemProps.props.subType.slice(
              1
            )} ${handleItemProps.props.subType2} Handle`
            handleItemProps.render = true
            handleItemProps.matrix =
              props.type === '2door'
                ? this.calculateCornerTwoDoorHandlePosition(
                    doorProps.handleProps.type,
                    doorProps.handleProps.subtype,
                    doorProps.visualType,
                    itemProps.props as CornerTwoDoorItemPropsType,
                    new Vector3(
                      itemProps.matrix[12],
                      itemProps.matrix[13],
                      itemProps.matrix[14]
                    ),
                    doorProps.handleProps.position,
                    doorProps.handleProps.positionX,
                    handleItemProps.props.orientation === 'vertical'
                  )
                : this.calculateHandlePosition(
                    doorProps.handleProps.type,
                    doorProps.handleProps.subtype,
                    handleItemProps.props.orientation === 'vertical',
                    itemProps.props as DoorItemPropsType,
                    itemProps.matrix[13],
                    doorProps.handleProps.position,
                    doorProps.handleProps.positionX,
                    undefined,
                    doorProps.handleProps.positionFromGroundValue
                  )

            itemProps.childrenProps = [handleItemProps]
          }

          if (props.type === 'angled') {
            // Add hinge hardware
            const doorHingeHardwareId =
              doorHingehardwareIds[this.props.doorHingeType]

            const shIndex = itemProps.hardwaresProps.findIndex(
              (hProps) =>
                hProps.id === doorHingehardwareIds.standard ||
                hProps.id === doorHingehardwareIds.soft
            )

            if (shIndex !== -1) {
              itemProps.hardwaresProps.splice(shIndex, 1)
            }

            const localId =
              Math.max(...itemProps.hardwaresProps.map((id) => id.localId), 0) +
              1
            itemProps.hardwaresProps.push({
              id: doorHingeHardwareId,
              localId,
              count: doorProps.type === 'double' ? 2 : 1,
            })

            const lIndex = itemProps.links.findIndex(
              (link) =>
                link.hId === doorHingehardwareIds.standard.toString() ||
                link.hId === doorHingehardwareIds.soft.toString()
            )

            if (lIndex !== -1) {
              itemProps.links.splice(lIndex, 1)
            }

            itemProps.links.push({
              hId: localId.toString(),
              hProp: 'height',
              itemProp: 'height',
            })
          }
        }

        section.hideSection(doorProps.sectionNumber)

        itemsPropsList.push(itemProps)
      }
    }

    // =================Legs==================

    const legItem = itemsPropsList.find(
      (props) => props.name === 'cornerOneLeg'
    )
    const legsItem = itemsPropsList.find(
      (props) => props.props.type === 'cornerLegs'
    )
    const legs2ShortItem = itemsPropsList.find(
      (props) => props.name === 'cornerLegs2Short'
    )
    const legs2TallItem = itemsPropsList.find(
      (props) => props.name === 'cornerLegs2Tall'
    )
    // const separateBaseItem = itemsPropsList.find(props => props.props.type === 'separateBase')

    if (
      this.props.legProps.on &&
      legItem &&
      legsItem &&
      legs2ShortItem &&
      legs2TallItem
    ) {
      if (
        this.props.legProps.type === 'base' ||
        this.props.legProps.type === 'baseIsland'
      ) {
        if (
          itemsPropsList.findIndex(
            (item) => item.name === 'Corner Standard Leg Short'
          ) === -1
        ) {
          const itemProps = clone(legItem)

          itemProps.name = 'Corner Standard Leg Short'

          itemProps.props = {
            type: 'cornerOneLeg',
            height: props.legHeight,
            width1: props.width1,
            width2: props.width2,
            backWidth1: props.backWidth1,
            backWidth2: props.backWidth2,
            depth1: props.depth1,
            depth2: props.depth2,
            thickness,
          }

          itemProps.matrix = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            -props.height / 2,
            0,
            1,
          ]
          itemProps.render = true

          itemsPropsList.push(itemProps)
        }
      } else if (this.props.legProps.type === 'standard') {
        if (
          itemsPropsList.findIndex(
            (item) => item.name === 'Corner Standard Legs'
          ) === -1
        ) {
          const itemProps = clone(legsItem)

          itemProps.name = 'Corner Standard Legs'

          itemProps.props = {
            type: 'cornerLegs',
            height: props.legHeight,
            width1: props.width1,
            width2: props.width2,
            backWidth1: props.backWidth1,
            backWidth2: props.backWidth2,
            depth1: props.depth1,
            depth2: props.depth2,
            thickness,
          }

          itemProps.matrix = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            -props.height / 2,
            0,
            1,
          ]
          itemProps.render = true

          itemsPropsList.push(itemProps)
        }
      } else if (this.props.legProps.type === 'standard2_1') {
        if (
          itemsPropsList.findIndex(
            (item) => item.name === 'Corner Standard Legs 2 Short'
          ) === -1
        ) {
          const itemProps = clone(legs2ShortItem)

          itemProps.name = 'Corner Standard Legs 2 Short'

          itemProps.props = {
            type: 'cornerLegs2',
            subType: 'short',
            height: props.legHeight,
            width1: props.width1,
            width2: props.width2,
            backWidth1: props.backWidth1,
            backWidth2: props.backWidth2,
            depth1: props.depth1,
            depth2: props.depth2,
            thickness,
          }

          itemProps.matrix = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            -props.height / 2,
            0,
            1,
          ]
          itemProps.render = true

          itemsPropsList.push(itemProps)
        }
      } else if (this.props.legProps.type === 'standard2_2') {
        if (
          itemsPropsList.findIndex(
            (item) => item.name === 'Corner Standard Legs 2 Tall'
          ) === -1
        ) {
          const itemProps = clone(legs2TallItem)

          itemProps.name = 'Corner Standard Legs 2 Tall'

          itemProps.props = {
            type: 'cornerLegs2',
            subType: 'tall',
            height: props.legHeight,
            width1: props.width1,
            width2: props.width2,
            backWidth1: props.backWidth1,
            backWidth2: props.backWidth2,
            depth1: props.depth1,
            depth2: props.depth2,
            thickness,
          }

          itemProps.matrix = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            -props.height / 2,
            0,
            1,
          ]
          itemProps.render = true

          itemsPropsList.push(itemProps)
        }
      }
    }

    // const additionalItem = itemsPropsList.find(i => i.name === 'Additional Item')

    // if (additionalItem) {
    //     const _props = {} as { [key: string]: number }

    //     for (const iProps of itemsPropsList.filter(i => (i.name !== 'Additional Item' && i.render))) {
    //         for (const key in iProps.props) {
    //             // @ts-ignore
    //             if (typeof iProps.props[key] === 'number') {
    //                 // @ts-ignore
    //                 _props[iProps.name + '_' + key] = iProps.props[key]
    //             }
    //         }
    //     }

    //     additionalItem.props = {
    //         type: 'additional',
    //         cabinetWidth: props.width,
    //         cabinetHeight: props.height,
    //         cabinetDepth: props.depth,
    //         ..._props
    //     }
    // }

    if (this.scene.userData.isCornerTypeChanged)
      this.scene.userData.isCornerTypeChanged = false

    this.addSectionToScene(
      section,
      calculateCornerSectionTransform(
        props.width1,
        props.width2,
        props.depth1,
        props.depth2,
        thickness
      )
    )
    this.selecting.checkIfSelected(section)

    this.props.setSection(section)

    this.props.setItemsPropsList(itemsPropsList)

    this.setSectionPoses(
      this.selecting.getSectionsPoses(props.sectionProps.width)
    )

    // saveCornerCabinetPropsInLocalStorage(props, this.props.doorType, this.props.doorVisualType, this.props.legProps, this.props.splittedTop, this.props.cabinetType)
    this.saveCabinetInLS('cornerCabinetInfo', true)
    this.saveCabinetInLS('exportCabinetInfo')

    // console.timeEnd('createCabinet')
  }

  getHandleConfigs = (
    type: HandlePropsType['type'],
    subType: HandlePropsType['subtype'],
    defaultConfigs: ConfigsType['handleConfig']
  ) => {
    let legDist = defaultConfigs.legDist
    let legDiameter = defaultConfigs.legDiameter
    let distFromVerticalEdge =
      newHandleConfigs.distFromVerticalEdge.standard + legDist / 2

    if (type === 'knob') {
      if (subType === 'DHK401') {
        distFromVerticalEdge = newHandleConfigs.distFromVerticalEdge['knob401']
        legDiameter = newHandleConfigs.legDiameter['knob401']
      } else if (subType === 'DHK501') {
        distFromVerticalEdge = newHandleConfigs.distFromVerticalEdge['knob501']
        legDiameter = newHandleConfigs.legDiameter['knob501']
      } else {
        distFromVerticalEdge = newHandleConfigs.distFromVerticalEdge['knob301']
        legDiameter = newHandleConfigs.legDiameter['knob301']
      }
    } else if (type === 'pull') {
      if (subType === 'DHP306-96') {
        legDist = newHandleConfigs.legDist['DHP306-96']
        legDiameter = newHandleConfigs.legDiameter['DHP306-96']
        distFromVerticalEdge =
          newHandleConfigs.distFromVerticalEdge['DHP306-96'] + legDist / 2
      } else if (subType === 'DHP306-128') {
        legDist = newHandleConfigs.legDist['DHP306-128']
        legDiameter = newHandleConfigs.legDiameter['DHP306-128']
        distFromVerticalEdge =
          newHandleConfigs.distFromVerticalEdge['DHP306-128'] + legDist / 2
      } else if (subType === 'DHP465-192') {
        legDist = newHandleConfigs.legDist['DHP465-192']
        legDiameter = newHandleConfigs.legDiameter['DHP465-192']
        distFromVerticalEdge =
          newHandleConfigs.distFromVerticalEdge['DHP465-192'] + legDist / 2
      } else if (subType === 'DHP504-76') {
        legDist = newHandleConfigs.legDist['DHP504-192']
        // legDiameter = newHandleConfigs.legDiameter['DHP504-192']
        distFromVerticalEdge =
          newHandleConfigs.distFromVerticalEdge['DHP504-192'] + legDist / 2
      } else if (subType === 'DHP180-128') {
        legDist = newHandleConfigs.legDist['DHP180-128']
        // legDiameter = newHandleConfigs.legDiameter['DHP180-128']
        distFromVerticalEdge =
          newHandleConfigs.distFromVerticalEdge['DHP180-128'] + legDist / 2
      } else if (subType === 'DHP305MB96') {
        legDist = newHandleConfigs.legDist['DHP305MB96']
        legDiameter = newHandleConfigs.legDiameter['DHP305MB96']
        distFromVerticalEdge =
          newHandleConfigs.distFromVerticalEdge['DHP305MB96'] + legDist / 2
      } else if (subType === 'DHP305MB128') {
        legDist = newHandleConfigs.legDist['DHP305MB128']
        legDiameter = newHandleConfigs.legDiameter['DHP305MB128']
        distFromVerticalEdge =
          newHandleConfigs.distFromVerticalEdge['DHP305MB128'] + legDist / 2
      } else if (subType === 'BP723812') {
        legDist = newHandleConfigs.legDist['BP723812']
        legDiameter = newHandleConfigs.legDiameter['BP723812']
        distFromVerticalEdge =
          newHandleConfigs.distFromVerticalEdge['BP723812'] + legDist / 2
      } else if (subType === 'BP873128') {
        legDist = newHandleConfigs.legDist['BP873128']
        legDiameter = newHandleConfigs.legDiameter['BP873128']
        distFromVerticalEdge =
          newHandleConfigs.distFromVerticalEdge['BP873128'] + legDist / 2
      } else if (subType === 'BP7470128') {
        legDist = newHandleConfigs.legDist['BP7470128']
        legDiameter = newHandleConfigs.legDiameter['BP7470128']
        distFromVerticalEdge =
          newHandleConfigs.distFromVerticalEdge['BP7470128'] + legDist / 2
      }
    }

    return { legDist, legDiameter, distFromVerticalEdge }
  }

  calculateDrawerHandleMatrix = (
    visualType: DrawerVisualType,
    handlePos: HandlePropsType['position'],
    type: HandlePropsType['type'],
    subType: HandlePropsType['subtype'],
    drawerHeight: number,
    handlePosX: HandlePropsType['positionX'],
    drawerWidth: number,
    handleConfig: ConfigsType['handleConfig']
  ) => {
    const matrix =
      subType === 'DHP504-76'
        ? [
            1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0 /*12 - x*/, 0 /*13 - y*/,
            0 /*14 - z*/, 1,
          ]
        : [
            2.220446049250313e-16, 1, 0, 0, -1, 2.220446049250313e-16, 0, 0, 0,
            0, 1, 0, 0 /*12 - x*/, 0 /*13 - y*/, 0 /*14 - z*/, 1,
          ]

    // let legDist = handleConfig.legDist
    // let legDiameter = handleConfig.legDiameter
    // let distFromVerticalEdge = handleConfig.distFromVerticalEdge

    // if (type === 'knob') {
    // } else if (type === 'pull') {
    //   if (subType === 'DHP306-96') {
    //     legDist = 9.6
    //     legDiameter = 1.7

    //     distFromVerticalEdge -= (handleConfig.legDist - legDist) / 2
    //   } else if (subType === 'DHP465-192') {
    //     legDist = 19.2
    //     legDiameter = 1.1

    //     distFromVerticalEdge -= (handleConfig.legDist - legDist) / 2
    //   }
    // }

    const { legDist, distFromVerticalEdge, legDiameter } =
      this.getHandleConfigs(type, subType, handleConfig)

    // if (type === 'knob') {
    //   legDist = 0
    //   distFromVerticalEdge -= (handleConfig.legDist - legDist) / 2
    // }
    // if (type === 'pull') {
    //   if (subType === 'DHP306-96') {
    //     legDist = newHandleConfigs.legDist['DHP306-96']
    //     legDiameter = newHandleConfigs.legDiameter['DHP306-96']
    //     distFromVerticalEdge -= (handleConfig.legDist - legDist) / 2
    //   } else if (subType === 'DHP465-192') {
    //     legDist = newHandleConfigs.legDist['DHP465-192']
    //     legDiameter = newHandleConfigs.legDiameter['DHP465-192']
    //     distFromVerticalEdge -= (handleConfig.legDist - legDist) / 2
    //   } else if (subType === 'DHP504-76') {
    //     legDist = newHandleConfigs.legDist['DHP504-192']
    //     distFromVerticalEdge -= (handleConfig.legDist - legDist) / 2
    //   } else if (subType === 'DHP180-128') {
    //     legDist = newHandleConfigs.legDist['DHP180-128']
    //     distFromVerticalEdge -= (handleConfig.legDist - legDist) / 2
    //   }
    // }

    if (handlePosX === 'left') {
      matrix[12] = -drawerWidth / 2 + distFromVerticalEdge
    } else if (handlePosX === 'right') {
      matrix[12] = drawerWidth / 2 - distFromVerticalEdge
    } else if (typeof handlePosX === 'number') {
      matrix[12] = -drawerWidth / 2 + legDist / 2 + handlePosX
    }

    let distY = this.props.configs.drawerConfig.handleRevalFromTop
    if (visualType.startsWith('#')) {
      // @ts-ignore
      distY = newDoorPullX[visualType]
    } else if (visualType === 'fivePieces') {
      distY = newDoorPullX['fivePieces']
    }

    if (handlePos === 'forDrawer') {
      matrix[13] = drawerHeight / 2 - distY
    } else if (handlePos === 'forDrawerCenter') {
      matrix[13] = 0
    } else if (typeof handlePos === 'number') {
      matrix[13] = -(drawerHeight / 2 - handlePos) + legDiameter / 2
    }

    matrix[14] =
      type === 'pull' && subType === 'standard'
        ? this.props.configs.thickness
        : this.props.configs.thickness / 2

    return matrix
  }

  calculateDrawerDoubleHandleMatrix = (
    visualType: DrawerVisualType,
    handlePos: HandlePropsType['position'],
    handlePosX: HandlePropsType['positionX'],
    type: HandlePropsType['type'],
    subType: HandlePropsType['subtype'],
    drawerHeight: number,
    drawerWidth: number,
    isLeft: boolean,
    handleConfig: ConfigsType['handleConfig']
  ) => {
    const distFromEdge = 15

    const matrix =
      subType === 'DHP504-76'
        ? [
            1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0 /*12 - x*/, 0 /*13 - y*/,
            0 /*14 - z*/, 1,
          ]
        : [
            2.220446049250313e-16, 1, 0, 0, -1, 2.220446049250313e-16, 0, 0, 0,
            0, 1, 0, 0 /*12 - x*/, 0 /*13 - y*/, 0 /*14 - z*/, 1,
          ]

    let legDist = handleConfig.legDist

    if (type === 'knob') {
      legDist = 0
    } else if (type === 'pull') {
      if (subType === 'DHP306-96') {
        legDist = newHandleConfigs.legDist['DHP306-96']
      } else if (subType === 'DHP306-128') {
        legDist = newHandleConfigs.legDist['DHP306-128']
      } else if (subType === 'DHP465-192') {
        legDist = newHandleConfigs.legDist['DHP465-192']
      } else if (subType === 'DHP504-76') {
        legDist = newHandleConfigs.legDist['DHP504-192']
      } else if (subType === 'DHP180-128') {
        legDist = newHandleConfigs.legDist['DHP180-128']
      } else if (subType === 'DHP305MB96') {
        legDist = newHandleConfigs.legDist['DHP305MB96']
      } else if (subType === 'DHP305MB128') {
        legDist = newHandleConfigs.legDist['DHP305MB128']
      } else if (subType === 'BP723812') {
        legDist = newHandleConfigs.legDist['BP723812']
      } else if (subType === 'BP873128') {
        legDist = newHandleConfigs.legDist['BP873128']
      } else if (subType === 'BP7470128') {
        legDist = newHandleConfigs.legDist['BP7470128']
      }
    }

    const { distFromVerticalEdge } = this.getHandleConfigs(
      type,
      subType,
      handleConfig
    )

    if (typeof handlePosX === 'number') {
      // if (isLeft) {
      //     matrix[12] = handlePosX
      // } else if (!isLeft) {
      //     matrix[12] = -handlePosX
      // }
      matrix[12] =
        (isLeft ? 1 : -1) * (-drawerWidth / 2 + handlePosX + legDist / 2)
    } else {
      matrix[12] = (isLeft ? 1 : -1) * (-drawerWidth / 2 + distFromVerticalEdge)
    }

    let distY = this.props.configs.drawerConfig.handleRevalFromTop
    if (visualType.startsWith('#')) {
      // @ts-ignore
      distY = newDoorPullX[visualType]
    } else if (visualType === 'fivePieces') {
      distY = newDoorPullX['fivePieces']
    }

    if (handlePos === 'forDrawer') {
      matrix[13] = drawerHeight / 2 - distY
    } else if (handlePos === 'forDrawerCenter') {
      matrix[13] = 0
    } else if (typeof handlePos === 'number') {
      matrix[13] =
        -(drawerHeight / 2 - handlePos) + handleConfig.legDiameter / 2
    }

    matrix[14] =
      type === 'pull' && subType === 'standard'
        ? this.props.configs.thickness
        : this.props.configs.thickness / 2

    return matrix
  }

  calculateLiftUpDoubleHandleMatrix = (
    handlePos: HandlePropsType['position'],
    handlePosX: HandlePropsType['positionX'],
    visualType: DoorVisualType,
    type: HandlePropsType['type'],
    subType: HandlePropsType['subtype'],
    doorHeight: number,
    doorWidth: number,
    isLeft: boolean,
    handleConfig: ConfigsType['handleConfig']
  ) => {
    const distFromEdge = 15

    const matrix =
      subType === 'DHP504-76'
        ? [
            1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0 /*12 - x*/, 0 /*13 - y*/,
            0 /*14 - z*/, 1,
          ]
        : [
            2.220446049250313e-16, 1, 0, 0, -1, 2.220446049250313e-16, 0, 0, 0,
            0, 1, 0, 0 /*12 - x*/, 0 /*13 - y*/, 0 /*14 - z*/, 1,
          ]

    let legDist = handleConfig.legDist

    if (type === 'pull') {
      if (subType === 'DHP306-96') {
        legDist = newHandleConfigs.legDist['DHP306-96']
      } else if (subType === 'DHP465-192') {
        legDist = newHandleConfigs.legDist['DHP465-192']
      } else if (subType === 'DHP504-76') {
        legDist = newHandleConfigs.legDist['DHP504-192']
      } else if (subType === 'DHP180-128') {
        legDist = newHandleConfigs.legDist['DHP180-128']
      } else if (subType === 'DHP305MB96') {
        legDist = newHandleConfigs.legDist['DHP305MB96']
      } else if (subType === 'DHP305MB128') {
        legDist = newHandleConfigs.legDist['DHP305MB128']
      } else if (subType === 'BP723812') {
        legDist = newHandleConfigs.legDist['BP723812']
      } else if (subType === 'BP873128') {
        legDist = newHandleConfigs.legDist['BP873128']
      } else if (subType === 'BP7470128') {
        legDist = newHandleConfigs.legDist['BP7470128']
      } else if (subType === 'DHP306-128') {
        legDist = newHandleConfigs.legDist['DHP306-128']
      }
    }

    const { distFromVerticalEdge } = this.getHandleConfigs(
      type,
      subType,
      handleConfig
    )

    if (typeof handlePosX === 'number') {
      // if (isLeft) {
      //     matrix[12] = handlePosX
      // } else if (!isLeft) {
      //     matrix[12] = -handlePosX
      // }
      matrix[12] =
        (isLeft ? 1 : -1) * (-doorWidth / 2 + handlePosX + legDist / 2)
    } else {
      matrix[12] = (isLeft ? 1 : -1) * (-doorWidth / 2 + distFromVerticalEdge)
    }

    let distY = handleConfig.distFromEdge

    if (visualType.startsWith('#')) {
      // @ts-ignore
      distY = newDoorPullX[visualType]
    } else if (visualType === 'fivePieces') {
      distY = newDoorPullX['fivePieces']
    }

    if (handlePos === 'bottom') {
      matrix[13] = -(doorHeight / 2 - distY) //+ handleConfig.legDiameter / 2
    } else if (typeof handlePos === 'number') {
      matrix[13] = -(doorHeight / 2 - handlePos) //+ handleConfig.legDiameter / 2
    }

    matrix[14] =
      type === 'pull' && subType === 'standard'
        ? this.props.configs.thickness
        : this.props.configs.thickness / 2

    return matrix
  }

  calculateLiftUpDoorHandleMatrix = (
    type: HandlePropsType['type'],
    subType: HandlePropsType['subtype'],
    panelHeight: number,
    handlePos: HandlePropsType['position'],
    handlePosX: HandlePropsType['positionX'],
    visualType: DoorVisualType,
    doorWidth: number,
    handleConfig: ConfigsType['handleConfig']
  ) => {
    const matrix =
      subType === 'DHP504-76'
        ? [
            1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0 /*12 - x*/, 0 /*13 - y*/,
            0 /*14 - z*/, 1,
          ]
        : [
            2.220446049250313e-16, 1, 0, 0, -1, 2.220446049250313e-16, 0, 0, 0,
            0, 1, 0, 0 /*12 - x*/, 0 /*13 - y*/, 0 /*14 - z*/, 1,
          ]

    // let legDist = handleConfig.legDist
    // let distFromVerticalEdge = handleConfig.distFromVerticalEdge

    // if (type === 'knob') {
    //   if (subType === 'DHK401') {
    //     distFromVerticalEdge = newHandleConfigs.distFromVerticalEdge['knob401']
    //   } else {
    //     distFromVerticalEdge = newHandleConfigs.distFromVerticalEdge['knob301']
    //   }
    // } else if (type === 'pull') {
    //   if (subType === 'DHP306-96') {
    //     legDist = newHandleConfigs.legDist['DHP306-96']
    //     distFromVerticalEdge =
    //       newHandleConfigs.distFromVerticalEdge['DHP306-96'] + legDist / 2
    //   } else if (subType === 'DHP465-192') {
    //     legDist = newHandleConfigs.legDist['DHP465-192']
    //     distFromVerticalEdge =
    //       newHandleConfigs.distFromVerticalEdge['DHP465-192'] + legDist / 2
    //   } else if (subType === 'DHP504-76') {
    //     legDist = newHandleConfigs.legDist['DHP504-192']
    //     distFromVerticalEdge =
    //       newHandleConfigs.distFromVerticalEdge['DHP504-192'] + legDist / 2
    //   } else if (subType === 'DHP180-128') {
    //     legDist = newHandleConfigs.legDist['DHP180-128']
    //     distFromVerticalEdge =
    //       newHandleConfigs.distFromVerticalEdge['DHP180-128'] + legDist / 2
    //   }
    // }
    const { legDist, distFromVerticalEdge } = this.getHandleConfigs(
      type,
      subType,
      handleConfig
    )

    if (handlePosX === 'left') {
      matrix[12] = -doorWidth / 2 + distFromVerticalEdge
    } else if (handlePosX === 'right') {
      matrix[12] = doorWidth / 2 - distFromVerticalEdge
    } else if (typeof handlePosX === 'number') {
      matrix[12] = -doorWidth / 2 + legDist / 2 + handlePosX
    }

    let distY = handleConfig.distFromEdge

    if (visualType.startsWith('#')) {
      // @ts-ignore
      distY = newDoorPullX[visualType]
    } else if (visualType === 'fivePieces') {
      distY = newDoorPullX['fivePieces']
    }

    if (handlePos === 'bottom') {
      matrix[13] = -(panelHeight / 2 - distY) //+ handleConfig.legDiameter / 2
    } else if (typeof handlePos === 'number') {
      matrix[13] = -(panelHeight / 2 - handlePos) // + handleConfig.legDiameter / 2
    }

    matrix[14] =
      type === 'pull' && subType === 'standard'
        ? this.props.configs.thickness
        : this.props.configs.thickness / 2

    return matrix
  }

  calculateHandlePosition = (
    type: HandlePropsType['type'],
    subType: HandlePropsType['subtype'],
    isVertical: boolean,
    doorItemProps:
      | DoorItemPropsType
      | NewDoorItemPropsType
      | FivePiecesDoorItemPropsType,
    doorY: number,
    handlePos: HandlePropsType['position'],
    handlePosX: HandlePropsType['positionX'],
    doubleHandleXPos?: 'left' | 'right',
    positionFromGroundValue?: number
  ) => {
    const matrix = [
      1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0 /*12 - x*/, 0 /*13 - y*/,
      0 /*14 - z*/, 1,
    ]

    const doorWidth = doorItemProps.width
    const doorHeight = doorItemProps.height

    const handleConfig = this.props.configs.handleConfig
    const thickness = this.props.configs.thickness

    const { legDist, legDiameter } = this.getHandleConfigs(
      type,
      subType,
      handleConfig
    )

    let distFromLegCenterToCenter = (legDist + legDiameter) / 2

    let distX = newDoorPullX['standard']
    const distY = doorPoolY

    if (
      doorItemProps.type === 'newDoor' ||
      doorItemProps.type === 'fivePiecesDoor'
    ) {
      distX = newDoorPullX[doorItemProps.visualType]
    }

    if (doorItemProps.subType === 'double') {
      if (typeof handlePosX === 'number') {
        if (doubleHandleXPos === 'left') {
          if (isVertical) {
            matrix[12] = -handlePosX
          } else {
            matrix[12] = handlePosX
          }
        } else if (doubleHandleXPos === 'right') {
          if (isVertical) {
            matrix[12] = handlePosX
          } else {
            matrix[12] = -handlePosX
          }
        }
      } else {
        if (doubleHandleXPos === 'left') {
          if (isVertical) {
            matrix[12] = -distX
          } else {
            matrix[12] = distY
          }
        } else if (doubleHandleXPos === 'right') {
          if (isVertical) {
            matrix[12] = distX
          } else {
            matrix[12] = -distY
          }
        }
      }
    } else if (handlePosX === 'left') {
      //right door
      if (isVertical) {
        matrix[12] = -doorWidth / 2 + distX
      } else {
        matrix[12] = -doorWidth / 2 + (handlePos === 'center' ? distX : distY)
      }
    } else if (handlePosX === 'right') {
      //left door
      if (isVertical) {
        matrix[12] = doorWidth / 2 - distX
      } else {
        matrix[12] = doorWidth / 2 - (handlePos === 'center' ? distX : distY)
      }
    } else if (handlePosX === 'center') {
      if (isVertical) {
        matrix[12] = 0 //doorWidth / 2 - distFromEdge
      } else {
        matrix[12] = legDist / 2 //0 //doorWidth / 2 - handleConfig.distFromVerticalEdge
      }
    } else if (typeof handlePosX === 'number') {
      if (doorItemProps.subType === 'right') {
        matrix[12] = -doorWidth / 2 + handlePosX
      } else {
        matrix[12] = -doorWidth / 2 + (isVertical ? 0 : legDist) + handlePosX
      }
    }

    matrix[14] =
      type === 'pull' && subType === 'standard' ? thickness : thickness / 2

    if (handlePos === 'top') {
      if (isVertical) {
        matrix[13] = doorHeight / 2 - distY
        matrix[13] -= isVertical ? distFromLegCenterToCenter : legDiameter / 2
      } else {
        matrix[13] = doorHeight / 2 - distX
      }
    } else if (handlePos === 'bottom') {
      if (isVertical) {
        matrix[13] = -(doorHeight / 2 - distY)
        matrix[13] += isVertical ? distFromLegCenterToCenter : legDiameter / 2
      } else {
        matrix[13] = -doorHeight / 2 + distX
      }
    } else if (handlePos === 'center') {
      matrix[13] = 0
    } else if (handlePos === 'fromGround') {
      const height = !this.props.isCorner
        ? this.props.cabinetProps.height
        : this.props.cornerCabinetProps.height
      const legHeight = !this.props.isCorner
        ? this.props.cabinetProps.legHeight
        : this.props.cornerCabinetProps.legHeight

      const fromGroundValue =
        positionFromGroundValue ?? this.props.configs.handlePositionFromGround

      matrix[13] = -doorY + (fromGroundValue - legHeight) - height / 2 //+ handleConfig.legDist / 2 + handleConfig.legDiameter / 2
      // console.log(doorY, matrix[13])
    } else if (typeof handlePos === 'number') {
      matrix[13] = -(doorHeight / 2 - handlePos) + distFromLegCenterToCenter
    }

    // if (!isVertical) {
    //   const temp = matrix[12]
    //   matrix[12] = -matrix[13]
    //   matrix[13] = -temp
    // }

    return matrix
  }

  calculateCornerTwoDoorHandlePosition = (
    type: HandlePropsType['type'],
    subType: HandlePropsType['subtype'],
    visualType: DoorVisualType,
    doorItemProps: CornerTwoDoorItemPropsType,
    doorPos: Vector3,
    handlePos: HandlePropsType['position'],
    handlePosX: HandlePropsType['positionX'],
    isVertical: boolean
  ) => {
    const matrix =
      doorItemProps.subType === 'right'
        ? [
            2.220446049250313e-16, -0, -1, 0, 0, 1, -0, 0, 1, 0,
            2.220446049250313e-16, 0, 0, 0, 0, 1,
          ]
        : [
            1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0 /*12 - x*/, 0 /*13 - y*/,
            0 /*14 - z*/, 1,
          ]

    const doorHeight = doorItemProps.height

    const handleConfig = this.props.configs.handleConfig

    const { legDist, legDiameter } = this.getHandleConfigs(
      type,
      subType,
      handleConfig
    )

    let distX = newDoorPullX['standard']
    const distY = doorPoolY

    if (visualType.startsWith('#')) {
      // @ts-ignore
      distX = newDoorPullX[visualType]
    } else if (visualType === 'fivePieces') {
      distX = newDoorPullX['fivePieces']
    }

    if (doorItemProps.subType === 'right') {
      matrix[12] =
        -(doorItemProps.width2 + doorItemProps.thickness) / 2 +
        doorItemProps.thickness / 2 +
        (handleConfig.legLength + handleConfig.diameter) / 2

      if (typeof handlePosX === 'number') {
        matrix[14] =
          (doorItemProps.width1 + doorItemProps.thickness) / 2 - handlePosX
      } else {
        if (isVertical) {
          matrix[14] =
            (doorItemProps.width1 + doorItemProps.thickness) / 2 - distX
        } else {
          matrix[14] =
            (doorItemProps.width1 + doorItemProps.thickness) / 2 -
            (handlePos === 'center' ? distX : distY)
        }
      }
    } else {
      // if (doorItemProps.subType === 'left') {

      if (typeof handlePosX === 'number') {
        matrix[12] =
          (doorItemProps.width2 + doorItemProps.thickness) / 2 - handlePosX
      } else {
        if (isVertical) {
          matrix[12] =
            (doorItemProps.width2 + doorItemProps.thickness) / 2 - distX
        } else {
          matrix[12] =
            (doorItemProps.width2 + doorItemProps.thickness) / 2 -
            (handlePos === 'center' ? distX : distY)
        }
      }
      matrix[14] =
        -(doorItemProps.width1 + doorItemProps.thickness) / 2 +
        doorItemProps.thickness / 2 +
        (handleConfig.legLength + handleConfig.diameter) / 2
    }

    if (handlePos === 'top') {
      if (isVertical) {
        matrix[13] = doorHeight / 2 - legDist / 2 - distY
      } else {
        matrix[13] = doorHeight / 2 - distX
      }
    } else if (handlePos === 'bottom') {
      if (isVertical) {
        matrix[13] = -(doorHeight / 2) + legDist / 2 + distY
      } else {
        matrix[13] = -(doorHeight / 2) + distX
      }
    } else if (handlePos === 'center') {
      matrix[13] = 0
    } else if (handlePos === 'fromGround') {
      // matrix[13] = -doorY - (this.props.cabinetProps.height / 2 - this.props.configs.handlePositionFromGround) + handleConfig.legDist / 2 + handleConfig.legDiameter / 2
      matrix[13] =
        -doorPos.y +
        (this.props.configs.handlePositionFromGround -
          this.props.cornerCabinetProps.legHeight) -
        this.props.cornerCabinetProps.height / 2 //+ handleConfig.legDist / 2 + handleConfig.legDiameter / 2
      // console.log(doorPos.y, matrix[13])
    } else if (typeof handlePos === 'number') {
      matrix[13] = -(doorHeight / 2 - handlePos) + legDist / 2 + legDiameter / 2
    }

    return matrix
  }

  resolveSplitter(
    splitter: string | undefined,
    panelHeight: number,
    sectionY: number,
    cabinetHeight: number,
    legHeight: number
  ) {
    if (!splitter) return ''
    const match = splitter.match(
      /^[gG]([0-9.]+)(?:_([a-zA-Z]))?(?:_([a-zA-Z]))?$/
    )
    if (match) {
      const fromGroundValue = parseFloat(match[1])
      const bottomLetter =
        match[2] && match[2].toUpperCase() !== 'N' ? match[2].toUpperCase() : ''
      const topLetter =
        match[3] && match[3].toUpperCase() !== 'N' ? match[3].toUpperCase() : ''
      if (!isNaN(fromGroundValue)) {
        const sectionBottomFromGround =
          legHeight + cabinetHeight / 2 + sectionY - panelHeight / 2
        const bottomSegment = fromGroundValue - sectionBottomFromGround
        const topSegment = panelHeight - bottomSegment
        return `${bottomLetter}${bottomSegment.toFixed(2)},${topLetter}${topSegment.toFixed(2)}`
      }
    }
    return splitter
  }

  removeSectionFromScene = () => {
    const removableChildren = []

    for (const child of this.scene.children) {
      if (child.name.includes('section') || child.name.includes('divider')) {
        removableChildren.push(child)
      }
    }

    for (const child of removableChildren) {
      this.scene.remove(child)
    }
  }

  addSectionToScene = (
    section: Section,
    pos: number | { x: number; z: number; angle: number }
  ) => {
    this.removeSectionFromScene()

    if (typeof pos === 'number') {
      if (section.dividers.length > 0) {
        for (const subSection of section.sections) {
          subSection.object.position.z = pos / 2
          this.addSceneChild(subSection.object)
        }

        for (const divider of section.dividers) {
          divider.object.position.z = pos / 2 + 0.05
          this.addSceneChild(divider.object)
        }
      } else {
        this.addSceneChild(section.object)
        section.object.position.z = pos / 2
      }
    } else {
      if (section.dividers.length > 0) {
        for (const subSection of section.sections) {
          subSection.object.position.x = pos.x
          subSection.object.position.z = pos.z
          subSection.object.rotation.y = pos.angle
          this.addSceneChild(subSection.object)
        }

        for (const divider of section.dividers) {
          divider.object.position.x = pos.x + 0.05
          divider.object.position.z = pos.z + 0.05
          divider.object.rotation.y = pos.angle
          this.addSceneChild(divider.object)
        }
      } else {
        this.addSceneChild(section.object)
        section.object.position.x = pos.x
        section.object.position.z = pos.z
        section.object.rotation.y = pos.angle
      }
    }
  }

  visualizeItems = (itemsProps: ItemPropsType[]) => {
    // console.time('visualizeItems')

    const items = function makeItems(
      this: Three,
      itemsProps: ItemPropsType[],
      parentItem?: Item
    ) {
      const items = [] as Array<Item>
      for (const itemProps of itemsProps) {
        if (itemProps.render) {
          const item = new Item(
            itemProps.name,
            itemProps.props,
            this.createHardwares(itemProps.hardwaresProps),
            itemProps.links,
            itemProps.addon,
            this.props.configs,
            parentItem
          )

          item.object3D.applyMatrix4(new Matrix4().fromArray(itemProps.matrix))

          if (parentItem) {
            const index = parentItem.object3D.children.findIndex(
              (child) => child.name === item.name
            )
            if (index === -1) parentItem.object3D.add(item.object3D)
            else parentItem.object3D.children[index] = item.object3D
          } else {
            const index = this.scene.children.findIndex(
              (child) => child.name === item.name
            )
            if (index === -1) this.scene.add(item.object3D)
            else this.scene.children[index] = item.object3D
          }

          //for Doors
          if (item.object3D.userData.isDoor || item.object3D.userData.isDrawer)
            item.object3D.visible = this.props.isFrontPanelsVisible

          if (itemProps.childrenProps.length > 0)
            item.children = makeItems.call(this, itemProps.childrenProps, item)

          items.push(item)
        }
      }

      return items
    }.call(this, itemsProps)

    this.props.setItems(items)
    this.needRender = true

    // console.timeEnd('visualizeItems')
  }

  createHardwares = (hProps: ItemPropsType['hardwaresProps']) => {
    const hardwares = [] as Array<Hardware>
    // let lastLocalId = Math.max(...ids.map(id => id.localId), 0)

    for (const id of hProps) {
      const hProps = this.props.hardwaresList.find((h) => h.id === id.id)
      const markupValue = this.props.markups.find(
        (m) => m.id === hProps?.markupId
      )?.value

      if (hProps !== undefined && markupValue !== undefined) {
        const childrenIds = [] as {
          id: number
          localId: number
          count: number
        }[]
        let lastLocalId = 0

        hProps.childrenIds.forEach((id) => {
          lastLocalId++
          childrenIds.push({ id, localId: lastLocalId, count: 1 })
        })

        // const materialsProps = this.props.materials.filter(m => hProps.materialsIds.includes(m.id))
        // const materials = materialsProps.map(m => new Material(m.id, m.name, m.price, m.addon, m.texture))

        if (this.state.ovveridenMaterials) {
          const [cabMatId, doorMatId] = this.state.ovveridenMaterials

          const cabinetGroupId = 'g10'
          const panelGroupIds = ['g9', 'g24', 'g21', 'g25']

          if (hProps.materialsIds.includes(cabinetGroupId)) {
            hProps.defaultMaterialId = cabMatId
          } else if (
            hProps.materialsIds.some((id) => panelGroupIds.includes(id))
          ) {
            hProps.defaultMaterialId = doorMatId
          }
        }

        const materialProps = this.props.materials.find(
          (m) => m.id === hProps.defaultMaterialId
        )
        let material
        // console.log(hProps.id, materialProps?.threeProps)
        if (materialProps)
          material = new Material(
            materialProps.id,
            materialProps.name,
            materialProps.weight,
            materialProps.price,
            materialProps.addon,
            materialProps.texture.texture,
            materialProps.length,
            materialProps.width,
            materialProps.threeProps
          )

        hardwares.push(
          new Hardware(
            id,
            hProps.name,
            hProps.type,
            hProps.unitWeight,
            hProps.unitPrice,
            hProps.unitPriceAddon,
            hProps.addonD,
            hProps.addonP,
            hProps.minPrice,
            markupValue,
            material,
            this.createHardwares(childrenIds),
            this.props.configs.drawerConfig,
            this.props.configs.hingeBreakpoints
          )
        )
      }
    }

    return hardwares
  }

  initOutline = () => {
    //Outline settings
    this.outlinePass.edgeGlow = 0.5
    // this.outlinePass.visibleEdgeColor.set('#ffffff') // default
    // this.outlinePass.pulsePeriod = 0 // default
    // this.outlinePass.edgeStrength = 3 //default

    this.composer.addPass(this.renderPass)
    this.composer.addPass(this.outlinePass)
    this.composer.addPass(this.effectFXAA)
  }

  init = () => {
    // this.renderer.setPixelRatio(window.devicePixelRatio)

    // alert(window.devicePixelRatio + '_' + this.renderer.getPixelRatio())
    // this.renderer.setClearColor('#ff0000')
    // this.renderer.setClearColor('#fafafa')
    this.renderer.setClearColor('#f0efe1')
    // this.renderer.shadowMap.enabled = true
    // this.renderer.shadowMap.type = PCFSoftShadowMap

    // Light settings
    // this.light.position.set(0, 350, 0)
    // this.light2.position.set(1000, 1000, 0)
    // this.light2.castShadow = true
    // const lightGroup =
    new LightGroup(this.scene, 400, 400, 0.55)
    // const light = new PointLight(undefined, 1)
    // light.position.set(200, 50, 0)
    // this.scene.add(light)
    // this.scene.add(new PointLightHelper(light))

    // Controlers settings
    // this.orbit.screenSpacePanning = true

    this.camera.position.set(160, 160, 160)
    this.camera.lookAt(0, 0, 0)

    // const cube = new Mesh(
    //     new BoxGeometry(),
    //     new MeshNormalMaterial()
    // )

    // this.createCabinet(this.props.cabinetProps, this.props.itemsPropsList)
    // if (!this.props.isCorner) {
    //     this.props.setWidth(this.props.cabinetProps.width, this.props.configs.thickness)
    //     this.props.setHeight(this.props.cabinetProps.height, this.props.configs.thickness, false)
    // }
    // else {
    //     console.log("setCinit");

    //     this.props.setCHeight(this.props.cornerCabinetProps.height, this.props.configs.thickness, false)
    // }

    // const newProps = !this.props.isCorner
    //     ? recalculateAllShelvesAndDoorsPositions(
    //         this.props.cabinetProps.sectionProps.dividersProps.sort((a, b) => a.top - b.top),
    //         this.props.cabinetProps.height,
    //         this.props.cabinetProps.sectionProps.shelvesProps,
    //         this.props.cabinetProps.sectionProps.doorsProps,
    //         this.props.cabinetProps.sectionProps.drawersProps,
    //         this.props.configs.thickness
    //     )
    //     : recalculateAllShelvesAndDoorsPositions(
    //         this.props.cornerCabinetProps.sectionProps.dividersProps.sort((a, b) => a.top - b.top),
    //         this.props.cornerCabinetProps.height,
    //         this.props.cornerCabinetProps.sectionProps.shelvesProps,
    //         this.props.cornerCabinetProps.sectionProps.doorsProps,
    //         this.props.cornerCabinetProps.sectionProps.drawersProps,
    //         this.props.configs.thickness
    //     )

    // this.props.setShelves(newProps.shelvesProps)
    // this.props.setDoors(newProps.doorsProps)
    // this.props.setDrawers(newProps.drawersProps)

    // this.visualizeItems(this.props.itemsPropsList)
    this.outlinePass.selectedObjects = this.scene.children.filter((child) =>
      this.props.openItemsName.includes(child.name)
    )

    this.initOutline()
    this.renderScene()
  }

  handleWindowResize = (winWidth: number, winHeight: number) => {
    const width = winWidth * this.props.myWidth
    const height = winHeight - 48

    this.props.setSidebarHeight(
      winWidth < 960 ? winHeight * 0.5 - 48 - 48 : winHeight - 48
    )

    this.renderer.setSize(width, height)

    this.composer.setSize(width, height)
    this.effectFXAA.uniforms['resolution'].value.set(1 / width, 1 / height)
    this.outlinePass.resolution = new Vector2(width, height)

    this.camera.aspect = width / height
    this.camera.updateProjectionMatrix()

    this.renderScene()
  }

  addSceneChild = (child: Object3D) => {
    const index = this.scene.children.findIndex((ch) => ch.name === child.name)

    if (index === -1) this.scene.add(child)
    else this.scene.children[index] = child

    this.setNeedRender(true)
  }

  removeSceneChild = (child: Object3D) => {
    const index = this.scene.children.findIndex((ch) => ch.name === child.name)

    if (index !== -1) this.scene.remove(this.scene.children[index])

    this.setNeedRender(true)
  }

  onMouseDown = (e: MouseEvent) => {
    if (e.ctrlKey) {
      if (this.renderer.domElement.parentElement) {
        this.mouse.x =
          ((e.clientX - this.renderer.domElement.parentElement.offsetLeft) /
            this.renderer.domElement.clientWidth) *
            2 -
          1
        this.mouse.y =
          -(
            (e.clientY - this.renderer.domElement.parentElement.offsetTop) /
            this.renderer.domElement.clientHeight
          ) *
            2 +
          1

        this.raycater.setFromCamera(this.mouse, this.camera)

        let intersected = this.raycater.intersectObjects(
          this.scene.children.filter(
            (child) =>
              !['Light Group', 'section', 'divider', 'vdivider'].includes(
                child.name.split('_')[0]
              )
          ),
          true
        )

        if (intersected.length) {
          const intersectedMesh = intersected[0].object
          const name =
            intersectedMesh.name !== ''
              ? intersectedMesh.name
              : intersectedMesh.parent?.name || ''

          if (e.shiftKey) {
            let hId = 0

            for (const id of this.props.itemsPropsList.find(
              (i) => i.name === name
            )?.hardwaresProps || []) {
              for (const hardwareProps of this.props.hardwaresList) {
                if (
                  id.id === hardwareProps.id &&
                  hardwareProps.materialsIds.length > 0
                )
                  hId = id.id

                if (hId !== 0) break
              }

              if (hId !== 0) break
            }

            if (e.altKey) {
              this.props.openMaterialDetails(
                this.props.hardwaresList.find((h) => h.id === hId)
                  ?.defaultMaterialId || 0
              )
            } else {
              this.props.openHardwareDetails(hId)
            }

            window?.getSelection()?.removeAllRanges()
          } else {
            if (this.props.isDemo || this.props.user?.role === 'admin') {
              this.props.setActiveTab(1)
              this.props.setOpenItem(name)
            }
          }
        }
      }
    }
  }

  onKeyDown = async (e: KeyboardEvent) => {
    if (e.ctrlKey && e.key === 's') {
      e.preventDefault()

      // const rendererRatio = this.renderer.getSize(new Vector2()).height / this.renderer.getSize(new Vector2()).width
      // const image = await resizeBase64Img(this.screenshot(), 500, 500 * rendererRatio)
      const image = this.screenshot()
      localStorage.setItem('sceneImage', image)

      this.setState(
        {
          isPreviewOpen: true,
        },
        () => {
          setTimeout(() => {
            this.setState({ isPreviewOpen: false })
          }, 5000) //5 Second delay
        }
      )
      // const cabInfo = localStorage.getItem('exportCabinetInfo') ? JSON.parse(localStorage.getItem('exportCabinetInfo') || '') : undefined

      // if (cabInfo) {
      //     const title = prompt('Write Cabinet title')

      //     if (title) {
      //         const cabProps = {
      //             title,
      //             name: cabInfo.name,
      //             additional: cabInfo.additional
      //         } as CabPropsType

      //         this.props.addCabinet(cabProps, this.props.enqueueSnackbar)
      //     }
      // }
    } else if (e.ctrlKey && e.key === 'l') {
      e.preventDefault()

      const id = prompt(
        'write id of cabinet, here is ids of available cabinets - ' +
          this.props.userCabinets.map((c) => c.id).join(',')
      )

      if (id) {
        const cab = this.props.userCabinets.find((c) => c.id === parseInt(id))

        if (cab) {
          this.loadCabinet(
            cab.name,
            cab.additional ? JSON.parse(cab.additional) : undefined
          )
        }
      }
    } else if (e.code == 'Numpad9' && e.ctrlKey) {
      //numpad 1
      e.preventDefault()
      this.positionHelper.activate()
    }
  }

  start = () => {
    this.init()
    if (!this.frameId) {
      this.frameId = requestAnimationFrame(this.animate)
    }
  }

  stop = () => {
    cancelAnimationFrame(this.frameId)
    window.removeEventListener('resize', () => {
      this.props.setWindowSize(window.innerWidth, window.innerHeight)
    })
    window.removeEventListener('mousedown', this.onMouseDown)
    console.log('stop')
    window.removeEventListener('keydown', this.onKeyDown)

    this.orbit.dispose()
  }

  animate = () => {
    if (this.needRender) {
      this.renderScene()
      this.needRender = false
    }
    // console.log(this.props.section?.object.position)
    // this.renderScene()
    this.frameId = window.requestAnimationFrame(this.animate)
  }

  renderScene = (scene?: Scene) => {
    if (scene) {
      this.renderer.render(scene, this.camera)
      this.composer.render()
    } else {
      this.renderer.render(this.scene, this.camera)
      this.composer.render()
    }
  }

  onEditClick = () => {
    this.props.setIsSidebarOpen(true)
  }

  onSaveClick = () => {
    const cabInfo = localStorage.getItem('exportCabinetInfo')
      ? JSON.parse(localStorage.getItem('exportCabinetInfo') || '')
      : undefined

    if (cabInfo) {
      const title = this.props.actualCabinetTitle
      if (title) {
        const cabProps = {
          title,
          name: cabInfo.name,
          additional: cabInfo.additional,
          image: this.screenshot(),
        } as CabPropsType

        const cabId = this.props.userCabinets.find((c) => c.title === title)?.id

        if (cabId) {
          if (cabId === 1) {
            cabProps.image =
              this.props.userCabinets.find((c) => c.id === 1)?.image || ''
          }

          this.props.editCabinet(cabId, cabProps, this.props.enqueueSnackbar)
        } else this.props.addCabinet(cabProps, this.props.enqueueSnackbar)
      } else {
        showMessage(this.props.enqueueSnackbar, "Cabinet Title can't be empty")
      }
    }
  }

  onCatalogClick = () => {
    this.setState({ isCatalogOpen: true })
  }

  handleSectionHeightBlur = () => {
    const tempSection = this.state.tempSection
    const section = this.state.sectionPoses.find(
      (s) => s.name === tempSection?.name
    )

    if (tempSection && section) {
      this.props.setSubsectionHeight(
        tempSection.name,
        tempSection.height > 5 ? tempSection.height : 5,
        section.height,
        this.state.sectionLocks
      )
      this.setState({ tempSection: undefined })
    }
  }

  handleTempSectionHeightChange = (value: number, isSection: boolean) => {
    const temp = this.state.tempSection

    if (temp) {
      const delta = temp.panelHeight - temp.height
      if (isSection) {
        temp.height = value
        temp.panelHeight = value + delta
      } else {
        temp.height = value - delta
        temp.panelHeight = value
      }
    }

    this.setState({
      tempSection: temp,
    })
  }

  viewShelf = (
    count: number,
    centerY: number = 0,
    sectionHeight: number = 0,
    sectionName: string = '0_0'
  ) => {
    const ys = []

    let temp = centerY - sectionHeight / 2
    for (let i = 0; i < count; i++) {
      temp += sectionHeight / (count + 1)
      ys.push(temp)
    }

    this.hideShelfItems(
      sectionName === 'section' ? '1' : sectionName.split('_')[1]
    )
    this.removeTempShelves()

    ys.reverse().forEach((y, i) => {
      const shelf = !this.props.isCorner
        ? createSheet(
            this.props.cabinetProps.width - 2 * this.props.configs.thickness,
            this.props.cabinetProps.depth - this.props.configs.thickness,
            this.props.configs.thickness
          )
        : createCornerHorizontalSheet(
            this.props.cornerCabinetProps.type,
            this.props.cornerCabinetProps.width1,
            this.props.cornerCabinetProps.width2,
            this.props.cornerCabinetProps.depth1,
            this.props.cornerCabinetProps.depth2,
            this.props.cornerCabinetProps.backWidth1,
            this.props.cornerCabinetProps.backWidth2,
            this.props.cornerCabinetProps.thickness,
            true,
            undefined,
            0,
            0
          )

      shelf.name = 'tempShelf'
      shelf.position.y = y
      shelf.rotation.x += Math.PI / 2

      if (!this.props.isCorner)
        shelf.position.z += this.props.configs.thickness / 2 - 0.01

      shelf.userData.names =
        sectionName === 'section'
          ? '1_' + (i + 1).toString()
          : sectionName.split('_')[1] + '_' + (i + 1).toString()

      this.scene.add(shelf)
    })
  }

  viewTempDividers = (
    count: number,
    centerY: number = 0,
    sectionHeight: number = 0,
    sectionName: string = '0_0'
  ) => {
    const ys = []

    let temp = centerY - sectionHeight / 2
    for (let i = 0; i < count; i++) {
      temp += sectionHeight / (count + 1)
      ys.push(temp)
    }

    this.removeTempDividers()

    const dividerWidth = !this.props.isCorner
      ? this.props.cabinetProps.sectionProps.width
      : this.props.cornerCabinetProps.sectionProps.width

    const transform = !this.props.isCorner
      ? this.props.cabinetProps.depth / 2
      : calculateCornerSectionTransform(
          this.props.cornerCabinetProps.width1,
          this.props.cornerCabinetProps.width2,
          this.props.cornerCabinetProps.depth1,
          this.props.cornerCabinetProps.depth2,
          this.props.cornerCabinetProps.thickness
        )

    ys.reverse().forEach((y, i) => {
      const divider = createDivider(dividerWidth)

      divider.name = 'tempDivider'

      if (typeof transform === 'number') {
        divider.position.set(0, y, transform + 0.05)
      } else {
        divider.position.set(transform.x + 0.05, y, transform.z + 0.05)
        divider.rotation.y = transform.angle
      }

      this.scene.add(divider)
    })
  }

  addTempDividers = () => {
    const dividers = this.scene.children.filter(
      (child) => child.name === 'tempDivider'
    )

    const newDividers = [] as DividerPropsType[]

    const cabinetHeight = !this.props.isCorner
      ? this.props.cabinetProps.height
      : this.props.cornerCabinetProps.height

    for (const divider of dividers) {
      newDividers.push({
        type: 'none',
        top:
          (cabinetHeight - this.props.configs.thickness * 2) / 2 -
          divider.position.y,
        uuid: v4(),
      })
    }

    this.removeTempDividers()
    this.props.addDividers(newDividers)
  }

  hideShelfItems = (sectionNumber: string) => {
    for (const child of this.scene.children) {
      if (child.name.slice(0, 5) === 'Shelf') {
        if (child.name.split('_')[1] === sectionNumber) {
          child.visible = false
        }
      }
    }
  }

  unhideShelfItems = (sectionNumber: string = '-1') => {
    if (sectionNumber === 'all') {
      for (const child of this.scene.children) {
        if (child.name.slice(0, 5) === 'Shelf') {
          child.visible = true
        }
      }
    } else {
      for (const child of this.scene.children) {
        if (child.name.slice(0, 5) === 'Shelf') {
          if (child.name.split('_')[1] === sectionNumber) {
            child.visible = true
          }
        }
      }
    }
  }

  // deleteShelfItemsObjects = (sectionNumber: string = '-1') => {
  //     let removable = []

  //     for (const child of this.scene.children) {
  //         if (child.name.slice(0, 5) === 'Shelf') {
  //             if (child.name.split('_')[1] === sectionNumber) {
  //                 removable.push(child)
  //             }
  //         }
  //     }

  //     for (const child of removable)
  //         this.scene.remove(child)
  // }

  removeTempShelves = () => {
    let removable = this.scene.children.filter(
      (child) => child.name === 'tempShelf'
    )

    for (const child of removable) this.scene.remove(child)

    this.needRender = true
  }

  removeTempDividers = () => {
    let removable = this.scene.children.filter(
      (child) => child.name === 'tempDivider'
    )

    for (const child of removable) this.scene.remove(child)

    this.needRender = true
  }

  addShelvesAsItem = (itemsPropsList: ItemPropsType[]) => {
    // const shelfItemProps = itemsPropsList.find(props => props.name === 'shelf')

    // if (shelfItemProps) {
    //     const shelves = this.scene.children.filter(child => child.name === 'tempShelf')

    //     let sectionNumber = '-1'

    //     const shelvesProps = [] as ItemPropsType[]

    //     for (const shelf of shelves) {
    //         const name = 'Shelf_' + shelf.userData.names

    //         const oldItem = itemsPropsList.find(item => item.name === name)

    //         const props = oldItem ? clone(oldItem) : clone(shelfItemProps)
    //         props.name = name

    //         sectionNumber = shelf.userData.names.split('_')[0]

    //         props.props = {
    //             type: 'shelf',
    //             width: ((shelf as Mesh).geometry as BoxGeometry).parameters.height,
    //             length: ((shelf as Mesh).geometry as BoxGeometry).parameters.width,
    //             thickness: ((shelf as Mesh).geometry as BoxGeometry).parameters.depth
    //         }

    //         props.matrix = shelf.matrix.elements
    //         props.render = true

    //         shelvesProps.push(props)
    //     }

    //     this.deleteShelfItemsObjects(sectionNumber)

    this.removeTempShelves()

    //     this.props.addItemsProps(shelvesProps, true)
    // }
  }

  backToGC = () => {
    const addItionalItem = this.props.itemsPropsList.find(
      (i) => i.name === 'Additional Item'
    )

    const materialInfo = JSON.parse(this.props.gcInfo.cabinet).name.split(
      '|'
    )[8]

    const cabinetInfo = encodeURI(
      JSON.stringify({
        name: `0|${this.props.cabinetType[0]}|${
          this.props.cabinetProps.width
        };${this.props.cabinetProps.height};${
          this.props.cabinetProps.depth
        }|${this.props.cabinetProps.sectionProps.dividersProps
          .map((d) =>
            d.type === 'none'
              ? 'f' + d.top.toFixed(appConfig.fractionDigits)
              : 't' + d.top.toFixed(appConfig.fractionDigits)
          )
          .join(';')}|${this.props.cabinetProps.sectionProps.doorsProps
          .map(
            (d) =>
              d.type[0] +
              '_' +
              d.sectionNumber +
              '_' +
              (['top', 'center', 'bottom', 'fromGround'].includes(
                d.handleProps.position.toString()
              )
                ? d.handleProps.position.toString()[0]
                : d.handleProps.position.toString())
          )
          .join(';')}|${this.props.cabinetProps.sectionProps.drawersProps
          .map((d) => d.sectionNumber.toString())
          .join(';')}|${this.props.cabinetProps.sectionProps.shelvesProps
          .map((sh) => '' + sh.sectionNumber + '_' + sh.count)
          .join(';')}|${
          this.state.sectionLocks.find((s) => !s.isLock)?.number.toString() ||
          '0'
        }|${materialInfo}|${
          this.props.legProps.type === 'base'
            ? '0'
            : this.props.legProps.type === 'noToeKick'
              ? '1'
              : this.props.legProps.type === 'standard'
                ? '2'
                : '3'
        }`,
        additional: JSON.stringify({
          hardwareProps: addItionalItem ? addItionalItem.hardwaresProps : [],
          links: addItionalItem ? addItionalItem.links : [],
        }),
      })
    )

    const link = `http://${this.props.gcInfo.domain}/?h=${this.props.gcInfo.hash}&c=${cabinetInfo}`
    window.location.replace(link)
  }

  screenshot = () => {
    const orbitState = {
      target: new Vector3(0, 0, 0),
      position: new Vector3(
        -110.0253371295736,
        38.9472460799676,
        166.96464279841004
      ),
      zoom: 1,
    }

    const { width, height } = this.renderer.domElement
    // const rendererColor = '#f0efe1'

    const newWidth = 500
    const newHeight = (500 * height) / width

    this.renderer.setSize(newWidth, newHeight)
    // this.renderer.setClearColor('#e5e5e7', .9)

    this.composer.setSize(newWidth, newHeight)
    this.effectFXAA.uniforms['resolution'].value.set(
      1 / newWidth,
      1 / newHeight
    )
    // this.outlinePass.resolution = new Vector2(newWidth, newHeight)

    // this.outlinePass.visibleEdgeColor.set('#ffffff') // default
    // this.outlinePass.visibleEdgeColor.set('#ff0000')
    // this.outlinePass.edgeGlow = 0

    this.camera.aspect = newWidth / newHeight
    this.camera.updateProjectionMatrix()

    this.orbit.saveState()
    // @ts-ignore
    const currentOrbitState = {
      // @ts-ignore
      target: this.orbit.target0,
      // @ts-ignore
      position: this.orbit.position0,
      // @ts-ignore
      zoom: this.orbit.zoom0,
    }
    // @ts-ignore
    this.orbit.target0 = orbitState.target
    // @ts-ignore
    this.orbit.position0 = orbitState.position
    // @ts-ignore
    this.orbit.zoom0 = orbitState.zoom
    this.orbit.reset()

    const newScene = this.cloneSceneForScreenshot()

    // const customOutlinePass = new CustomOutlinePass(new Vector2(window.innerWidth * 0.75, window.innerHeight - 88), newScene, this.camera)

    this.renderPass.scene = newScene
    // this.composer.addPass(customOutlinePass)

    // this.outlinePass.selectedObjects = [...newScene.children]

    this.renderScene(newScene)

    const image = this.renderer.domElement.toDataURL()

    // this.renderer.setClearColor(rendererColor, 1)
    this.renderer.setSize(width, height)

    this.composer.setSize(width, height)
    this.effectFXAA.uniforms['resolution'].value.set(1 / width, 1 / height)
    // this.composer.removePass(customOutlinePass)
    // customOutlinePass.dispose()
    // this.outlinePass.resolution = new Vector2(width, height)
    // this.outlinePass.visibleEdgeColor.set('#ffffff')
    // this.outlinePass.edgeGlow = 0.5
    // this.outlinePass.selectedObjects = []

    // @ts-ignore
    this.orbit.target0 = currentOrbitState.target
    // @ts-ignore
    this.orbit.position0 = currentOrbitState.position
    // @ts-ignore
    this.orbit.zoom0 = currentOrbitState.zoom
    this.orbit.reset()

    this.camera.aspect = width / height
    this.camera.updateProjectionMatrix()

    this.renderPass.scene = this.scene

    this.renderScene()

    return image
  }

  cloneSceneForScreenshot = () => {
    const newScene = this.scene.clone()

    const removableChildren = []

    for (const child of newScene.children) {
      if (child.name.includes('section')) removableChildren.push(child)
    }

    for (const child of removableChildren) {
      newScene.remove(child)
    }

    // newScene.traverse((object) => {
    //     // @ts-ignore
    //     if (object.isMesh) {
    //         // @ts-ignore
    //         object.material = new MeshBasicMaterial({ color: 'white' })
    //         // object.material = object.material.clone()
    //     }
    // })

    return newScene
  }

  disposeScene = (scene: Scene) => {}

  unselectSection = () => {
    this.selecting.setSelectedSection(undefined)
    this.removeTempDividers()
    this.removeTempShelves()
    this.unhideShelfItems('all')
  }

  render() {
    return (
      <>
        <div
          className={'three'}
          style={{ position: 'relative' }}
          ref={(mount) => {
            this.myDiv = mount
          }}
        ></div>

        {/* Section unselect button */}
        <Slide direction="down" in={this.state.selectedSection !== undefined}>
          <Fab
            style={{
              position: 'absolute',
              left: (window.innerWidth * this.props.myWidth) / 2 - 20,
              top: 60,
            }}
            size="small"
            color="secondary"
            onClick={this.unselectSection}
          >
            <CloseIcon />
          </Fab>
        </Slide>

        {/* Section Actions */}
        <Fade in={this.state.selectedSection !== undefined}>
          <Box>
            {this.state.selectedSection &&
              (() => {
                this.unhideShelfItems('all')

                const sectionName = this.state.selectedSection
                  ? this.state.selectedSection.name
                  : '0_0'
                const selectedSectionNumber =
                  sectionName === 'section' ? '1' : sectionName.split('_')[1]
                const sectionHeight = this.state.selectedSection
                  ? this.state.selectedSection.height
                  : 0
                const panelHeight = this.state.sectionPoses.find(
                  (s) =>
                    s.name ===
                    (sectionName === 'section' ? 'section_1' : sectionName)
                )?.panelHeight
                const sectionY = this.state.selectedSection
                  ? this.state.selectedSection.y
                  : 0
                const sectionProps = !this.props.isCorner
                  ? this.props.cabinetProps.sectionProps
                  : this.props.cornerCabinetProps.sectionProps
                const doorProps = sectionProps.doorsProps.find(
                  (dProps) =>
                    dProps.sectionNumber === parseInt(selectedSectionNumber)
                )
                const drawerProps = sectionProps.drawersProps.find(
                  (dProps) =>
                    dProps.sectionNumber === parseInt(selectedSectionNumber)
                )

                return (
                  <SectionActions
                    isCorner={this.props.isCorner}
                    drawerSlideType={this.props.drawerSlideType}
                    isTwoDoorCorner={
                      this.props.isCorner &&
                      this.props.cornerCabinetProps.type === '2door'
                    }
                    cabinetDepth={this.props.cabinetProps.depth}
                    panelHeight={panelHeight ? panelHeight : 0}
                    legHeight={this.props.cabinetProps.legHeight}
                    cabinetHeight={this.props.cabinetProps.height}
                    sectionY={sectionY}
                    left={
                      this.state.selectedSection
                        ? this.state.selectedSection.left
                        : 0
                    }
                    top={
                      this.state.selectedSection
                        ? this.state.selectedSection.top
                        : 0
                    }
                    shelfCount={
                      this.state.selectedSection
                        ? this.scene.children.filter((child) => {
                            if (child.name.slice(0, 5) === 'Shelf') {
                              const sectionNumber = child.name.split('_')[1]
                              // const selectedSectionNumber = this.state.selectedSection?.name === 'section' ? '1' : this.state.selectedSection?.name.split('_')[1]
                              if (sectionNumber === selectedSectionNumber)
                                return true
                            }
                            return false
                          }).length
                        : 1
                    }
                    setDividerMode={(val) => {
                      this.selecting.setDividerMode(val)
                    }}
                    viewShelf={(count: number) => {
                      this.viewShelf(
                        count,
                        this.state.selectedSection?.y,
                        this.state.selectedSection?.height,
                        this.state.selectedSection?.name
                      )
                    }}
                    viewDividers={(count: number) => {
                      this.viewTempDividers(
                        count,
                        this.state.selectedSection?.y,
                        this.state.selectedSection?.height,
                        this.state.selectedSection?.name
                      )
                    }}
                    removeTempShelves={this.removeTempShelves}
                    removeTempDividers={this.removeTempDividers}
                    addShelvesAsItem={(count: number) => {
                      this.props.setSectionShelves(
                        parseInt(selectedSectionNumber),
                        {
                          count,
                          sectionNumber: parseInt(selectedSectionNumber),
                          sectionHeight,
                          sectionY,
                        }
                      )

                      this.removeTempShelves()
                    }}
                    addTempDividers={this.addTempDividers}
                    deleteShelves={() => {
                      this.props.setSectionShelves(
                        parseInt(selectedSectionNumber)
                      )
                      this.removeTempShelves()
                    }}
                    unhideShelfItems={() => {
                      this.unhideShelfItems(selectedSectionNumber)
                    }}
                    setSectionDoor={(type: DoorType) => {
                      this.props.setSectionDoor(
                        parseInt(selectedSectionNumber),
                        {
                          type,
                          uuid: v4(),
                          sectionNumber: parseInt(selectedSectionNumber),
                          sectionHeight,
                          sectionY,
                          handleProps: doorProps
                            ? {
                                ...doorProps.handleProps,
                                position:
                                  type === 'liftUp'
                                    ? 'bottom'
                                    : doorProps.handleProps.position,
                                positionX:
                                  type === 'liftUp'
                                    ? 'center'
                                    : type === 'left'
                                      ? 'right'
                                      : 'left',
                              }
                            : {
                                ...this.props.handleProps,
                                position:
                                  type === 'liftUp' ? 'bottom' : 'center',
                                positionX:
                                  type === 'liftUp'
                                    ? 'center'
                                    : type === 'left'
                                      ? 'right'
                                      : 'left',
                              },
                          visualType: doorProps
                            ? doorProps.visualType
                            : 'vGroove',
                          normalMapSplitter: doorProps?.normalMapSplitter,
                        }
                      )
                    }}
                    setSectionDoorVisualType={(type: DoorVisualType) => {
                      this.props.setSectionDoor(
                        parseInt(selectedSectionNumber),
                        {
                          type: doorProps ? doorProps.type : 'left',
                          uuid: v4(),
                          sectionNumber: parseInt(selectedSectionNumber),
                          sectionHeight,
                          sectionY,
                          handleProps: doorProps
                            ? doorProps.handleProps
                            : this.props.handleProps,
                          visualType: type,
                        }
                      )
                    }}
                    setSectionDrawerVisualType={(type: DrawerVisualType) => {
                      this.props.setSectionDrawer(
                        parseInt(selectedSectionNumber),
                        {
                          uuid: v4(),
                          sectionNumber: parseInt(selectedSectionNumber),
                          sectionHeight,
                          sectionY,
                          handleProps: drawerProps
                            ? drawerProps.handleProps
                            : {
                                type: 'pull',
                                subtype: 'standard',
                                position: 'forDrawer',
                                positionX: 'center',
                                orientation: 'vertical',
                              },
                          visualType: type,
                        }
                      )
                    }}
                    setSectionDoorSplitters={(value: string) => {
                      this.props.setSectionDoor(
                        parseInt(selectedSectionNumber),
                        {
                          type: doorProps ? doorProps.type : 'left',
                          uuid: v4(),
                          sectionNumber: parseInt(selectedSectionNumber),
                          sectionHeight,
                          sectionY,
                          handleProps: doorProps
                            ? doorProps.handleProps
                            : this.props.handleProps,
                          visualType: doorProps
                            ? doorProps.visualType
                            : this.props.doorVisualType,
                          normalMapSplitter: value,
                        }
                      )
                    }}
                    setSectionDrawer={() => {
                      this.props.setSectionDrawer(
                        parseInt(selectedSectionNumber),
                        {
                          uuid: drawerProps ? drawerProps.uuid : v4(),
                          sectionNumber: parseInt(selectedSectionNumber),
                          sectionHeight,
                          sectionY,
                          handleProps: drawerProps
                            ? drawerProps.handleProps
                            : {
                                type: 'pull',
                                subtype: 'standard',
                                position: 'forDrawer',
                                positionX: 'center',
                                orientation: 'vertical',
                              },
                        }
                      )
                    }}
                    deleteSectionDoor={() => {
                      this.props.setSectionDoor(parseInt(selectedSectionNumber))
                    }}
                    deleteSectionDrawer={() => {
                      this.props.setSectionDrawer(
                        parseInt(selectedSectionNumber)
                      )
                    }}
                    doorProps={doorProps}
                    drawerProps={drawerProps}
                    globalDoorType={this.props.doorType}
                    globalHandlePosition={this.props.handleProps.position}
                    globalDoorVisualType={this.props.doorVisualType}
                    panelVisualType={this.props.panelVisualType}
                    handlePositionFromGroundDefault={
                      this.props.configs.handlePositionFromGround
                    }
                    setSectionDoorHandlePosition={(
                      position: HandlePropsType['position']
                    ) => {
                      console.log(this.props.handleProps, position)
                      this.props.setSectionDoor(
                        parseInt(selectedSectionNumber),
                        {
                          type: doorProps ? doorProps.type : 'left',
                          uuid: doorProps ? doorProps.uuid : v4(),
                          sectionNumber: parseInt(selectedSectionNumber),
                          sectionHeight,
                          sectionY,
                          handleProps: {
                            ...(doorProps
                              ? doorProps.handleProps
                              : this.props.handleProps),
                            position,
                          },
                          visualType: doorProps
                            ? doorProps.visualType
                            : 'vGroove',
                          normalMapSplitter: doorProps?.normalMapSplitter,
                        }
                      )
                    }}
                    setSectionDoorHandlePositionX={(
                      positionX: HandlePropsType['positionX']
                    ) => {
                      this.props.setSectionDoor(
                        parseInt(selectedSectionNumber),
                        {
                          type: doorProps ? doorProps.type : 'left',
                          uuid: doorProps ? doorProps.uuid : v4(),
                          sectionNumber: parseInt(selectedSectionNumber),
                          sectionHeight,
                          sectionY,
                          handleProps: {
                            ...(doorProps
                              ? doorProps.handleProps
                              : this.props.handleProps),
                            positionX,
                          },
                          visualType: doorProps
                            ? doorProps.visualType
                            : 'vGroove',
                          normalMapSplitter: doorProps?.normalMapSplitter,
                        }
                      )
                    }}
                    setSectionDoorHandlePositionFromGroundValue={(
                      value: number | undefined
                    ) => {
                      this.props.setSectionDoor(
                        parseInt(selectedSectionNumber),
                        {
                          type: doorProps ? doorProps.type : 'left',
                          uuid: doorProps ? doorProps.uuid : v4(),
                          sectionNumber: parseInt(selectedSectionNumber),
                          sectionHeight,
                          sectionY,
                          handleProps: {
                            ...(doorProps
                              ? doorProps.handleProps
                              : this.props.handleProps),
                            positionFromGroundValue: value,
                          },
                          visualType: doorProps
                            ? doorProps.visualType
                            : 'vGroove',
                          normalMapSplitter: doorProps?.normalMapSplitter,
                        }
                      )
                    }}
                    setHandleOrientation={(v: HandleOrientationType) => {
                      this.props.setSectionDoor(
                        parseInt(selectedSectionNumber),
                        {
                          type: doorProps ? doorProps.type : 'left',
                          uuid: doorProps ? doorProps.uuid : v4(),
                          sectionNumber: parseInt(selectedSectionNumber),
                          sectionHeight,
                          sectionY,
                          handleProps: {
                            ...(doorProps
                              ? doorProps.handleProps
                              : this.props.handleProps),
                            orientation: v,
                          },
                          visualType: doorProps
                            ? doorProps.visualType
                            : 'vGroove',
                          normalMapSplitter: doorProps?.normalMapSplitter,
                        }
                      )
                    }}
                    setDrawerHandleOrientation={(v: HandleOrientationType) => {
                      this.props.setSectionDrawer(
                        parseInt(selectedSectionNumber),
                        {
                          uuid: v4(),
                          sectionNumber: parseInt(selectedSectionNumber),
                          sectionHeight,
                          sectionY,
                          handleProps: drawerProps
                            ? { ...drawerProps.handleProps, orientation: v }
                            : {
                                type: 'pull',
                                subtype: 'standard',
                                position: 'forDrawer',
                                positionX: 'center',
                                orientation: v,
                              },
                          visualType: drawerProps
                            ? drawerProps.visualType || 'standard'
                            : 'standard',
                        }
                      )
                    }}
                    setDrawerHandlePosition={(
                      position: HandlePropsType['position']
                    ) => {
                      this.props.setSectionDrawer(
                        parseInt(selectedSectionNumber),
                        {
                          uuid: v4(),
                          sectionNumber: parseInt(selectedSectionNumber),
                          sectionHeight,
                          sectionY,
                          handleProps: drawerProps
                            ? { ...drawerProps.handleProps, position }
                            : {
                                type: 'pull',
                                subtype: 'standard',
                                position,
                                orientation: 'horizontal',
                                positionX: 'center',
                              },
                          visualType: drawerProps
                            ? drawerProps.visualType || 'standard'
                            : 'standard',
                        }
                      )
                    }}
                    setDrawerHandlePositionX={(
                      positionX: HandlePropsType['positionX']
                    ) => {
                      this.props.setSectionDrawer(
                        parseInt(selectedSectionNumber),
                        {
                          uuid: v4(),
                          sectionNumber: parseInt(selectedSectionNumber),
                          sectionHeight,
                          sectionY,
                          handleProps: drawerProps
                            ? { ...drawerProps.handleProps, positionX }
                            : {
                                type: 'pull',
                                subtype: 'standard',
                                positionX,
                                orientation: 'horizontal',
                                position: 'forDrawer',
                              },
                          visualType: drawerProps
                            ? drawerProps.visualType || 'standard'
                            : 'standard',
                        }
                      )
                    }}
                  />
                )
              })()}
          </Box>
        </Fade>

        {this.state.selectedSection &&
          this.state.sectionPoses.map((section, i) => (
            <Slide direction="right" in key={section.height + section.name}>
              {this.state.tempSection?.name !== section.name ? (
                // <Box display='flex' alignItems='center'
                //     style={{

                //     }}
                // >
                <SectionHeightInfoWithUnitSupport
                  sx={{
                    position: 'absolute',
                    top: section.top + 36,
                    left: section.left - 100,
                    cursor:
                      this.state.sectionPoses.length !== 1 &&
                      !this.state.sectionLocks[i]?.isLock
                        ? 'pointer'
                        : 'default',
                  }}
                  valueInCm={
                    this.props.viewSectionHeight
                      ? section.height
                      : section.panelHeight
                  }
                  onClick={() => {
                    if (
                      this.state.sectionPoses.length > 1 &&
                      !this.state.sectionLocks[i].isLock
                    )
                      this.setState({
                        tempSection: { ...section },
                      })
                  }}
                />
              ) : (
                // </Box>
                <Box></Box>
              )}
            </Slide>
          ))}

        {/* Section Locks */}
        {this.state.selectedSection &&
          this.state.sectionLocks.map((lock, i) => (
            <Slide direction="right" in key={lock.number}>
              <Box
                display="flex"
                style={{
                  position: 'absolute',
                  top:
                    this.state.tempSection &&
                    this.state.tempSection.name.split('_')[1] ===
                      lock.number.toString()
                      ? this.state.tempSection.top + 20 // + 6
                      : this.selecting.getSectionsPoses(
                          !this.props.isCorner
                            ? this.props.cabinetProps.sectionProps.width
                            : this.props.cornerCabinetProps.sectionProps.width
                        )[i].top +
                        21 +
                        6,
                  left:
                    this.state.tempSection &&
                    this.state.tempSection.name.split('_')[1] ===
                      lock.number.toString()
                      ? this.state.tempSection.left - 150 - 42 * 2
                      : this.selecting.getSectionsPoses(
                          !this.props.isCorner
                            ? this.props.cabinetProps.sectionProps.width
                            : this.props.cornerCabinetProps.sectionProps.width
                        )[i].left -
                        100 -
                        42 * 2,
                }}
              >
                <Radio
                  checked={lock.number === this.state.modifiableSection}
                  onClick={() => {
                    this.setState({
                      modifiableSection:
                        this.state.modifiableSection === lock.number
                          ? -1
                          : lock.number,
                    })
                  }}
                />
                <Checkbox
                  checked={lock.isLock}
                  color="primary"
                  onChange={(e) => {
                    this.setState({
                      sectionLocks: this.state.sectionLocks.map((lock) =>
                        this.state.sectionLocks[i].number === lock.number
                          ? { ...lock, isLock: e.currentTarget.checked }
                          : lock
                      ),
                    })
                  }}
                />
              </Box>
            </Slide>
          ))}

        {/* Temp Section input */}
        {
          this.state.tempSection && (
            <TempSectionHeightInputWithUnitSupport
              sx={{
                position: 'absolute',
                top: this.state.tempSection.top + 20,
                left: this.state.tempSection.left - 150,
              }}
              valueInCm={
                this.props.viewSectionHeight
                  ? this.state.tempSection.height
                  : this.state.tempSection.panelHeight
              }
              onChange={(v) => {
                this.handleTempSectionHeightChange(
                  v,
                  this.props.viewSectionHeight
                )
              }}
              onSubmit={this.handleSectionHeightBlur}
            />
          )
          // <FormControl
          //     variant="outlined"
          //     size='small'
          //     style={{
          //         position: 'absolute',
          //         top: this.state.tempSection.top + 20,
          //         left: this.state.tempSection.left - 150,
          //     }}
          // >
          //     <OutlinedInput
          //         style={{ width: 120 }}
          //         type='number'
          //         value={this.props.viewSectionHeight ? this.state.tempSection.height : this.state.tempSection.panelHeight}
          //         onChange={(e) => { this.handleTempSectionHeightChange(parseFloat(e.target.value), this.props.viewSectionHeight) }}
          //         onKeyUp={(e) => {
          //             handleEnter(
          //                 e,
          //                 this.handleSectionHeightBlur
          //                 // parseFloat((e.target as HTMLInputElement).value)
          //             )
          //         }}
          //         onBlur={(e) => {
          //             this.handleSectionHeightBlur()
          //         }}
          //         onFocus={e => { handleFocus(e) }}
          //         startAdornment={<InputAdornment position="start">cm</InputAdornment>}
          //         inputProps={{ min: 0 }}
          //         autoFocus
          //     // disabled={this.state.tempSectionPosesValues.length === 1}
          //     />
          // </FormControl>
        }

        {/* Divider buttons */}
        {this.state.selectedSection &&
          this.selecting
            .getDividersPoses(
              !this.props.isCorner
                ? this.props.cabinetProps.sectionProps.width
                : this.props.cornerCabinetProps.sectionProps.width
            )
            .map((divider) => (
              <Fragment key={divider.name}>
                <Slide direction="left" in>
                  <Fab
                    style={{
                      position: 'absolute',
                      left: divider.rightPos.left,
                      top: divider.rightPos.top + 35,
                      maxWidth: 25,
                      maxHeight: 25,
                      minWidth: 25,
                      minHeight: 25,
                    }}
                    color="secondary"
                    onClick={() => {
                      this.selecting.setSelectedSection(undefined)
                      this.removeTempDividers()
                      this.removeTempShelves()
                      this.unhideShelfItems('all')
                      this.props.deleteDivider(divider.name)
                    }}
                  >
                    <CloseIcon />
                  </Fab>
                </Slide>
                <Slide direction="right" in>
                  <Checkbox
                    defaultChecked={divider.name[0] === 'v'}
                    style={{
                      position: 'absolute',
                      left: divider.leftPos.left - 30 - 10, //21+9
                      top: divider.leftPos.top + 30 - 3, //21+9
                      // background: 'white'
                    }}
                    color="primary"
                    onChange={(e) => {
                      const newType = e.currentTarget.checked
                        ? 'visible'
                        : 'none'

                      const cabProps = !this.props.isCorner
                        ? this.props.cabinetProps
                        : this.props.cornerCabinetProps

                      const newDividers = clone(
                        cabProps.sectionProps.dividersProps
                      ).sort((a, b) => a.top - b.top)

                      const dNumber = parseInt(divider.name.split('_')[1])

                      newDividers[dNumber - 1].type = newType

                      const newProps = recalculateAllShelvesAndDoorsPositions(
                        newDividers,
                        cabProps.height,
                        cabProps.sectionProps.shelvesProps,
                        cabProps.sectionProps.doorsProps,
                        cabProps.sectionProps.drawersProps,
                        this.props.configs.thickness
                      )

                      this.props.setDividers(newDividers)
                      this.props.setDoors(
                        newProps.doorsProps,
                        'divider to fixed change three'
                      )
                      this.props.setDrawers(newProps.drawersProps)
                      this.props.setShelves(newProps.shelvesProps)
                    }}
                  />
                </Slide>
              </Fragment>
            ))}

        {/* Floating buttons left */}
        <Box style={{ position: 'absolute', left: 0, top: 48, margin: 5 }}>
          {this.props.gcInfo.hash !== '' && (
            <Tooltip title={'Back to GC'}>
              <IconButton color="primary" onClick={this.backToGC}>
                <ArrowBackIcon />
              </IconButton>
            </Tooltip>
          )}
          <Tooltip
            title={
              this.props.isFrontPanelsVisible
                ? 'Hide front panels'
                : 'Show front panels'
            }
          >
            {this.props.isFrontPanelsVisible ? (
              <IconButton
                color="primary"
                onClick={() => {
                  this.props.setIsFrontPanelsVisible(false)
                }}
              >
                <VisibilityIcon />
              </IconButton>
            ) : (
              <IconButton
                onClick={() => {
                  this.props.setIsFrontPanelsVisible(true)
                }}
              >
                <VisibilityOffIcon />
              </IconButton>
            )}
          </Tooltip>

          <Tooltip
            title={
              this.props.viewSectionHeight
                ? 'Switch to Door height mode'
                : 'Switch to Section height mode'
            }
          >
            <Switch
              checked={this.props.viewSectionHeight}
              onChange={(e) => {
                this.props.setViewSectionHeight(e.currentTarget.checked)
              }}
              color="secondary"
            />
          </Tooltip>
          <Tooltip title={'Hide/Show cabinet sheets'}>
            <IconButton
              color="primary"
              onClick={() => {
                for (const child of this.scene.children) {
                  if (
                    [
                      'Right Side',
                      'Left Side',
                      'Top',
                      'Bottom',
                      'Back',
                      'Splitted Top',
                    ].includes(child.name)
                  ) {
                    child.visible = !child.visible
                  }
                }
                this.needRender = true
              }}
            >
              <KitchenIcon />
            </IconButton>
          </Tooltip>
        </Box>

        {/* Floating buttons right */}
        {this.props.user && (
          <Box
            display="flex"
            style={{
              columnGap: 15,
              position: 'absolute',
              right: window.innerWidth * (1 - this.props.myWidth),
              top: 48,
              margin: 17,
            }}
          >
            <Fab color="primary" size="small" onClick={this.onCatalogClick}>
              <GridViewIcon />
            </Fab>
            <Fab color="primary" size="small" onClick={this.onSaveClick}>
              <SaveIcon />
            </Fab>
          </Box>
        )}

        {/* Prices */}
        <Box
          display="flex"
          style={{
            columnGap: 15,
            position: 'absolute',
            right: window.innerWidth * (1 - this.props.myWidth),
            bottom: 0,
            margin: 17,
          }}
        >
          {(() => {
            const clearPrice =
              this.props.items.reduce(
                (sum, current) => sum + parseFloat(current.getClearPrice()),
                0
              ) * (this.props.isDemo ? Math.PI : 1)
            const nonMarkupPrice =
              this.props.items.reduce(
                (sum, current) => sum + parseFloat(current.getNonMarkupPrice()),
                0
              ) * (this.props.isDemo ? Math.PI : 1)
            const price =
              this.props.items.reduce(
                (sum, current) => sum + parseFloat(current.getPrice()),
                0
              ) * (this.props.isDemo ? Math.PI : 1)

            return (
              <Tooltip
                title={this.props.isDemo ? 'Prices are fake for demo user' : ''}
              >
                <Box sx={{ display: 'flex', gap: 2 }}>
                  {((this.props.user && this.props.user.role === 'admin') ||
                    this.props.isDemo) && (
                    <>
                      <Typography
                        style={{
                          fontSize: 20,
                          color: this.props.isDemo ? 'red' : undefined,
                        }}
                      >
                        ${clearPrice.toFixed(appConfig.fractionDigits)}
                      </Typography>
                      <Typography
                        style={{
                          fontSize: 20,
                          color: this.props.isDemo ? 'green' : undefined,
                        }}
                      >
                        $
                        {(
                          nonMarkupPrice +
                          this.props.cabinetAddonD +
                          ((nonMarkupPrice + this.props.cabinetAddonD) *
                            this.props.cabinetAddonP) /
                            100
                        ).toFixed(appConfig.fractionDigits)}
                      </Typography>
                    </>
                  )}
                  <Typography
                    style={{
                      fontSize: 20,
                      color: this.props.isDemo ? 'blue' : undefined,
                    }}
                  >
                    $
                    {(
                      price +
                      this.props.cabinetAddonD +
                      ((price + this.props.cabinetAddonD) *
                        this.props.cabinetAddonP) /
                        100
                    ).toFixed(appConfig.fractionDigits)}
                  </Typography>
                </Box>
              </Tooltip>
            )
          })()}
        </Box>
        <CabinetWeightText items={this.props.items} />

        {/* Mobile Sidebar */}
        <Hidden mdUp>
          {!this.props.isSidebarOpen && (
            <Fab
              color="secondary"
              style={{ position: 'absolute', right: 0, bottom: 0, margin: 15 }}
              onClick={this.onEditClick}
            >
              <EditIcon />
            </Fab>
          )}
        </Hidden>

        {/* Preview viewer */}
        <Dialog open={this.state.isPreviewOpen}>
          <img
            src={localStorage.getItem('sceneImage') || ''}
            alt="screenshot"
          />
        </Dialog>

        <CabinetCatalogDialog
          open={this.state.isCatalogOpen}
          cabinetsList={this.props.userCabinets}
          allCabinetsList={this.props.allCabinets}
          categoriesList={this.props.categoriesList}
          companyEmails={this.props.availableUsersEmails}
          setOpen={(value) => {
            this.setState({ isCatalogOpen: value })
          }}
          loadCabinet={(cab) => {
            this.unselectSection()
            this.props.setActualCabinetTitle(cab.title)
            this.loadCabinet(
              cab.name,
              cab.additional ? JSON.parse(cab.additional) : undefined
            )
          }}
          editCabinet={this.props.editCabinet}
          copyCabinet={(id) => {
            this.props.copyCabinet(id, this.props.enqueueSnackbar)
          }}
          deleteCabinet={(id) => {
            this.props.deleteCabinet(id, this.props.enqueueSnackbar)
          }}
          userCabinetsGridVisibilityModel={
            this.props.userCabinetsGridVisibilityModel
          }
          userCabinetsGridSortModel={this.props.userCabinetsGridSortModel}
          userCabinetsGridFilterModel={this.props.userCabinetsGridFilterModel}
          setUserCabinetsGridVisibilityModel={
            this.props.setUserCabinetsGridVisibilityModel
          }
          setUserCabinetsGridSortModel={this.props.setUserCabinetsGridSortModel}
          setUserCabinetsGridFilterModel={
            this.props.setUserCabinetsGridFilterModel
          }
          shareCabinet={this.props.shareCabinet}
        />
      </>
    )
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(withSnackbar(Three))
